import zhHans from 'vuetify/es5/locale/zh-Hans';
export default {
    ...zhHans,
    setting: {
        language: "จีนตัวย่อ",
        dialogDetermine: "แน่นอน",
        dreivatives: "จัดส่ง",
        markets: "คำคม",
        assets: "สินทรัพย์",
        liquidity: "การทำฟาร์ม",
        helpCentre: "ศูนย์ช่วยเหลือ",
        announcementCenter: "ศูนย์ประกาศ",
        about: "เกี่ยวกับ",
        bulletinCentre: "ศูนย์ประกาศ",
        serviceAgreement: "สัญญาการให้บริการ",
        support: "สนับสนุน",
        onlineSupportCustomerService: "บริการออนไลน์",
        suggestionsAndFeedback: "ข้อเสนอแนะและข้อเสนอแนะ",
        service: "ให้บริการ",
        download: "ดาวน์โหลด",
        coinApplication: "แอปพลิเคชั่นรายการเหรียญ",
        privacyStatement: "คำชี้แจงสิทธิส่วนบุคคล",
        trade: "การซื้อขายตามสัญญา",
        standardConteact: "ที่ยั่งยืน",
        signOut: "ออกจากระบบ",
        assetWallets: "กระเป๋าเงินทรัพย์สิน",
        financeRecords: "บันทึกการเปลี่ยนแปลงบัญชี",
        identification: "การรับรองความถูกต้อง",
        personalCenter: "ศูนย์ส่วนบุคคล",
        chooseLanguage: "เลือกภาษา",
        tips: "คำใบ้",
        dark: "โหมดมืด",
        light: "โหมดวัน",
        languageTitle: "ภาษา",
        convertCurrency: "แปลงสกุลเงิน",
        cancel: "ยกเลิก",
        aboutUs: "เกี่ยวกับเรา",
        standard: "ความต่อเนื่องของมาตรฐาน",
        share: "แบ่งปัน",
        introduce: "บทนำแพลตฟอร์ม",
        set: "ติดตั้ง",
        changePassword: "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
        denomination: "สกุลเงินใบเสนอราคา",
        color: "การกำหนดค่าสี",
        code: "หมายเลขเวอร์ชัน",
        color1: "ขึ้นสีแดงและตกสีเขียว",
        color2: "สีเขียวขึ้นและสีแดงตก",
        setLangue: "การตั้งค่าภาษา",
        vip: "สิทธิประโยชน์วีไอพี",
        vip2: "ระดับวีไอพีในปัจจุบัน",
        safeMenu: "ศูนย์รักษาความปลอดภัย",
        conventional: "ธรรมดา",
        other: "อื่น",
        quickTips: "เพิ่มปุ่มฟังก์ชั่นทางลัดได้สูงสุด 3 ปุ่ม",
        quickTransaction: "การทำธุรกรรมที่รวดเร็ว",
        safeConvenient: "ปลอดภัยและสะดวกสบาย",
        timeSharing: "การแบ่งปันเวลา",
        currentLevel: "ระดับปัจจุบัน",
        levelBenefits: "รายได้ระดับ %{level}",
        teamLevel: "ระดับทีม",
        levelLower: "%{ระดับ}ผู้ใต้บังคับบัญชา",
        rules: "คำอธิบายกฎ",
        bindWithdrawalAddress: "ผูกที่อยู่การถอน",
        tipsBindWithdrawalAddress: "คุณยังไม่ได้ผูกมัดที่อยู่การถอนเงินของคุณ โปรดผูกมัดก่อน",
        walletAddressFormatIncorrect: "รูปแบบที่อยู่ Wallet ไม่ถูกต้อง",
        tradeRules1: "ทำนายการขึ้นและลงในช่วงอนาคต ราคา ณ เวลาสั่งซื้อจะใช้เป็นราคาเริ่มต้น และราคา ณ วินาทีสุดท้ายของระยะเวลาคาดการณ์จะใช้เป็นราคาชำระราคา หากราคาชำระมากกว่าราคาเริ่มต้น หมายความว่าเพิ่มขึ้น และหาก ราคาชำระน้อยกว่าราคาเริ่มต้นก็หมายความว่าลดลง",
        tradeRules2: "1.สัญญาคืออะไร?",
        tradeRules3: "แพลตฟอร์มนี้จัดทำสัญญาถาวรตาม USDT ผู้ใช้สามารถตัดสินการขึ้นหรือลงและเลือกซื้อสัญญาระยะยาวหรือขายระยะสั้นเพื่อรับผลกำไรจากการขึ้น/ลงของราคาสินทรัพย์ดิจิทัล สัญญาไม่จำกัดระยะเวลาไม่มีวันส่งมอบ และผู้ใช้สามารถถือสัญญาไว้ได้ตลอดไป",
        tradeRules4: "2.มาร์จิ้นคืออะไร",
        tradeRules5: "ในตลาดสัญญาเสมือน ผู้ใช้จะต้องจ่ายเงินจำนวนเล็กน้อยในสัดส่วนที่แน่นอนตามราคาของสัญญาเพื่อเป็นหลักประกันทางการเงินสำหรับการปฏิบัติตามสัญญา จากนั้นผู้ใช้สามารถมีส่วนร่วมในการซื้อและขายสัญญาได้ กองทุนประเภทนี้คือการฝากสัญญาเสมือน \nสัญญาบนแพลตฟอร์มนี้ใช้รูปแบบมาร์จิ้นแยกต่างหากของบัญชีที่แยกกัน แต่ละสกุลเงินสอดคล้องกับบัญชีสัญญา สินทรัพย์ในบัญชีและตำแหน่งของสกุลเงินสัญญาที่แตกต่างกันจะเป็นอิสระจากกัน และการโอนและการทำธุรกรรมระหว่างบัญชีสัญญาที่แตกต่างกันจะไม่ส่งผลกระทบต่อกัน หลังจากเปิดบัญชีสัญญาของผู้ใช้แล้ว ความเสี่ยงและผลประโยชน์ของตำแหน่งทั้งหมดที่ถืออยู่ในบัญชีสัญญาจะถูกคำนวณร่วมกัน",
        tradeRules6: "3.วิธีการคำนวณมาร์จิ้น",
        tradeRules7: "อัตรากำไรขั้นต้นของตำแหน่ง = มูลค่าที่ตราไว้ของสัญญา * จำนวนสัญญาที่เปิดอยู่ / ตัวคูณเลเวอเรจ\nอัตรากำไรที่แช่แข็ง = ผลรวมของอัตรากำไรของคำสั่งซื้อขายที่ส่งสำเร็จทั้งหมดและคำสั่งซื้อขายที่เปิดในคำสั่งซื้อปัจจุบัน\อัตรากำไรที่มีอยู่ = ยอดคงเหลือในบัญชี - อัตรากำไรขั้นต้นของสถานะ - อัตรากำไรที่แช่แข็ง",
        tradeRules8: "4.วิธีการคำนวณอัตรามาร์จิ้น",
        tradeRules9: "อัตรามาร์จิ้นเป็นตัววัดความเสี่ยงด้านสินทรัพย์ของผู้ใช้ \nอัตรามาร์จิ้น = (กำไรและขาดทุนที่ยังไม่เกิดขึ้นจริง + อัตรากำไรขั้นต้นของสถานะ + อัตรากำไรขั้นต้นที่มีอยู่ + อัตรากำไรขั้นต้นคงค้าง - ค่าธรรมเนียมการชำระบัญชี) / อัตรากำไรขั้นต้นของสถานะ \nยิ่งอัตราอัตรากำไรขั้นต้นน้อย ความเสี่ยงของบัญชีก็จะยิ่งสูงขึ้น เมื่ออัตรามาร์จิ้นน้อยกว่าหรือเท่ากับ 0% การบังคับชำระบัญชีจะถูกทริกเกอร์",
        tradeRules10: "5.ราคาบังคับความเท่าเทียมกันโดยประมาณคือเท่าไร?",
        tradeRules11: "ราคาบังคับชำระบัญชีโดยประมาณ ได้แก่ ราคาที่คำนวณโดยระบบที่กระตุ้นให้เกิดการบังคับชำระบัญชีในทางทฤษฎี มีไว้เพื่อการอ้างอิงเท่านั้น และอาจเบี่ยงเบนจากมูลค่าจริงเล็กน้อย",
        tradeRules12: "6.มูลค่าสุทธิของบัญชีและกำไรขาดทุนที่ยังไม่เกิดขึ้นจริงคืออะไร?",
        tradeRules13: "ส่วนของบัญชีทั้งหมด = ยอดคงเหลือในบัญชี + กำไรและขาดทุนที่ยังไม่เกิดขึ้น\nกำไรและขาดทุนที่ยังไม่เกิดขึ้นคือกำไรและขาดทุนของตำแหน่งปัจจุบันที่ถือโดยผู้ใช้ในสัญญาสกุลเงิน กำไรและขาดทุนที่ยังไม่เกิดขึ้นจะเปลี่ยนแปลงตามการเปลี่ยนแปลงราคาธุรกรรมล่าสุด \nกำไรและขาดทุนที่ยังไม่รับรู้สำหรับสถานะซื้อ = (1/ราคาสถานะเฉลี่ย - 1/ราคาธุรกรรมล่าสุด) * จำนวนสัญญาสำหรับสถานะซื้อ * มูลค่าที่ตราไว้ของสัญญา * ราคาธุรกรรมล่าสุด \n กำไรและขาดทุนที่ยังไม่เกิดขึ้นสำหรับสถานะขาย = (1/ ราคาซื้อขายล่าสุด - 1/ ราคาสถานะเฉลี่ย) * จำนวนสัญญาสั้น * มูลค่าที่ตราไว้ของสัญญา * ราคาซื้อขายล่าสุด",
        text1: "ความปลอดภัยของบัญชี",
        text2: "โหมดกลางวันและกลางคืน",
        text3: "ล้างแคช",
        text4: "คุณแน่ใจว่าคุณต้องการที่จะออกจากระบบ?",
        text5: "คุณแน่ใจหรือไม่ว่าต้องการล้างแคช？",
        text6: "หลายภาษา",
        text7: "เพื่อปกป้องความปลอดภัยของคุณ เราขอแนะนำให้เปิดการตรวจสอบสิทธิ์แบบสองปัจจัยอย่างน้อยหนึ่งรายการ"
    },
    login: {
        login: "เข้าสู่ระบบ",
        register: "ลงทะเบียน",
        title1: "ซื้อขายได้ทุกที่ทุกเวลาและดูสภาวะตลาดแบบเรียลไทม์",
        title2: "ซื้อขายได้ทุกที่ทุกเวลาและดูสภาวะตลาดแบบเรียลไทม์",
        title3: "แพลตฟอร์มการซื้อขาย Cryptocurrency ที่น่าเชื่อถือที่สุด",
        formTitle1: "ลงชื่อเข้าใช้",
        formTitle2: "ยินดีต้อนรับกลับ! เข้าสู่ระบบด้วยอีเมล หมายเลขโทรศัพท์ของคุณ",
        btn1: "โทรศัพท์มือถือ",
        btn2: "จดหมาย",
        btn3: "เข้าสู่ระบบ",
        btn4: "ลงทะเบียน",
        btn5: "ลืมรหัสผ่าน？",
        field1: "หมายเลขโทรศัพท์",
        field2: "รหัสผ่าน",
        field3: "จดหมาย",
        placeholder1: "ชาติ",
        placeholder2: "กรุณากรอกหมายเลขโทรศัพท์",
        placeholder3: "กรุณากรอกรหัสผ่าน",
        placeholder4: "กรุณากรอกอีเมล์ของคุณ",
        content12: "กรุณากรอกหมายเลขโทรศัพท์",
        content13: "กรุณากรอกรหัสผ่าน",
        content14: "กรุณากรอกอีเมล์ของคุณ",
        content16: "บริการทางการเงินสินทรัพย์ดิจิทัล",
        loginSuccess: "เข้าสู่ระบบสำเร็จ ",
        chooseArea: "กรุณาเลือกรหัสพื้นที่",
        placeholder5: "กรุณาเลือกรหัสประเทศ",
        placeholder6: "จำรหัสผ่านของฉัน",
        placeholder7: "ดาวน์โหลดแอพ",
        placeholder8: "ติดต่อฝ่ายบริการลูกค้า",
        placeholder9: "เลือกประเทศหรือภูมิภาค",
        placeholder10: "รหัสพื้นที่",
        placeholder11: "เข้าสู่ระบบกระเป๋าเงิน",
        placeholder12: "การดำเนินการล้มเหลว โปรดเปลี่ยนไปที่",
        placeholder13: "กระเป๋าสตางค์"
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: "เกี่ยวกับ",
        aboutCoinbeadCenterDetails: "มีแพลตฟอร์มการซื้อขายสินทรัพย์บล็อคเชนชั้นนำของโลกและดำเนินงานระบบนิเวศทั้งหมด",
        footDetails1: "ปริมาณการซื้อขายรายวัน",
        footDetails2: "ธุรกรรม/วินาที",
        footDetails3: "ศูนย์ช่วยเหลือ",
        coinbeadCenterTitle: "",
        coinbeadCenterDetails: "เป็นเว็บไซต์ระดับนานาชาติที่มีชื่อเสียงระดับโลกสำหรับสินทรัพย์ดิจิทัล โดยให้บริการเหรียญและอนุพันธ์ของสินทรัพย์ดิจิทัลเป็นหลัก เช่น Bitcoin (BTC), Litecoin (LTC) และ Ethereum (ETH) แก่ผู้ใช้ทั่วโลก",
        coinbeadCenterDetailsm: "การนำเทคโนโลยีขั้นสูงมาใช้ เช่น GSLB, เซิร์ฟเวอร์เครือข่าย, ธุรกรรมเครือข่าย, เครือข่าย, กลไกการซื้อขายหน่วยความจำความเร็วสูงหลายเครื่อง, กระเป๋าเงินเย็น, กระเป๋าเงินออฟไลน์อัจฉริยะ ฯลฯ เราให้บริการลูกค้าของเราด้วยเทอร์มินัลหลายตัว เช่น เว็บโทรศัพท์มือถือและพีซี . ให้บริการธุรกรรมภาษีดิจิทัลที่ปลอดภัย มั่นคง และเชื่อถือได้ ในเวลาเดียวกัน เราปรับปรุงและอัปเกรดผลิตภัณฑ์และบริการตามคำแนะนำของผู้ใช้และความต้องการเพื่อให้บริการที่ดีขึ้นแก่ลูกค้าทุกราย และการปรับปรุงประสบการณ์ผู้ใช้เชิงนวัตกรรมไม่มีที่สิ้นสุด",
        infrastructureCenterTitle: "โครงสร้างพื้นฐาน",
        infrastructureCenterDetails: "ภารกิจของเราคือการให้บริการโครงสร้างพื้นฐานสำหรับระบบนิเวศบล็อคเชนทั้งหมด",
        freeCenterTitle: "ฟรี",
        freeCenterDetails: "วิสัยทัศน์ของเราคือการทำให้เงินไหลเวียนไปทั่วโลกอย่างอิสระ เราเชื่อว่าการแพร่กระจายเสรีภาพนี้จะทำให้โลกเป็นสถานที่ที่ดีขึ้นได้",
        futureCenterTitle: "ผู้บุกเบิกอนาคตของเทคโนโลยี",
        futureCenterDetails: "เปิดโลกอนาคตแห่งเทคโนโลยี",
    },
    applicationForListing: {
        title: "แอปพลิเคชั่นรายการเหรียญ",
        projectName: "ชื่อโครงการ",
        tokenName: "ชื่อโทเค็น",
        projectDescription: "รายละเอียดโครงการ",
        contractAddress: "ที่อยู่สัญญา",
        officialWebsite: "เว็บไซต์อย่างเป็นทางการ",
        ContactAndEmail: "อีเมล์ติดต่อ",
        ContactAndName: "ชื่อผู้ติดต่อ",
        file: "อัพโหลดไฟล์แนบ",
        pleaseEnter: "กรุณาเข้า",
        enterFile: "กรุณาอัพโหลดไฟล์",
        upload1: "ปัจจุบันจำกัดการเลือกไฟล์ไว้เพียง 1 ไฟล์",
        upload2: "ครั้งนี้ฉันเลือกแล้ว",
        upload3: "ไฟล์，",
        upload4: "เลือกทั้งหมดแล้ว",
        upload5: "ไฟล์",
    },
    public: {
        submit: "ส่ง",
        copySuccessfully: "คัดลอกเรียบร้อยแล้ว",
        copyFailed: "การคัดลอกล้มเหลว",
        noDate: "ไม่มีข้อมูล",
        submitSuccessfully: "ส่งเรียบร้อยแล้ว",
        goBack: "กลับไปที่หน้าสุดท้าย",
        cancel: "ยกเลิก",
        home: "หน้าแรก",
        loading: "กำลังโหลด...",
        confirm: "ยืนยัน",
        loadingFailed: "ความผิดปกติของเครือข่าย",
        nomore: "ไม่มีอีกแล้ว",
        tryAgain: "โปรดรีเฟรชหน้า/ออกจากโปรแกรมแล้วอัปโหลดอีกครั้ง!",
        hot: "พื้นที่ยอดนิยม",
    },
    inviteFriends: {
        inviteFriends: "แบ่งปันกับเพื่อน ๆ",
        freedomOfWealth: "ให้ความมั่งคั่งเป็นอิสระด้วยกัน",
        myInvitationCode: "รหัสเชิญของฉัน",
        clickCopy: "คลิกเพื่อคัดลอก",
        myInvitationLink: "ลิงค์คำเชิญของฉัน",
        clicktoSaveTheQRCode: "คลิกเพื่อบันทึกรหัส QR",
        saveQRCode: "เชิญคิวอาร์โค้ด",
        numberOfSubordinates: "จำนวนผู้ใต้บังคับบัญชา",
        rebateIncome: "รายได้ส่วนลด",
        people: "ประชากร",
        myPromotionRevenue: "รายได้ส่งเสริมการขายของฉัน",
        numberOfDirectSubordinates: "จำนวนผู้ใต้บังคับบัญชาโดยตรง",
        totalNumberOfSubordinates: "จำนวนผู้ใต้บังคับบัญชาทั้งหมด",
        directSubordinateReturnsCommission: "ส่วนลดค่าคอมมิชชันสำหรับผู้ใต้บังคับบัญชาโดยตรง",
        theTotalCommission: "ส่วนลดทั้งหมด",
        checkHistory: "ดูบันทึกส่วนลด",
        history: "บันทึกค่าคอมมิชชั่น",
        theLowerAccount: "บัญชีรอง",
        type: "พิมพ์：",
        serviceCharge: "ค่าธรรมเนียมการจัดการ：",
        percentageofCommissionReturned: "อัตราส่วนเงินคืน：",
        commissionrebateAmount: "จำนวนเงินคืน：",
        time: "เวลา：",
        typeName1: "เติมเงินและคอมมิชชั่น",
        typeName2: "ค่าธรรมเนียมการจัดการคำสั่ง MT การกระจายสามระดับ",
        typeName3: "การกระจายสามระดับที่มีกำไรของ MT",
        typeName4: "รางวัลการแนะนำ",
        typeName30: "เติมเงินและคอมมิชชั่น",
        typeName31: "การคืนเงินกำไรจากการซื้อขายเป็นระยะ",
        typeName32: "การคืนเงินกำไรจากการขุดสภาพคล่อง",
        typeName45: "การคืนเงินค่าธรรมเนียมการทำธุรกรรม",
        typeName46: "ส่วนลดค่าคอมมิชชันสำหรับค่าธรรมเนียมการจัดการของตัวเอง",
        typeName50: "การคืนเงินค่าธรรมเนียมการจัดการสัญญาการจัดส่ง",
        typeName51: "การคืนเงินค่าธรรมเนียมการจัดการสัญญาแบบไม่จำกัดระยะเวลา",
        typeName52: "การคืนเงินค่าคอมมิชชั่นเพิ่มเติมสำหรับค่าธรรมเนียมการจัดการสัญญาการจัดส่ง",
        typeName53: "การคืนเงินค่าคอมมิชชันเพิ่มเติมสำหรับค่าธรรมเนียมการจัดการสัญญาแบบไม่จำกัดระยะเวลา",
        typeName54: "ส่วนลดเพิ่มเติมสำหรับค่าธรรมเนียมการจัดการสัญญาแบบไม่จำกัดระยะเวลา",
        shareRules1: "คำแนะนำการเชิญชวน",
        shareRules2: "เข้าสู่ศูนย์คำเชิญ คัดลอกลิงก์หรือรหัสคำเชิญ และแบ่งปันกับเพื่อนของคุณ เพื่อนสามารถเป็นผู้ใต้บังคับบัญชาของคุณได้โดยการลงทะเบียนด้วยรหัสเชิญของคุณ",
        shareRules3: "รับส่วนลด",
        shareRules4: "เมื่อผู้ใต้บังคับบัญชาทำธุรกรรม คุณจะได้รับค่าคอมมิชชั่นที่เกี่ยวข้อง โดยรองรับผู้ใต้บังคับบัญชาสูงสุดสามระดับ ตัวอย่างเช่น หากคุณเชิญเพื่อน A, A เชิญ B และ B เชิญ C จากนั้น A, B และ C จะทำสัญญาและธุรกรรมอื่น ๆ บนแพลตฟอร์ม และคุณจะได้รับค่าคอมมิชชั่นที่เกี่ยวข้องกันทั้งหมด",
        shareRules5: "ระดับทีม",
        shareRules6: "ยิ่งคุณเลื่อนตำแหน่งผู้ใต้บังคับบัญชาระดับแรกมากเท่าไร ระดับทีมก็จะยิ่งสูงขึ้น และคุณจะได้รับเงินคืนมากขึ้นเท่านั้น ระดับทีมแบ่งออกเป็น LV1-LV6 กฎการอัปเกรดจะแสดงอยู่ในตารางด้านล่าง โดยที่ 'N' คือจำนวนผู้ใต้บังคับบัญชาระดับแรกที่ได้ชาร์จและยืนยันตัวตนด้วยชื่อจริงเรียบร้อยแล้ว",
        shareRules7: "เมื่อผู้ใต้บังคับบัญชาวางเดิมพันตามสัญญาการส่งมอบ คุณสามารถรับค่าคอมมิชชั่นตามสัดส่วนการเดิมพันของพวกเขา",
        upgradeConditions: "จำเป็นต้อง",
        recommendedNumberOfPeople: "จำนวนคนที่แนะนำ"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: "ข้อเสนอแนะและข้อเสนอแนะ",
        text: "หากคุณพบจุดบกพร่องหรือมีข้อเสนอแนะผลิตภัณฑ์ระหว่างการใช้งาน โปรดให้ข้อเสนอแนะแก่เรา",
        email: "ที่อยู่อีเมล",
        enterEmail: "กรุณากรอกอีเมล์",
        enterCorrectEmail: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
        title: "ชื่อ",
        enterTitle: "กรุณากรอกหัวข้อคำถาม",
        describeTheProblem: "อธิบายปัญหา",
        enterDescribeTheProblem: "กรุณากรอกปัญหาที่คุณอธิบาย",
        submit: "ส่ง",
    },
    help: {
        enterSearch: "ค้นหา",
        title: "ศูนย์ช่วยเหลือ",
        search: "กรุณากรอกคำถามของคุณ",
        text1: "เข้าใจความต้องการของคุณและให้บริการที่สะดวกสบายยิ่งขึ้นแก่คุณต่อไป"
    },
    announcement: {
        enterSearch: "ค้นหา",
        title: "ศูนย์ประกาศ",
        search: "กรุณากรอกคำถามของคุณ"
    },
    privacy: {
        title: "คำชี้แจงความเป็นส่วนตัว",
        content1: "1. ข้อมูลส่วนบุคคลใดของผู้ใช้ที่ถูกรวบรวม？",
        content2: "ข้อมูลส่วนบุคคลจะถูกรวบรวมเพื่อจัดหาผลิตภัณฑ์และบริการและเพื่อปรับปรุงอย่างต่อเนื่อง。",
        content3: "ต่อไปนี้คือประเภทของข้อมูลส่วนบุคคลที่เรารวบรวม：",
        content4: 'ข้อมูลที่คุณให้กับเรา: เราได้รับและจัดเก็บข้อมูลใด ๆ ที่คุณให้ไว้เกี่ยวกับแพลตฟอร์ม คุณสามารถเลือกที่จะไม่ให้ข้อมูลบางอย่างได้ แต่คุณอาจไม่สามารถใช้ "บริการแพลตฟอร์มนี้" บางอย่างได้ ตัวอย่างข้อมูลที่คุณให้กับเรา ได้แก่:',
        content5: "ชื่อ",
        content6: "ที่อยู่",
        content7: "ประเทศที่คุณถือสัญชาติอยู่",
        content8: "รูปถ่ายประจำตัว",
        content9: "หมายเลขโทรศัพท์มือถือ/หมายเลขอีเมล",
        content10: "ข้อมูลอื่น ๆ ที่ช่วยให้เราระบุตัวคุณได้",
        content11: "ข้อมูลที่รวบรวมโดยอัตโนมัติ: เรารวบรวมและจัดเก็บข้อมูลบางประเภทเกี่ยวกับการใช้บริการแพลตฟอร์มของคุณโดยอัตโนมัติ เช่นเดียวกับเว็บไซต์อื่นๆ เราใช้คุกกี้และตัวระบุที่ไม่ซ้ำกันอื่นๆ เราได้รับข้อมูลบางประเภทเมื่อเว็บเบราว์เซอร์หรืออุปกรณ์ของคุณเข้าถึงแพลตฟอร์ม ตัวอย่างข้อมูลที่เรารวบรวมและวิเคราะห์ ได้แก่:",
        content12: "ที่อยู่อินเทอร์เน็ตโปรโตคอล (IP) ที่เชื่อมต่อคอมพิวเตอร์ส่วนบุคคลกับอินเทอร์เน็ต",
        content13: "ข้อมูลการเข้าสู่ระบบ ที่อยู่อีเมล รหัสผ่าน และตำแหน่งของอุปกรณ์ส่วนตัวหรือคอมพิวเตอร์",
        content14: "การตั้งค่าเวอร์ชันและโซนเวลา",
        content15: "ประวัติการทำรายการ.",
        content16: "ข้อมูลจากแหล่งอื่น: เราอาจรวบรวมข้อมูลเกี่ยวกับคุณจากแหล่งอื่น เช่น ประวัติเครดิตจากสำนักงานเครดิต เราจะใช้ข้อมูลนี้เพื่อป้องกันและตรวจจับการฉ้อโกง",
        content17: "2. เด็กใช้ได้ไหม?",
        content18: 'แพลตฟอร์มนี้ไม่อนุญาตให้บุคคลที่มีอายุต่ำกว่า 18 ปีใช้ "บริการ"',
        content19: "3. คุกกี้และตัวระบุอื่น ๆ ใช้ทำอะไร?",
        content20: "เราใช้คุกกี้และเครื่องมือที่คล้ายกันเพื่อเพิ่มประสิทธิภาพประสบการณ์ผู้ใช้ ให้บริการของเรา และทำความเข้าใจวิธีที่ลูกค้าใช้บริการของเรา เพื่อให้เราสามารถปรับปรุงตามเป้าหมายได้ เราใช้คุกกี้เพื่อให้แน่ใจว่าระบบของเราสามารถจดจำเบราว์เซอร์หรืออุปกรณ์ของคุณและให้บริการแก่คุณได้",
        content21: 'เราใช้คุกกี้การดำเนินงานและเครื่องมือที่คล้ายกัน (เรียกรวมกันว่า "คุกกี้") เพื่อให้บริการต่างๆ เช่น:',
        content22: "ระบุตัวคุณเมื่อคุณเข้าสู่ระบบและใช้บริการของเรา。",
        content23: "นำเสนอคุณสมบัติและบริการที่ปรับแต่งเอง。",
        content24: "ป้องกันการฉ้อโกงกิจกรรม。",
        content25: "ปรับปรุงความปลอดภัย。",
        content26: "ติดตามการตั้งค่าของคุณ (เช่นสกุลเงินและภาษา)",
        content27: "นอกจากนี้เรายังใช้คุกกี้เพื่อทำความเข้าใจว่าผู้ใช้ใช้บริการของเราอย่างไร เพื่อให้เราสามารถปรับปรุงตามเป้าหมายได้",
        content28: "4. ข้อมูลส่วนบุคคลของฉันจะถูกแบ่งปันหรือไม่?",
        content29: "ข้อมูลผู้ใช้เป็นส่วนสำคัญของธุรกิจของเรา และเราจะไม่ขายข้อมูลส่วนบุคคลของผู้ใช้ให้กับผู้อื่น แพลตฟอร์มนี้จะแบ่งปันข้อมูลส่วนบุคคลของผู้ใช้กับบริษัทสาขาหรือบริษัทในเครือภายใต้สถานการณ์ต่อไปนี้เท่านั้น บริษัทสาขาหรือบริษัทในเครือเหล่านี้จะต้องปฏิบัติตามคำชี้แจงความเป็นส่วนตัวนี้หรืออย่างน้อยก็ปฏิบัติตามแนวทางปฏิบัติที่ได้รับการคุ้มครองเช่นเดียวกับมาตรการป้องกันที่อธิบายไว้ในคำชี้แจงความเป็นส่วนตัวนี้",
        content30: "ผู้ให้บริการบุคคลที่สาม: เราจ้างบริษัทและบุคคลอื่นเพื่อทำหน้าที่ในนามของเรา ตัวอย่างของฟังก์ชันดังกล่าว ได้แก่ การวิเคราะห์ข้อมูล การให้ความช่วยเหลือทางการตลาด การประมวลผลการชำระเงิน การส่งเนื้อหา และการประเมินและจัดการความเสี่ยงด้านเครดิต ผู้ให้บริการบุคคลที่สามเหล่านี้สามารถเข้าถึงข้อมูลส่วนบุคคลที่จำเป็นในการปฏิบัติหน้าที่ แต่ไม่สามารถใช้ข้อมูลดังกล่าวเพื่อวัตถุประสงค์อื่นใดได้ นอกจากนี้ พวกเขาจะต้องประมวลผลข้อมูลส่วนบุคคลตามคำชี้แจงความเป็นส่วนตัวนี้และกฎหมายคุ้มครองข้อมูลที่บังคับใช้",
        content31: "การโอนธุรกิจ: เนื่องจากธุรกิจของเราเติบโตอย่างต่อเนื่อง เราอาจขายหรือซื้อธุรกิจหรือบริการอื่น ๆ ในการทำธุรกรรมดังกล่าว ข้อมูลผู้ใช้โดยทั่วไปจะเป็นหนึ่งในทรัพย์สินทางธุรกิจที่ถ่ายโอน แต่ยังคงอยู่ภายใต้สัญญาในคำชี้แจงสิทธิ์ส่วนบุคคลที่มีอยู่ก่อน (เว้นแต่ผู้ใช้จะตกลงเป็นอย่างอื่น) นอกจากนี้ หากบริษัทของเราหรือทรัพย์สินส่วนใหญ่ของบริษัทถูกได้มา ข้อมูลผู้ใช้ก็จะถูกถ่ายโอนเช่นกัน การคุ้มครองบริษัทของเราและอื่นๆ: เมื่อเราเชื่อว่าการเปิดเผยบัญชีและข้อมูลส่วนบุคคลอื่น ๆ มีความเหมาะสมที่จะปฏิบัติตามกฎหมายหรือภาระผูกพันด้านกฎระเบียบของเรา บังคับใช้หรือใช้ข้อกำหนดการใช้งานและข้อตกลงอื่น ๆ ของเรา หรือสิทธิ์ ทรัพย์สิน หรือความปลอดภัยของเรา ผู้ใช้หรือผู้อื่น เมื่อใดเราจะเปิดเผยบัญชีและข้อมูลส่วนบุคคลอื่น ๆ รวมถึงการแลกเปลี่ยนข้อมูลกับบริษัทและองค์กรอื่นๆ เพื่อป้องกันการฉ้อโกงและลดความเสี่ยงด้านเครดิต",
        content32: "5. การถ่ายโอนข้อมูลส่วนบุคคลระหว่างประเทศ",
        content33: 'เราอาจถ่ายโอนข้อมูลของคุณนอกเขตเศรษฐกิจยุโรป ("EEA") เราจะใช้มาตรการป้องกันที่เหมาะสมเพื่อให้แน่ใจว่าการถ่ายโอนดังกล่าวเป็นไปตามกฎการปกป้องข้อมูลที่เกี่ยวข้อง เว้นแต่คณะกรรมาธิการยุโรปจะยืนยันว่าประเทศที่ข้อมูลถูกถ่ายโอนนั้นมีระดับการป้องกันที่เพียงพอ',
        content34: "6. ข้อมูลส่วนตัวของฉันปลอดภัยหรือไม่?",
        content35: "เราออกแบบระบบของเราโดยคำนึงถึงความปลอดภัยและความเป็นส่วนตัวของคุณ เราใช้โปรโตคอลการเข้ารหัสและซอฟต์แวร์เพื่อปกป้องความปลอดภัยของข้อมูลส่วนบุคคลระหว่างการส่ง",
        content36: "เรานำมาตรการป้องกันทางกายภาพ อิเล็กทรอนิกส์ และขั้นตอนมาใช้เสมอเมื่อรวบรวม จัดเก็บ และเปิดเผยข้อมูลส่วนบุคคล ขั้นตอนการรักษาความปลอดภัยของเราหมายความว่าเราอาจจำเป็นต้องยืนยันตัวตนของคุณก่อนที่จะเปิดเผยข้อมูลส่วนบุคคลให้กับคุณ",
        content37: "สิ่งสำคัญที่สุดที่คุณสามารถทำได้คือปกป้องรหัสผ่านบัญชีส่วนตัวของคุณจากการเข้าถึงโดยไม่ได้รับอนุญาต เราขอแนะนำให้ตั้งรหัสผ่านเฉพาะสำหรับบัญชีของคุณซึ่งแตกต่างจากบัญชีออนไลน์อื่นๆ และอย่าลืมออกจากระบบหลังจากใช้คอมพิวเตอร์ที่ใช้ร่วมกัน",
        content38: "7. ฉันจะปกป้องข้อมูลส่วนบุคคลได้อย่างไร?",
        content39: "หากคุณมีคำถามหรือข้อโต้แย้งเกี่ยวกับวิธีที่เรารวบรวมและประมวลผลข้อมูลส่วนบุคคล โปรดติดต่อเจ้าหน้าที่บริการลูกค้า",
        content40: "หลังจากที่คุณยินยอมให้เราประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์เฉพาะ คุณสามารถเพิกถอนความตั้งใจของคุณได้ตลอดเวลา และเราจะหยุดการประมวลผลข้อมูลของคุณเพื่อวัตถุประสงค์นั้น",
        content41: "นอกจากนี้ คุณมีสิทธิ์ร้องขอการเข้าถึง แก้ไข และลบข้อมูลส่วนบุคคล และขอการเคลื่อนย้ายข้อมูล ภายใต้กฎหมายที่บังคับใช้ คุณยังสามารถคัดค้านการประมวลผลข้อมูลส่วนบุคคลของคุณของเรา หรือขอให้เราจำกัดการประมวลผลข้อมูลส่วนบุคคลของคุณในบางสถานการณ์",
        content42: "8. EU GDPR และกฎหมายคุ้มครองข้อมูลของสหราชอาณาจักร - พื้นฐานทางกฎหมาย",
        content43: "กฎหมายคุ้มครองข้อมูล EU GDPR และสหราชอาณาจักรกำหนดให้เราต้องปฏิบัติตามพื้นฐานทางกฎหมายเมื่อใช้ข้อมูลส่วนบุคคล พื้นฐานของเราขึ้นอยู่กับวัตถุประสงค์เฉพาะในการใช้ข้อมูลส่วนบุคคล ฐานเหล่านี้รวมถึง:",
        content44: "การปฏิบัติตามสัญญา - เพื่อจัดหาหรือสื่อสารกับคุณเกี่ยวกับผลิตภัณฑ์หรือบริการ รวมถึงการใช้ข้อมูลส่วนบุคคลของคุณเพื่อยอมรับและประมวลผลคำสั่งซื้อและดำเนินการชำระเงิน",
        content45: "ผลประโยชน์ทางธุรกิจที่ชอบด้วยกฎหมายและผลประโยชน์ของผู้ใช้ - เราตรวจจับและป้องกันการฉ้อโกงและการละเมิดเพื่อปกป้องความปลอดภัยของผู้ใช้ของเรา ตัวเราเอง หรือผู้อื่น",
        content46: "ความยินยอมของคุณ – เราต้องการความยินยอมจากคุณในการประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์เฉพาะที่สื่อสารกับคุณ เมื่อคุณให้ความยินยอมแก่เราในการประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์เฉพาะ คุณสามารถเพิกถอนความยินยอมของคุณได้ตลอดเวลา และเราจะหยุดการประมวลผลข้อมูลของคุณเพื่อวัตถุประสงค์นั้น",
        content47: "ปฏิบัติตามภาระผูกพันทางกฎหมาย - เราใช้ข้อมูลส่วนบุคคลของคุณตามที่กฎหมายกำหนด ตัวอย่างเช่น เรารวบรวมข้อมูลบัญชีธนาคารเพื่อวัตถุประสงค์ในการยืนยันตัวตน",
        content48: "พื้นฐานทางกฎหมายข้างต้นและพื้นฐานอื่น ๆ ขึ้นอยู่กับวัตถุประสงค์เฉพาะที่เราใช้ข้อมูลส่วนบุคคล",
        content49: "9. เงื่อนไขการใช้งาน ประกาศ และการแก้ไข",
        content50: "การใช้งานของคุณและข้อพิพาทเกี่ยวกับความเป็นส่วนตัวอยู่ภายใต้คำชี้แจงนี้และข้อกำหนดการใช้งานของเรา หากคุณมีข้อสงสัยเกี่ยวกับความเป็นส่วนตัวของแพลตฟอร์มนี้ โปรดติดต่อเราพร้อมคำอธิบายโดยละเอียด เรายินดีที่จะแก้ไขปัญหาให้กับคุณ คุณมีสิทธิ์ติดต่อหน่วยงานคุ้มครองข้อมูลในพื้นที่ของคุณ",
        content51: "ธุรกิจของเรามีการเปลี่ยนแปลงอยู่ตลอดเวลา และคำชี้แจงสิทธิ์ส่วนบุคคลของเราจะเปลี่ยนแปลงเช่นกัน คุณควรตรวจสอบเว็บไซต์ของเราเป็นประจำเพื่อดูการเปลี่ยนแปลงล่าสุด หากคุณไม่เห็นด้วยกับเนื้อหาที่แก้ไขคุณควรหยุดการเข้าถึงทันที หลังจากเผยแพร่นโยบายความเป็นส่วนตัวเวอร์ชันอัปเดตแล้ว การเข้าถึงอย่างต่อเนื่องของคุณหมายความว่าคุณเห็นด้วยกับเนื้อหาที่อัปเดต และตกลงที่จะปฏิบัติตามนโยบายความเป็นส่วนตัวที่อัปเดต นโยบายความเป็นส่วนตัวปัจจุบันใช้กับข้อมูลทั้งหมดที่เราเก็บไว้เกี่ยวกับคุณและบัญชีของคุณ เว้นแต่จะระบุไว้เป็นอย่างอื่น",
    },
    serviceAgreement: {
        title: "สัญญาการให้บริการ",
        content1: 'เว็บไซต์นี้เป็นแพลตฟอร์มเฉพาะสำหรับผู้ใช้ในการทำธุรกรรมสินทรัพย์ดิจิทัลและให้บริการที่เกี่ยวข้อง (ต่อไปนี้จะเรียกว่า "บริการ" หรือ "บริการ") เพื่อความสะดวกในการอธิบายข้อตกลงนี้ เว็บไซต์นี้รวมคำว่า "เรา" หรือคำสรรพนามบุรุษที่ 1 อื่นๆ ในข้อตกลงนี้ ตราบใดที่บุคคลธรรมดาหรือหัวข้ออื่นๆ ที่เข้าสู่ระบบเว็บไซต์ยังเป็นผู้ใช้เว็บไซต์นี้ เพื่อความสะดวกในการแสดงข้อตกลงนี้ "คุณ" หรือบุคคลอื่นจะถูกนำมาใช้ด้านล่าง เพื่อความสะดวกในการแสดงข้อตกลงนี้ เราและคุณจะถูกเรียกรวมกันว่า "คู่สัญญา" ในข้อตกลงนี้ และเราหรือคุณจะถูกเรียกเป็นรายบุคคลว่า "คู่สัญญา"',
        content2: "คำใบ้ที่สำคัญ：",
        content3: "เราอยากจะเตือนคุณที่นี่：",
        content4: "1 สินทรัพย์ดิจิทัลนั้นไม่ได้ออกโดยสถาบันการเงินหรือบริษัทใด ๆ หรือเว็บไซต์นี้",
        content5: "2 ตลาดสินทรัพย์ดิจิทัลเป็นตลาดใหม่ ยังไม่ได้รับการยืนยัน และอาจไม่เติบโต",
        content6: "3 สินทรัพย์ดิจิทัลส่วนใหญ่ถูกใช้อย่างหนักโดยนักเก็งกำไร โดยมีการใช้งานค่อนข้างน้อยในตลาดค้าปลีกและการค้า ธุรกรรมสินทรัพย์ดิจิทัลมีความเสี่ยงอย่างยิ่ง มีการซื้อขายอย่างต่อเนื่องตลอดทั้งวันโดยไม่มีขีดจำกัดการขึ้นและลง และราคาได้รับผลกระทบจากตลาดได้ง่าย ผู้ผลิตและนโยบายของรัฐบาลทั่วโลก ความผันผวน;",
        content7: "4  บริษัทขอสงวนสิทธิ์ในการระงับหรือยกเลิกบัญชีของคุณได้ตลอดเวลา หากบริษัทพิจารณาตามดุลยพินิจของบริษัทแต่เพียงผู้เดียวว่าคุณได้ละเมิดข้อตกลงนี้ หรือบริการที่เว็บไซต์นี้มอบให้หรือการใช้บริการของคุณที่เว็บไซต์นี้มีให้ ผิดกฎหมายภายใต้กฎหมายในเขตอำนาจศาลของคุณ หรือระงับหรือยุติการใช้บริการหรือธุรกรรมสินทรัพย์ดิจิทัลที่จัดทำโดยเว็บไซต์นี้ ห้ามมิให้บุคคลใดก็ตามจาก [จีนแผ่นดินใหญ่ ไต้หวัน อิสราเอล อิรัก บังคลาเทศ โบลิเวีย เอกวาดอร์ คีร์กีซสถาน เซวาสโตโพล และสหราชอาณาจักร (ผู้ใช้รายย่อย)] ใช้บริการธุรกรรมตามสัญญาที่จัดทำโดยเว็บไซต์นี้ รายชื่อประเทศหรือภูมิภาคที่กล่าวมาข้างต้นจะเปลี่ยนแปลงขึ้นอยู่กับนโยบายและประเภทผลิตภัณฑ์ของประเทศหรือภูมิภาคต่างๆ เราอาจไม่แจ้งให้คุณทราบเป็นการเฉพาะในขณะนั้น ดังนั้น โปรดใส่ใจกับการอัปเดตข้อตกลงนี้อย่างทันท่วงที",
        content8: "การซื้อขายสินทรัพย์ดิจิทัลมีความเสี่ยงสูงมากและไม่เหมาะสำหรับคนส่วนใหญ่ คุณเข้าใจและเข้าใจว่าธุรกรรมนี้อาจส่งผลให้เกิดการสูญเสียบางส่วนหรือทั้งหมด ดังนั้นคุณควรกำหนดจำนวนเงินของธุรกรรมตามระดับการสูญเสียที่คุณสามารถจ่ายได้ คุณทราบและเข้าใจว่าสินทรัพย์ดิจิทัลจะก่อให้เกิดความเสี่ยงด้านอนุพันธ์ ดังนั้นหากคุณมีคำถามใดๆ ขอแนะนำให้ขอความช่วยเหลือจากที่ปรึกษามืออาชีพก่อน นอกจากนี้ นอกจากความเสี่ยงที่กล่าวมาข้างต้นแล้ว ยังมีความเสี่ยงที่ไม่สามารถคาดเดาได้อีกด้วย คุณควรพิจารณาอย่างรอบคอบและใช้วิจารณญาณที่ชัดเจนในการประเมินสถานการณ์ทางการเงินของคุณและความเสี่ยงที่กล่าวมาข้างต้นก่อนที่จะตัดสินใจซื้อหรือขายสินทรัพย์ดิจิทัลและรับผลขาดทุนที่เกิดขึ้นทั้งหมด เราไม่รับผิดชอบต่อสิ่งนี้",
        content9: "คำเตือนสำหรับคุณ：",
        content10: "1 คุณเข้าใจว่าเว็บไซต์นี้ใช้เป็นสถานที่สำหรับรับข้อมูลสินทรัพย์ดิจิทัล ค้นหาฝ่ายธุรกรรม เจรจาและดำเนินธุรกรรมเกี่ยวกับสินทรัพย์ดิจิทัลเท่านั้น เว็บไซต์นี้ไม่มีส่วนร่วมในธุรกรรมใด ๆ ของคุณ ดังนั้น คุณควรใช้วิจารณญาณอย่างรอบคอบ เพื่อกำหนดสินทรัพย์ดิจิทัลและ/หรือธุรกรรมที่เกี่ยวข้อง หรือความถูกต้อง ความถูกต้องตามกฎหมาย และความถูกต้องของข้อมูล และจะต้องรับภาระความรับผิดชอบและความสูญเสียที่เกิดขึ้นด้วยตัวมันเอง",
        content11: "2 ความคิดเห็น ข่าวสาร การอภิปราย การวิเคราะห์ ราคา คำแนะนำ และข้อมูลอื่น ๆ บนเว็บไซต์นี้ถือเป็นความคิดเห็นทั่วไปของตลาดและไม่ถือเป็นคำแนะนำในการลงทุน เราจะไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นโดยตรงหรือโดยอ้อมจากการพึ่งพาข้อมูลนี้ รวมถึงแต่ไม่จำกัดเพียงการสูญเสียผลกำไร",
        content12: "3 เว็บไซต์นี้ขอสงวนสิทธิ์ในการตัดสินใจ แก้ไข หรือเปลี่ยนแปลงเนื้อหาได้ตลอดเวลา เราได้ใช้มาตรการที่เหมาะสมเพื่อรับรองความถูกต้องของข้อมูลบนเว็บไซต์ แต่เราไม่สามารถรับประกันความถูกต้องได้ และเราจะไม่รับผิดชอบต่อ ความสูญเสียหรือความเสียหายใด ๆ ที่เกิดจากข้อมูลบนเว็บไซต์นี้หรือการขาดข้อมูลความสูญเสียทั้งทางตรงและทางอ้อมที่เกิดจากความล่าช้าหรือความล้มเหลวในการเชื่อมโยงอินเทอร์เน็ตการส่งหรือรับประกาศและข้อมูลใด ๆ",
        content13: "4 นอกจากนี้ยังมีความเสี่ยงในการใช้ระบบการซื้อขายบนอินเทอร์เน็ต ซึ่งรวมถึงแต่ไม่จำกัดเพียงซอฟต์แวร์ ฮาร์ดแวร์ และความล้มเหลวในการเชื่อมต่ออินเทอร์เน็ต เนื่องจากเราไม่สามารถควบคุมความน่าเชื่อถือและความพร้อมใช้งานของอินเทอร์เน็ตได้ เราจึงไม่รับผิดชอบต่อการบิดเบือน ความล่าช้า และความล้มเหลวในการเชื่อมต่อ",
        content14: "5 ห้ามมิให้ใช้เว็บไซต์นี้เพื่อมีส่วนร่วมในกิจกรรมการค้าที่ผิดกฎหมายหรือกิจกรรมที่ผิดกฎหมายทั้งหมด เช่น การฟอกเงิน การลักลอบขนของ การให้สินบนในเชิงพาณิชย์ เป็นต้น หากพบธุรกรรมที่น่าสงสัยหรือกิจกรรมที่ผิดกฎหมาย เว็บไซต์นี้จะใช้วิธีการต่างๆ ที่มี รวมถึงแต่ ไม่ จำกัด เพียงการระงับบัญชีและแจ้งให้ฝ่ายที่เกี่ยวข้องทราบ เจ้าหน้าที่ ฯลฯ เราไม่รับผิดชอบทั้งหมดที่เกิดขึ้นและขอสงวนสิทธิ์ในการติดตามความรับผิดจากบุคคลที่เกี่ยวข้อง",
        content15: "6 ห้ามมิให้ใช้เว็บไซต์นี้เพื่อบิดเบือนตลาด การทำธุรกรรมที่ไม่เหมาะสมและกิจกรรมการซื้อขายที่ผิดจรรยาบรรณอื่น ๆ หากพบเหตุการณ์ดังกล่าว เว็บไซต์นี้จะเตือน จำกัดการทำธุรกรรม และปิดพฤติกรรมที่ผิดจรรยาบรรณทั้งหมด เช่น การจัดการราคาที่เป็นอันตรายและอิทธิพลที่เป็นอันตรายต่อ ระบบการซื้อขาย เราไม่รับผิดชอบทั้งหมดที่เกิดขึ้นจากมาตรการป้องกันเชิงป้องกัน เช่น การระงับบัญชี และขอสงวนสิทธิ์ในการติดตามความรับผิดจากบุคคลที่เกี่ยวข้อง",
        content16: "1. หลักการทั่วไป",
        content17: '1.1 "ข้อตกลงผู้ใช้" (ต่อไปนี้จะเรียกว่า "ข้อตกลงนี้" หรือ "ข้อกำหนดและเงื่อนไขเหล่านี้") ประกอบด้วยข้อความหลัก "ข้อกำหนดความเป็นส่วนตัว" "รู้จักลูกค้าของคุณ และนโยบายต่อต้านการฟอกเงิน" และนโยบายอื่น ๆ มากมายที่มี ได้รับการเผยแพร่หรืออาจจะเผยแพร่ในอนาคตบนเว็บไซต์นี้ กฎของชั้นเรียน ข้อความ คำอธิบาย ฯลฯ',
        content18: "1.2 คุณควรอ่านข้อตกลงนี้อย่างละเอียดก่อนใช้บริการของเว็บไซต์นี้ หากคุณไม่เข้าใจสิ่งใด ๆ หรือหากจำเป็น โปรดปรึกษาทนายความมืออาชีพ หากคุณไม่เห็นด้วยกับข้อตกลงนี้และ/หรือการแก้ไขข้อตกลงนี้ในเวลาใดก็ตาม โปรดหยุดใช้บริการที่เว็บไซต์นี้จัดให้ทันที หรือไม่ลงชื่อเข้าใช้เว็บไซต์นี้อีกต่อไป เมื่อคุณเข้าสู่ระบบเว็บไซต์นี้ ใช้บริการใด ๆ ของเว็บไซต์นี้หรือพฤติกรรมอื่นที่คล้ายคลึงกัน หมายความว่าคุณได้เข้าใจและยอมรับเนื้อหาของข้อตกลงนี้โดยสมบูรณ์ รวมถึงการแก้ไขใด ๆ ที่ทำโดยเว็บไซต์นี้ต่อข้อตกลงนี้เมื่อใดก็ได้",
        content19: '1.3 คุณสามารถเป็นสมาชิกของเว็บไซต์นี้ (ต่อไปนี้เรียกว่า "สมาชิก") โดยการกรอกข้อมูลที่เกี่ยวข้องตามข้อกำหนดของเว็บไซต์นี้และลงทะเบียนให้สำเร็จหลังจากขั้นตอนที่เกี่ยวข้องอื่น ๆ โดยคลิกปุ่ม "ตกลง" ในระหว่างการลงทะเบียน คุณลงนามทางอิเล็กทรอนิกส์ แบบฟอร์มข้อตกลงกับบริษัท หรือ เมื่อคุณคลิกที่ปุ่มใด ๆ ที่ระบุว่า "ตกลง" หรือความหมายที่คล้ายกันระหว่างการใช้งานเว็บไซต์นี้ หรือใช้บริการจริง ๆ ของเว็บไซต์นี้ ในรูปแบบอื่น ๆ ที่ได้รับอนุญาตจากเว็บไซต์นี้ หมายความว่าคุณเข้าใจ ตกลง และยอมรับข้อกำหนดทั้งหมดภายใต้ข้อตกลงนี้โดยสมบูรณ์ การไม่มีลายเซ็นที่เขียนด้วยลายมือของคุณจะไม่ส่งผลกระทบต่อผลผูกพันทางกฎหมายของข้อตกลงนี้กับคุณ',
        content20: "1.4 หลังจากเป็นสมาชิกของเว็บไซต์นี้แล้ว คุณจะได้รับบัญชีสมาชิกและรหัสผ่านที่เกี่ยวข้อง คุณมีหน้าที่รับผิดชอบในการรักษาบัญชีสมาชิกและรหัสผ่าน คุณจะต้องรับผิดชอบตามกฎหมายต่อกิจกรรมและกิจกรรมทั้งหมดที่ดำเนินการภายใต้บัญชีของคุณ",
        content21: "1.5 เฉพาะสมาชิกที่เป็นสมาชิกของเว็บไซต์นี้เท่านั้นที่สามารถใช้แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลที่จัดทำโดยเว็บไซต์นี้สำหรับการทำธุรกรรมและเพลิดเพลินกับบริการอื่น ๆ ที่กำหนดโดยเว็บไซต์นี้ซึ่งมีให้สำหรับสมาชิกเท่านั้น ผู้ที่ไม่ใช่สมาชิกสามารถเข้าสู่ระบบเว็บไซต์เท่านั้นเรียกดูเว็บไซต์ และบริการอื่น ๆ ที่กำหนดโดยเว็บไซต์นี้ บริการ",
        content22: "1.6 โดยการลงทะเบียนและใช้บริการและฟังก์ชั่นใด ๆ ที่ให้บริการโดยเว็บไซต์นี้ คุณจะถือว่าคุณได้อ่าน ทำความเข้าใจ และ:",
        content23: "1.6.1 ยอมรับที่จะผูกพันตามข้อกำหนดและเงื่อนไขทั้งหมดของข้อตกลงนี้",
        content24: "1.6.2 คุณยืนยันว่าคุณอายุเกิน 18 ปีหรือมีอายุตามกฎหมายในการทำสัญญาตามกฎหมายที่บังคับใช้ต่างๆ การลงทะเบียนของคุณบนเว็บไซต์นี้ การขายหรือการซื้อ การเผยแพร่ข้อมูล ฯลฯ และการยอมรับบริการของเว็บไซต์นี้ควรเป็นไปตามข้อกำหนด เป็นไปตามข้อกำหนดของคุณ มีเขตอำนาจเหนือกฎหมายและข้อบังคับที่เกี่ยวข้องของประเทศหรือภูมิภาคอธิปไตย และมีความสามารถอย่างเต็มที่ในการยอมรับข้อกำหนดเหล่านี้ ทำธุรกรรม และใช้เว็บไซต์นี้เพื่อทำธุรกรรมสินทรัพย์ดิจิทัล",
        content25: "1.6.3 คุณรับประกันว่าสินทรัพย์ดิจิทัลทั้งหมดที่เป็นของคุณที่เกี่ยวข้องกับการทำธุรกรรมนั้นได้มาอย่างถูกกฎหมายและมีกรรมสิทธิ์",
        content26: "1.6.4 คุณยอมรับว่าคุณเป็นผู้รับผิดชอบแต่เพียงผู้เดียวสำหรับกิจกรรมการซื้อขายหรือไม่ซื้อขายของคุณเอง และต่อผลกำไรหรือขาดทุนใดๆ",
        content27: "1.6.5 คุณยืนยันว่าข้อมูลที่คุณให้เมื่อลงทะเบียนเป็นความจริงและถูกต้อง",
        content28: "1.6.6 คุณตกลงที่จะปฏิบัติตามข้อกำหนดของกฎหมายที่เกี่ยวข้อง รวมถึงการรายงานผลกำไรจากการซื้อขายเพื่อวัตถุประสงค์ด้านภาษี",
        content29: "1.6.7 คุณตกลงที่จะไม่มีส่วนร่วมหรือมีส่วนร่วมในการกระทำหรือกิจกรรมที่เป็นอันตรายต่อผลประโยชน์ของเว็บไซต์นี้หรือบริษัทได้ตลอดเวลา ไม่ว่าจะเกี่ยวข้องกับบริการของเว็บไซต์นี้หรือไม่ก็ตาม",
        content30: "1.6.8 ข้อตกลงนี้ควบคุมเฉพาะสิทธิ์และภาระผูกพันระหว่างคุณกับเราเท่านั้น และไม่เกี่ยวข้องกับความสัมพันธ์ทางกฎหมายและข้อพิพาททางกฎหมายที่เกิดจากธุรกรรมสินทรัพย์ดิจิทัลระหว่างผู้ใช้เว็บไซต์นี้และเว็บไซต์อื่น ๆ และคุณ",
        content31: "2. การแก้ไขข้อตกลง",
        content32: "เราขอสงวนสิทธิ์ในการแก้ไขข้อตกลงนี้เป็นครั้งคราวและประกาศบนเว็บไซต์โดยไม่ต้องแจ้งให้คุณทราบแยกต่างหาก หลังจากการแก้ไข เวลาแก้ไขจะถูกทำเครื่องหมายไว้ที่ [เวลาอัปเดตล่าสุด] ที่แสดงในข้อตกลงนี้ และจะใช้เวลาแก้ไขโดยอัตโนมัติ มีผลเมื่อมีการเผยแพร่บนเว็บไซต์ คุณควรเรียกดูและใส่ใจกับเวลาอัปเดตและเนื้อหาที่อัปเดตของข้อตกลงนี้เป็นครั้งคราว หากคุณไม่เห็นด้วยกับการเปลี่ยนแปลงที่เกี่ยวข้อง คุณควรหยุดใช้บริการของเว็บไซต์นี้ทันที การใช้บริการของเว็บไซต์นี้ต่อไป เว็บไซต์ หมายถึง ท่านยอมรับและตกลงที่จะผูกพันตามข้อตกลงฉบับแก้ไข .",
        content33: "3. การลงทะเบียน",
        content34: "3.1 คุณสมบัติการลงทะเบียน",
        content35: "คุณยืนยันและสัญญาว่าเมื่อคุณเสร็จสิ้นขั้นตอนการลงทะเบียนหรือใช้บริการของเว็บไซต์นี้ในวิธีอื่นที่เว็บไซต์นี้อนุญาต คุณควรจะสามารถลงนามข้อตกลงนี้และใช้บริการของเว็บไซต์นี้ตามที่กำหนดโดยกฎหมายที่บังคับใช้ บุคคลธรรมดา นิติบุคคล หรือองค์กรอื่น เมื่อคุณคลิกปุ่มตกลงที่จะลงทะเบียน หมายความว่าคุณหรือตัวแทนที่ได้รับอนุญาตของคุณได้ยอมรับเนื้อหาของข้อตกลง และได้รับการลงทะเบียนและใช้บริการของเว็บไซต์นี้โดยตัวแทนของเขา หากคุณไม่มีคุณสมบัติตามหัวข้อข้างต้น คุณและตัวแทนที่ได้รับอนุญาตของคุณจะต้องรับผลที่ตามมาทั้งหมด และบริษัทขอสงวนสิทธิ์ในการยกเลิกหรือระงับบัญชีของคุณอย่างถาวร และให้คุณและตัวแทนที่ได้รับอนุญาตของคุณจะต้องรับผิดชอบ",
        content36: "3.2 วัตถุประสงค์ในการลงทะเบียน",
        content37: "คุณยืนยันและสัญญาว่าการลงทะเบียนของคุณบนเว็บไซต์นี้ไม่ได้มีวัตถุประสงค์เพื่อละเมิดกฎหมายและข้อบังคับหรือขัดขวางลำดับการทำธุรกรรมสินทรัพย์ดิจิทัลบนเว็บไซต์นี้",
        content38: "3.3ขั้นตอนการลงทะเบียน",
        content39: "3.3.1 คุณตกลงที่จะให้ที่อยู่อีเมล หมายเลขโทรศัพท์มือถือ และข้อมูลอื่น ๆ ที่ถูกต้องตามที่กำหนดในหน้าลงทะเบียนผู้ใช้ของเว็บไซต์นี้ คุณสามารถใช้ที่อยู่อีเมล หมายเลขโทรศัพท์มือถือที่คุณให้หรือยืนยัน หรือวิธีการอื่น ๆ ที่อนุญาตโดยเว็บไซต์นี้ในการเข้าสู่ระบบ วิธีการเข้าสู่เว็บไซต์นี้ หากจำเป็น ตามกฎหมายและข้อบังคับที่เกี่ยวข้องของเขตอำนาจศาลที่แตกต่างกัน คุณต้องระบุชื่อจริง เอกสารประจำตัว และข้อมูลที่เกี่ยวข้องอื่น ๆ ที่กำหนดไว้ในกฎหมายและข้อบังคับ ข้อความเป็นส่วนตัว และข้อต่อต้านการฟอกเงิน และอัปเดตข้อมูลการลงทะเบียนอย่างต่อเนื่องใน ได้อย่างทันท่วงที มีรายละเอียด และถูกต้องแม่นยำ ต้องการ ข้อมูลที่พิมพ์ไว้แต่แรกทั้งหมดจะถูกอ้างอิงเป็นข้อมูลการลงทะเบียน คุณต้องรับผิดชอบต่อความถูกต้อง ความสมบูรณ์ และความถูกต้องของข้อมูลดังกล่าว และจะต้องรับผิดชอบต่อความสูญเสียและผลที่ตามมาไม่ว่าโดยตรงหรือโดยอ้อมใด ๆ ที่เกิดขึ้นจากข้อมูลดังกล่าว",
        content40: "3.3.2 หากกฎหมาย ข้อบังคับ กฎ คำสั่ง และข้อบังคับอื่นๆ ของประเทศหรือภูมิภาคที่คุณอาศัยอยู่มีข้อกำหนดชื่อจริงสำหรับหมายเลขโทรศัพท์มือถือ คุณยอมรับว่าหมายเลขโทรศัพท์มือถือที่ลงทะเบียนไว้นั้นได้รับการลงทะเบียนภายใต้ชื่อจริง หาก คุณไม่ระบุไว้ตามข้อบังคับ ผลที่ตามมาใด ๆ ที่เกิดขึ้นกับคุณจะเป็นการสูญเสียโดยตรงหรือโดยอ้อมและผลที่ตามมาจะต้องรับผิดชอบเอง",
        content41: "3.3.3 หากคุณให้ข้อมูลที่จำเป็นสำหรับการลงทะเบียนอย่างถูกต้องตามกฎหมาย ครบถ้วน และมีประสิทธิภาพ และได้ตรวจสอบแล้ว คุณมีสิทธิ์ได้รับหมายเลขบัญชีและรหัสผ่านของเว็บไซต์นี้ เมื่อคุณได้รับหมายเลขบัญชีและรหัสผ่านของเว็บไซต์นี้ การลงทะเบียนของคุณจะถือว่า สำเร็จและคุณสามารถเข้าสู่ระบบในฐานะสมาชิกบนเว็บไซต์นี้ได้",
        content42: "3.3.4 คุณตกลงที่จะรับอีเมลและ/หรือข้อความสั้นที่ส่งจากเว็บไซต์นี้ที่เกี่ยวข้องกับการจัดการและการดำเนินงานของเว็บไซต์นี้",
        content43: "4. บริการ",
        content44: "เว็บไซต์นี้ให้บริการแพลตฟอร์มการซื้อขายออนไลน์สำหรับกิจกรรมการซื้อขายสินทรัพย์ดิจิทัลของคุณเท่านั้น (รวมถึงแต่ไม่จำกัดเพียงการซื้อขายสินทรัพย์ดิจิทัลและบริการอื่น ๆ) ผ่านทางเว็บไซต์นี้",
        content45: "4.1 เนื้อหาการบริการ",
        content46: "4.1.1 คุณมีสิทธิ์เรียกดูสภาวะตลาดและข้อมูลธุรกรรมแบบเรียลไทม์ของผลิตภัณฑ์สินทรัพย์ดิจิทัลต่างๆ บนเว็บไซต์นี้ และคุณมีสิทธิ์ส่งคำแนะนำในการทำธุรกรรมสินทรัพย์ดิจิทัลและทำธุรกรรมสินทรัพย์ดิจิทัลให้เสร็จสิ้นผ่านเว็บไซต์นี้",
        content47: "4.1.2 คุณมีสิทธิ์ดูข้อมูลภายใต้บัญชีสมาชิกของคุณบนเว็บไซต์นี้ และใช้ฟังก์ชันต่างๆ ที่ได้รับจากเว็บไซต์นี้เพื่อดำเนินการ",
        content48: "4.1.3 คุณมีสิทธิ์เข้าร่วมกิจกรรมเว็บไซต์ที่จัดโดยเว็บไซต์นี้ตามกฎกิจกรรมที่เผยแพร่บนเว็บไซต์นี้。",
        content49: "4.1.4 บริการอื่นๆ ที่เว็บไซต์นี้สัญญาว่าจะมอบให้แก่คุณ。",
        content50: "4.2 กฎการบริการ คุณสัญญาว่าจะปฏิบัติตามกฎการบริการต่อไปนี้ของเว็บไซต์นี้:",
        content51: "4.2.1 คุณจะต้องปฏิบัติตามกฎหมาย ข้อบังคับ และข้อกำหนดของนโยบาย ตรวจสอบความถูกต้องตามกฎหมายของแหล่งที่มาของสินทรัพย์ดิจิทัลทั้งหมดในบัญชีของคุณ และจะไม่มีส่วนร่วมในกิจกรรมที่ผิดกฎหมายหรืออื่น ๆ ที่เป็นอันตรายต่อสิทธิ์และผลประโยชน์ของเว็บไซต์นี้หรือบุคคลที่สามบนเว็บไซต์นี้ หรือโดยการใช้บริการ รวมถึงแต่ไม่จำกัดเพียง: คุณไม่จํากัดเพียงการส่งหรือรับข้อมูลที่ผิดกฎหมาย ผิดกฎหมาย หรือละเมิดสิทธิของผู้อื่น การส่งหรือรับแผนปิรามิดหรือข้อมูลหรือหมายเหตุที่เป็นอันตรายอื่น ๆ การใช้หรือการปลอมแปลงอีเมล ข้อมูลส่วนหัวบนเว็บไซต์นี้โดยไม่ได้รับอนุญาตจากเว็บไซต์นี้ ฯลฯ",
        content52: "4.2.2 คุณควรปฏิบัติตามกฎหมายและข้อบังคับ และใช้และรักษาหมายเลขบัญชี รหัสผ่านเข้าสู่ระบบ รหัสผ่านกองทุน หมายเลขโทรศัพท์มือถือที่ผูกไว้กับคุณเมื่อลงทะเบียน และรหัสยืนยันโทรศัพท์มือถือที่ได้รับจากโทรศัพท์มือถือของคุณอย่างเหมาะสม คุณต้องรับผิดชอบอย่างเต็มที่ต่อการดำเนินการและผลที่ตามมาของการใช้บัญชีและรหัสผ่านเข้าสู่ระบบ รหัสผ่านกองทุน และรหัสยืนยันโทรศัพท์มือถือ เมื่อคุณพบว่าหมายเลขบัญชี รหัสผ่านเข้าสู่ระบบ รหัสผ่านกองทุน หรือรหัสยืนยันของเว็บไซต์นี้ถูกใช้โดยบุคคลที่สามโดยไม่ได้รับอนุญาตจากคุณ หรือมีปัญหาด้านความปลอดภัยของบัญชีอื่น ๆ คุณควรแจ้งเว็บไซต์นี้ทันทีและมีประสิทธิภาพและขอให้เว็บไซต์นี้ระงับ บริการของบัญชีของเว็บไซต์นี้ . เว็บไซต์นี้มีสิทธิ์ที่จะดำเนินการตามคำขอของคุณภายในระยะเวลาอันสมควร แต่เว็บไซต์นี้ไม่รับผิดชอบต่อผลที่ตามมา (รวมถึงแต่ไม่จำกัดเพียงความสูญเสียที่คุณได้รับ) ที่เกิดขึ้นก่อนดำเนินการ คุณไม่สามารถบริจาค ยืม ให้เช่า โอนหรือจำหน่ายบัญชีเว็บไซต์ของคุณให้กับผู้อื่นโดยไม่ได้รับความยินยอมจากเว็บไซต์นี้",
        content53: "4.2.3 คุณตกลงที่จะรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้บัญชีและรหัสผ่านของคุณบนเว็บไซต์นี้ (รวมถึงแต่ไม่จำกัดเพียงการเปิดเผยข้อมูล การโพสต์ข้อมูล การคลิกออนไลน์เพื่อตกลงหรือส่งกฎและข้อตกลงต่างๆ การต่ออายุข้อตกลงออนไลน์หรือการซื้อ บริการ ฯลฯ)",
        content54: "4.2.4 เมื่อทำธุรกรรมสินทรัพย์ดิจิทัลบนเว็บไซต์นี้ คุณต้องไม่แทรกแซงความคืบหน้าปกติของธุรกรรมสินทรัพย์ดิจิทัลหรือขัดขวางลำดับการทำธุรกรรมอย่างมุ่งร้าย คุณต้องไม่แทรกแซงการทำงานปกติของเว็บไซต์นี้ หรือแทรกแซงการใช้งานเว็บไซต์นี้ของผู้ใช้รายอื่น บริการด้วยวิธีการทางเทคนิคหรือวิธีการอื่น ๆ คุณต้องไม่ใช้สิ่งที่สมมติขึ้นเพื่อทำลายชื่อเสียงของเว็บไซต์นี้ผ่านข้อเท็จจริงและวิธีการอื่น ๆ",
        content55: "4.2.5 หากคุณมีข้อพิพาทกับผู้ใช้รายอื่นเนื่องจากการทำธุรกรรมออนไลน์ คุณไม่สามารถขอให้เว็บไซต์นี้ให้ข้อมูลที่เกี่ยวข้องผ่านช่องทางที่ไม่ใช่กระบวนการยุติธรรมหรือการบริหาร",
        content56: "4.2.6 คุณจะต้องตัดสินและรับผิดชอบภาษีใด ๆ ที่ต้องชำระ เช่นเดียวกับฮาร์ดแวร์ ซอฟต์แวร์ บริการ และค่าใช้จ่ายอื่น ๆ ทั้งหมดที่เกิดขึ้นระหว่างการใช้บริการของเว็บไซต์นี้",
        content57: "4.2.7 คุณจะต้องปฏิบัติตามข้อตกลงนี้ตลอดจนข้อกำหนดการบริการและกฎการดำเนินงานอื่น ๆ ที่เผยแพร่และอัปเดตโดยเว็บไซต์นี้เป็นครั้งคราว และมีสิทธิ์ที่จะยกเลิกการใช้บริการที่เว็บไซต์นี้มอบให้ได้ตลอดเวลา",
        content58: "4.3 กฎผลิตภัณฑ์",
        content59: "4.3.1 เรียกดูข้อมูลการทำธุรกรรม",
        content60: "เมื่อคุณเรียกดูข้อมูลธุรกรรมบนเว็บไซต์นี้ คุณควรอ่านเนื้อหาทั้งหมดที่มีอยู่ในข้อมูลธุรกรรมอย่างละเอียด รวมถึงแต่ไม่จำกัดเพียงราคา ปริมาณค่าคอมมิชชั่น ค่าธรรมเนียมการจัดการ ทิศทางการซื้อหรือการขาย และเฉพาะหลังจากที่คุณยอมรับเนื้อหาทั้งหมดที่มีอยู่โดยสมบูรณ์แล้วเท่านั้น ในข้อมูลธุรกรรม การซื้อขายสามารถทำได้ด้วยการคลิกเพียงปุ่มเดียว",
        content61: "4.3.2 ดูรายละเอียดการทำธุรกรรม",
        content62: "คุณสามารถดูบันทึกธุรกรรมที่เกี่ยวข้องผ่านบัญชีของคุณ。",
        content63: "5. สิทธิและภาระผูกพันของเว็บไซต์นี้",
        content64: "5.1 หากคุณไม่มีคุณสมบัติการลงทะเบียนตามที่กำหนดไว้ในข้อตกลงนี้ เว็บไซต์นี้มีสิทธิ์ที่จะปฏิเสธการลงทะเบียนของคุณ สำหรับผู้ที่ลงทะเบียนแล้ว เว็บไซต์นี้มีสิทธิ์ที่จะยกเลิกบัญชีสมาชิกของคุณ เว็บไซต์นี้ขอสงวนสิทธิ์ในการถือครองคุณหรือ ตัวแทนที่ได้รับอนุญาตของคุณรับผิดชอบ ถูกต้อง ในเวลาเดียวกัน เว็บไซต์นี้ขอสงวนสิทธิ์ในการตัดสินใจว่าจะยอมรับการลงทะเบียนของคุณภายใต้สถานการณ์อื่นใดหรือไม่",
        content65: "5.2 ตามวิจารณญาณของเว็บไซต์นี้ หากเว็บไซต์นี้พบว่าคุณหรือผู้ใช้บัญชีที่เกี่ยวข้องของคุณไม่เหมาะสำหรับการลงทุนที่มีความเสี่ยงสูง เรามีสิทธิ์ที่จะระงับหรือยกเลิกบัญชีของคุณและการใช้งานบัญชีที่เกี่ยวข้องทั้งหมด",
        content66: "5.3 เมื่อเว็บไซต์นี้พบว่าผู้ใช้บัญชีไม่ใช่ผู้ลงทะเบียนบัญชีครั้งแรก ก็มีสิทธิ์ระงับหรือยุติการใช้บัญชีได้",
        content67: "5.4 เมื่อเว็บไซต์นี้สงสัยตามสมควรว่าข้อมูลที่คุณให้นั้นผิด ไม่จริง ไม่ถูกต้องหรือไม่สมบูรณ์ผ่านการทดสอบทางเทคนิค การสุ่มตัวอย่างด้วยตนเอง และวิธีการทดสอบอื่น ๆ ก็มีสิทธิ์แจ้งให้คุณทราบให้แก้ไขหรืออัปเดตข้อมูล หรือระงับหรือยุติข้อกำหนดของ เว็บไซต์นี้ให้บริการแก่คุณ",
        content68: "5.5 เว็บไซต์นี้ขอสงวนสิทธิ์ในการแก้ไขข้อมูลใด ๆ ที่แสดงบนเว็บไซต์นี้หากพบว่ามีข้อผิดพลาดที่ชัดเจน",
        content69: "5.6 เว็บไซต์นี้ขอสงวนสิทธิ์ในการแก้ไข ระงับ หรือยุติบริการของเว็บไซต์นี้ได้ตลอดเวลา เว็บไซต์นี้ไม่จำเป็นต้องแจ้งให้คุณทราบล่วงหน้าเพื่อใช้สิทธิ์ในการแก้ไขหรือยุติบริการ หากเว็บไซต์นี้ยุติบริการหนึ่งหรือหลายบริการนี้ การยกเลิกจะมาจากเว็บไซต์นี้ บนเว็บไซต์ มีผลใช้บังคับ ณ วันที่ประกาศเลิกประกาศ",
        content70: "5.7 เว็บไซต์นี้จะใช้วิธีการทางเทคนิคและมาตรการการจัดการที่จำเป็นเพื่อให้แน่ใจว่าเว็บไซต์นี้ทำงานได้ตามปกติ จัดให้มีสภาพแวดล้อมการซื้อขายและบริการการซื้อขายที่จำเป็นและเชื่อถือได้ และรักษาลำดับการทำธุรกรรมของสินทรัพย์ดิจิทัล",
        content71: "5.8 หากคุณไม่ได้เข้าสู่ระบบเว็บไซต์นี้โดยใช้บัญชีสมาชิกและรหัสผ่านของคุณเป็นเวลาหนึ่งปีติดต่อกัน เว็บไซต์นี้มีสิทธิ์ที่จะยกเลิกบัญชีของคุณ หลังจากที่บัญชีถูกยกเลิก เว็บไซต์นี้มีสิทธิ์เปิดชื่อสมาชิกที่เกี่ยวข้องให้กับผู้ใช้รายอื่นเพื่อลงทะเบียนและใช้งาน",
        content72: "5.9 เว็บไซต์นี้รับประกันความปลอดภัยของสินทรัพย์ดิจิทัลของคุณโดยเสริมสร้างการลงทุนด้านเทคโนโลยี ปรับปรุงข้อควรระวังด้านความปลอดภัยและมาตรการอื่น ๆ และจะแจ้งให้คุณทราบล่วงหน้าเมื่อมีความเสี่ยงด้านความปลอดภัยที่คาดการณ์ได้เกิดขึ้นในบัญชีของคุณ",
        content73: "5.10 เว็บไซต์นี้มีสิทธิ์ในการลบข้อมูลเนื้อหาทุกประเภทบนเว็บไซต์นี้ที่ไม่สอดคล้องกับกฎหมายและข้อบังคับหรือข้อบังคับของเว็บไซต์นี้ได้ตลอดเวลา เว็บไซต์นี้ไม่จำเป็นต้องแจ้งให้คุณทราบล่วงหน้าเพื่อใช้สิทธิ์ดังกล่าว",
        content74: "5.11 เว็บไซต์นี้มีสิทธิ์ขอให้คุณให้ข้อมูลหรือเนื้อหาเพิ่มเติมตามกฎหมาย ข้อบังคับ กฎ คำสั่ง และข้อกำหนดด้านกฎระเบียบอื่น ๆ ของประเทศอธิปไตยหรือภูมิภาคของคุณและเพื่อใช้มาตรการที่เหมาะสมเพื่อให้สอดคล้องกับข้อกำหนดด้านกฎระเบียบในท้องถิ่น คุณ เรา มีหน้าที่ให้ความร่วมมือ เว็บไซต์นี้มีสิทธิ์ที่จะระงับหรือหยุดเปิดบริการบางส่วนหรือทั้งหมดของเว็บไซต์นี้แก่คุณอย่างถาวรตามข้อกำหนดของกฎหมาย ข้อบังคับ กฎ คำสั่ง และข้อกำหนดอื่น ๆ ของประเทศหรือภูมิภาคอธิปไตยของคุณ",
        content75: "5.12 เว็บไซต์นี้ขอสงวนสิทธิ์ในการปิดบัญชีของคุณโดยแจ้งให้ทราบล่วงหน้าเจ็ดวันทำการตามดุลยพินิจของตนแต่เพียงผู้เดียว ดังนั้น คุณมีเวลาเจ็ดวันทำการในการยกเลิกคำสั่งซื้อและปิดสถานะ หากคุณไม่ได้ยกเลิกคำสั่งซื้อและปิดสถานะเมื่อพ้นระยะเวลา เราจะบังคับยกเลิกคำสั่งซื้อและปิดสถานะและคืนสินทรัพย์ดิจิทัลที่เหลืออยู่ในบัญชีของคุณให้กับคุณ",
        content76: "5.13 เพื่อปกป้องสิทธิและผลประโยชน์ของเทรดเดอร์ เว็บไซต์นี้มีสิทธิ์ในการปรับเปลี่ยนผลิตภัณฑ์ออนไลน์ภายใต้สถานการณ์พิเศษ (เช่น ระบบล้มเหลว เครือข่ายล้มเหลว สภาวะตลาดที่รุนแรง ฯลฯ) เช่น: สัญญาสำหรับการจัดส่งก่อนกำหนดและ การชำระบัญชี ประเภทของสัญญา และสัญญาสำหรับการจัดส่งก่อนกำหนดและการชำระบัญชี ระยะเวลา และการชำระราคา และราคาการส่งมอบจะขึ้นอยู่กับประกาศบนเว็บไซต์นี้",
        content77: "6. ค่าตอบแทน",
        content78: "6.1 ไม่ว่าในกรณีใด ความรับผิดของเราต่อคุณสำหรับความเสียหายโดยตรงจะเกินกว่าค่าบริการทั้งหมดที่เราเรียกเก็บจากคุณสำหรับการใช้งานเว็บไซต์นี้เป็นระยะเวลาสาม (3) เดือน",
        content79: "6.2 หากคุณละเมิดข้อตกลงนี้หรือกฎหมายและข้อบังคับอื่น ๆ คุณต้องชดเชยให้เราอย่างน้อย 2 ล้านดอลลาร์สหรัฐและรับผิดชอบค่าใช้จ่ายทั้งหมดที่เกิดขึ้น (รวมถึงค่าทนายความ ฯลฯ) หากไม่เพียงพอที่จะชดเชยความสูญเสียที่เกิดขึ้นจริง คุณจะต้อง ขึ้นอยู่กับมัน",
        content80: "7. สิทธิในการขอคำสั่งห้าม",
        content81: "เราและคุณทั้งสองรับทราบว่าการเยียวยาตามกฎหมายทั่วไปสำหรับการละเมิดสัญญาของคุณหรือการผิดสัญญาที่อาจเกิดขึ้นอาจไม่เพียงพอที่จะชดเชยความสูญเสียทั้งหมดที่เราได้รับ ดังนั้นเราจึงมีสิทธิ์ที่จะขอคำสั่งห้ามตามที่ได้รับอนุญาตโดยกฎหมายทั่วไปหรือความเป็นธรรมใน เหตุการณ์ที่คุณละเมิดสัญญาหรือการละเมิดสัญญาที่เป็นไปได้ การเยียวยาอื่น ๆ ทั้งหมด",
        content82: "8. ข้อจำกัดความรับผิดและข้อจำกัดความรับผิดชอบ",
        content83: "8.1 คุณเข้าใจและยอมรับว่าไม่ว่าในกรณีใด ๆ เราจะไม่รับผิดชอบต่อเรื่องต่อไปนี้:",
        content84: "8.1.1 การสูญเสียรายได้；",
        content85: "8.1.2 กำไรจากการซื้อขายหรือการสูญเสียสัญญา；",
        content86: "8.1.3 ความสูญเสียที่เกิดจากการหยุดชะงักทางธุรกิจ；",
        content87: "8.1.4 การสูญเสียเงินออมที่คาดหวัง；",
        content88: "8.1.5 การสูญเสียที่เกิดจากปัญหาข้อมูล；",
        content89: "8.1.6 การสูญเสียโอกาส ค่าความนิยม หรือชื่อเสียง",
        content90: "8.1.7 การทุจริตหรือการสูญหายของข้อมูล；",
        content91: "8.1.8 ต้นทุนการซื้อสินค้าหรือบริการทดแทน；",
        content92: "8.1.9 การสูญเสียหรือความเสียหายทางอ้อม พิเศษ หรือโดยบังเอิญใดๆ ที่เกิดขึ้นจากการละเมิด (รวมถึงความประมาทเลินเล่อ) การฝ่าฝืนสัญญา หรือเหตุผลอื่นใด ไม่ว่าการสูญเสียหรือความเสียหายดังกล่าวจะสามารถคาดการณ์ได้ตามสมควรหรือไม่ ไม่ว่าเราได้รับแจ้งถึงการมีอยู่ของสิ่งนั้นหรือไม่ก็ตาม ความเป็นไปได้ของการสูญเสียหรือความเสียหายล่วงหน้า",
        content93: "8.1.1 บทความใน 8.1.9 มีความเป็นอิสระจากกัน",
        content94: "8.2 คุณเข้าใจและยอมรับว่าเราจะไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นกับคุณเนื่องจากสถานการณ์ใด ๆ ต่อไปนี้:",
        content95: "8.2.1 ธุรกรรมเฉพาะของคุณอาจเกี่ยวข้องกับการละเมิดกฎหมายที่สำคัญหรือการละเมิดสัญญา",
        content96: "8.2.2 พฤติกรรมของคุณบนเว็บไซต์นี้ถูกสงสัยว่าผิดกฎหมายหรือผิดศีลธรรม。",
        content97: "8.2.3 ต้นทุนและความสูญเสียที่เกิดขึ้นจากการซื้อหรือรับข้อมูลใด ๆ หรือการทำธุรกรรมผ่านบริการของเว็บไซต์นี้หรือโดยการดำเนินการทดแทน",
        content98: "8.2.4 ความเข้าใจผิดของคุณเกี่ยวกับบริการของเว็บไซต์นี้。",
        content99: "8.2.5 ความสูญเสียอื่นใดที่เกี่ยวข้องกับบริการของเว็บไซต์นี้ที่ไม่ได้เกิดจากเรา",
        content100: "8.3 เรามีหน้าที่รับผิดชอบในการบำรุงรักษาอุปกรณ์เครือข่ายข้อมูล ความล้มเหลวในการเชื่อมต่อเครือข่ายข้อมูล คอมพิวเตอร์ การสื่อสารหรือระบบอื่นๆ ขัดข้อง ไฟฟ้าขัดข้อง สภาพอากาศ อุบัติเหตุ การนัดหยุดงาน ข้อพิพาทด้านแรงงาน การจลาจล การลุกฮือ การจลาจล ผลผลิตหรือวัสดุการผลิตไม่เพียงพอ ไฟไหม้ น้ำท่วม , พายุ, การระเบิด, สงคราม, เหตุผลของธนาคารหรือพันธมิตรอื่น ๆ, การล่มสลายของตลาดสินทรัพย์ดิจิทัล, การดำเนินการของรัฐบาล, คำสั่งของหน่วยงานตุลาการหรือฝ่ายบริหาร, การกระทำอื่น ๆ ที่อยู่นอกเหนือการควบคุมของเราหรือที่เราไม่สามารถควบคุมได้ หรือเหตุผลของบุคคลที่สาม อย่ารับผิดชอบต่อการไร้ความสามารถหรือความล่าช้าในการให้บริการ หรือการสูญเสียของคุณ",
        content101: "8.4 เราไม่สามารถรับประกันได้ว่าข้อมูล โปรแกรม ข้อความ ฯลฯ ทั้งหมดที่มีอยู่ในเว็บไซต์นี้จะปลอดภัยอย่างสมบูรณ์และปราศจากการแทรกแซงและความเสียหายจากไวรัส โทรจัน และโปรแกรมที่เป็นอันตรายอื่น ๆ ดังนั้นหากคุณเข้าสู่ระบบและใช้บริการใด ๆ บนเว็บไซต์นี้ หรือดาวน์โหลดและใช้โปรแกรม ข้อมูล ฯลฯ ที่ดาวน์โหลดมา ล้วนเป็นการตัดสินใจของคุณเอง และคุณต้องรับความเสี่ยงและการสูญเสียที่อาจเกิดขึ้นด้วยความเสี่ยงของคุณเอง",
        content102: "8.5 เราไม่รับประกันหรือให้คำมั่นสัญญาใด ๆ เกี่ยวกับข้อมูล ผลิตภัณฑ์ และบริการของเว็บไซต์บุคคลที่สามที่เชื่อมโยงกับเว็บไซต์นี้หรือเนื้อหารูปแบบอื่นใดที่ไม่ได้เป็นของเรา หากคุณใช้บริการ ข้อมูล และบริการใด ๆ ที่จัดทำโดยบุคคลที่สาม -เว็บไซต์ของบุคคล ผลิตภัณฑ์ ฯลฯ ล้วนเป็นการตัดสินใจของคุณเอง และคุณต้องรับผิดชอบทั้งหมดที่เกิดขึ้นจากการตัดสินใจดังกล่าว",
        content103: "8.6 เราไม่รับประกันโดยชัดแจ้งหรือโดยนัยสำหรับการใช้บริการของคุณบนเว็บไซต์นี้ ซึ่งรวมถึงแต่ไม่จำกัดเพียงความเหมาะสมของบริการที่เว็บไซต์นี้มอบให้ ไม่มีข้อผิดพลาดหรือการละเว้น ความต่อเนื่อง ความถูกต้อง ความน่าเชื่อถือ และความเหมาะสมสำหรับกรณีใดกรณีหนึ่งโดยเฉพาะ วัตถุประสงค์. ในเวลาเดียวกัน เราไม่มีข้อผูกมัดหรือรับประกันความถูกต้อง แม่นยำ ความถูกต้อง ความน่าเชื่อถือ คุณภาพ ความเสถียร ความสมบูรณ์และความทันเวลาของเทคโนโลยีและข้อมูลที่เกี่ยวข้องกับบริการที่จัดทำโดยเว็บไซต์นี้ การจะเข้าสู่ระบบหรือใช้บริการของเว็บไซต์นี้เป็นการตัดสินใจส่วนตัวของคุณและคุณต้องรับความเสี่ยงและการสูญเสียที่อาจเกิดขึ้นเอง เราไม่รับประกันโดยชัดแจ้งหรือโดยนัยเกี่ยวกับตลาด มูลค่า และราคาของสินทรัพย์ดิจิทัล คุณเข้าใจและเข้าใจว่าตลาดสินทรัพย์ดิจิทัลไม่เสถียร ราคาและมูลค่าอาจผันผวนหรือพังทลายลงอย่างมากได้ตลอดเวลา การซื้อขายสินทรัพย์ดิจิทัลนั้น เสรีภาพส่วนบุคคลของคุณ เลือกและตัดสินใจด้วยความเสี่ยงของคุณเองและการสูญเสียที่อาจเกิดขึ้น",
        content104: "8.7 การรับประกันและข้อผูกพันของเราที่กำหนดไว้ในข้อตกลงนี้เป็นเพียงการรับประกันและการรับรองที่ทำโดยเราที่เกี่ยวข้องกับข้อตกลงนี้และบริการที่มีให้บนเว็บไซต์นี้ และแทนที่การรับประกันและข้อผูกพันใด ๆ ที่เกิดขึ้นในลักษณะและลักษณะอื่น ๆ ไม่ว่าจะเป็นลายลักษณ์อักษรหรือด้วยวาจาโดยชัดแจ้ง ของหรือโดยนัย การรับประกันและการรับรองทั้งหมดนี้แสดงถึงข้อผูกพันและการรับประกันของเราเท่านั้น และไม่รับประกันว่าบุคคลที่สามจะปฏิบัติตามการรับประกันและข้อผูกพันในข้อตกลงนี้",
        content105: "8.8 เราไม่สละสิทธิ์ใด ๆ ที่ไม่ได้ระบุไว้ในข้อตกลงนี้ในการจำกัด ไม่รวมหรือชดเชยความรับผิดของเราสำหรับความเสียหายในขอบเขตสูงสุดที่กฎหมายที่ใช้บังคับ",
        content106: "8.9 หลังจากที่คุณลงทะเบียน คุณยอมรับการดำเนินการใดๆ ที่เราดำเนินการตามกฎที่กำหนดไว้ในข้อตกลงนี้ และความเสี่ยงใดๆ ที่เกิดขึ้นจะเป็นความรับผิดชอบของคุณ",
        content107: "9. การสิ้นสุดข้อตกลง",
        content108: "9.1 เว็บไซต์นี้มีสิทธิ์ที่จะยกเลิกบริการทั้งหมดของเว็บไซต์นี้ตามข้อตกลงนี้ ข้อตกลงนี้จะสิ้นสุดในวันที่บริการทั้งหมดของเว็บไซต์นี้ถูกยกเลิก",
        content109: "9.2 หลังจากการยุติข้อตกลงนี้ คุณไม่มีสิทธิ์ขอให้เว็บไซต์นี้ให้บริการใด ๆ ต่อไปหรือปฏิบัติตามภาระผูกพันอื่นใด รวมถึงแต่ไม่จำกัดเพียงการกำหนดให้เว็บไซต์นี้เก็บรักษาหรือเปิดเผยข้อมูลใด ๆ ในบัญชีเว็บไซต์ดั้งเดิมแก่คุณ ถึงคุณหรือบุคคลที่สาม บุคคลที่สามส่งต่อข้อมูลใด ๆ ที่ยังไม่ได้อ่านหรือส่ง",
        content110: "9.3 การยกเลิกข้อตกลงนี้จะไม่ส่งผลกระทบต่อความรับผิดชอบอื่น ๆ ของฝ่ายที่ไม่ละเมิดต่อฝ่ายที่ละเมิด",
        content111: "10. สิทธิในทรัพย์สินทางปัญญา",
        content112: "10.1 ความสำเร็จทางปัญญาทั้งหมดที่มีอยู่ในเว็บไซต์นี้รวมถึงแต่ไม่จำกัดเพียงโลโก้ของเว็บไซต์ ฐานข้อมูล การออกแบบเว็บไซต์ ข้อความและกราฟิก ซอฟต์แวร์ รูปภาพ วิดีโอ เพลง เสียงและการผสมผสานของสิ่งเหล่านั้น การรวบรวมซอฟต์แวร์ ซอร์สโค้ดและซอฟต์แวร์ที่เกี่ยวข้อง (รวมถึงแอปพลิเคชันขนาดเล็ก ) สิทธิ์ในทรัพย์สินทางปัญญาของโปรแกรมและสคริปต์) เป็นของเว็บไซต์นี้ คุณไม่สามารถทำซ้ำ เปลี่ยนแปลง คัดลอก ส่ง หรือใช้เนื้อหาหรือเนื้อหาที่กล่าวมาข้างต้นเพื่อวัตถุประสงค์ทางการค้า",
        content113: "10.2 สิทธิ์ทั้งหมดที่อยู่ในชื่อของเว็บไซต์นี้ (รวมถึงแต่ไม่จำกัดเพียงค่าความนิยมและเครื่องหมายการค้า โลโก้) เป็นของบริษัท",
        content114: "10.3 การที่คุณยอมรับข้อตกลงนี้จะถือเป็นความคิดริเริ่มของคุณในการถ่ายโอนลิขสิทธิ์ของข้อมูลในรูปแบบใด ๆ ที่คุณเผยแพร่บนเว็บไซต์นี้ รวมถึงแต่ไม่จำกัดเพียง: สิทธิ์ในการทำซ้ำ สิทธิ์ในการแจกจ่าย สิทธิ์การเช่า สิทธิ์ในนิทรรศการ สิทธิ์ในการแสดง สิทธิ์ในการคัดกรอง สิทธิ์ในการออกอากาศ สิทธิ์ในการส่งผ่านข้อมูลทางอินเทอร์เน็ต สิทธิ์ในการถ่ายทำ สิทธิ์ในการดัดแปลง สิทธิ์การแปล สิทธิ์ในการรวบรวม และสิทธิ์ที่สามารถโอนได้อื่น ๆ ที่ผู้ถือลิขสิทธิ์ควรได้รับจะถูกโอนไปยังเว็บไซต์นี้โดยไม่เสียค่าใช้จ่ายแต่เพียงผู้เดียว เว็บไซต์นี้มีสิทธิ์ในการยื่นรายงานโดยอิสระ ฟ้องร้องเรื่องการละเมิดและได้รับค่าชดเชยเต็มจำนวน ข้อตกลงนี้ใช้ได้กับเนื้อหางานใด ๆ ที่ได้รับการคุ้มครองตามกฎหมายลิขสิทธิ์ที่คุณเผยแพร่บนเว็บไซต์นี้ ไม่ว่าเนื้อหานั้นจะเกิดขึ้นก่อนการลงนามข้อตกลงนี้หรือหลังจากการลงนามในข้อตกลงนี้",
        content115: "10.4 คุณต้องไม่ใช้หรือกำจัดสิทธิ์ในทรัพย์สินทางปัญญาของเว็บไซต์นี้หรือผู้อื่นอย่างผิดกฎหมายเมื่อใช้บริการของเว็บไซต์นี้ คุณไม่สามารถเผยแพร่หรืออนุญาตให้เว็บไซต์ (และสื่อ) อื่น ๆ ใช้ข้อมูลที่เผยแพร่บนเว็บไซต์นี้ในรูปแบบใด ๆ",
        content116: "11. การคุ้มครองข้อมูล",
        content117: 'บทบัญญัติของ "ข้อกำหนดความเป็นส่วนตัว" ที่เผยแพร่แยกต่างหากบนเว็บไซต์นี้จะมีผลเหนือกว่า',
        content118: "12. การคำนวณ",
        content119: "ผลการคำนวณธุรกรรมทั้งหมดได้รับการตรวจสอบโดยเราแล้ว และวิธีการคำนวณทั้งหมดได้รับการเผยแพร่บนเว็บไซต์ แต่เราไม่สามารถรับประกันได้ว่าการใช้งานเว็บไซต์จะไม่หยุดชะงักหรือปราศจากข้อผิดพลาด",
        content120: "13. การควบคุมการส่งออก",
        content121: "คุณเข้าใจและรับทราบว่าตามกฎหมายที่เกี่ยวข้อง คุณไม่ได้รับอนุญาตให้ส่งออก ส่งออกซ้ำ นำเข้าหรือถ่ายโอนสื่อใดๆ (รวมถึงซอฟต์แวร์) บนเว็บไซต์นี้ ดังนั้นคุณรับประกันว่าคุณจะไม่นำไปใช้หรือช่วยเหลือหรือมีส่วนร่วมในกิจกรรมใดๆ ของเว็บไซต์นี้ การส่งออกที่กล่าวมาข้างต้นหรือกิจกรรมที่เกี่ยวข้องที่ละเมิดกฎหมายและข้อบังคับ การโอน หรือการละเมิดกฎหมายและข้อบังคับที่บังคับใช้อื่น ๆ หากพบสถานการณ์ดังกล่าว คุณควรรายงานให้เราทราบอย่างทันท่วงทีและช่วยเหลือเราในการจัดการกับมัน",
        content122: "14. การโอน",
        content123: "สิทธิ์และภาระผูกพันที่กำหนดไว้ในข้อตกลงนี้จะมีผลผูกพันผู้รับโอน ทายาท ผู้บริหาร และผู้บริหารของฝ่ายที่ได้รับประโยชน์จากสิทธิ์และภาระผูกพันดังกล่าว คุณไม่สามารถถ่ายโอนไปยังบุคคลที่สามโดยไม่ได้รับความยินยอมจากเรา แต่เราอาจโอนสิทธิ์และภาระผูกพันของเราในข้อตกลงนี้ไปยังบุคคลที่สามได้ตลอดเวลาและแจ้งให้คุณทราบ",
        content124: "15. การแบ่งแยก",
        content125: "หากบทบัญญัติใด ๆ ของข้อตกลงนี้ถือว่าไม่สามารถบังคับใช้ได้ ไม่ถูกต้องหรือผิดกฎหมายโดยศาลที่มีเขตอำนาจศาลใด ๆ ก็จะไม่ส่งผลกระทบต่อความถูกต้องของบทบัญญัติที่เหลือของข้อตกลงนี้",
        content126: "16. ความสัมพันธ์ที่ไม่ใช่ตัวแทน",
        content127: "ไม่มีส่วนใดในข้อตกลงนี้ที่จะถือว่าสร้าง แสดงเป็นนัย หรือประกอบเราในฐานะตัวแทน ผู้ดูแลผลประโยชน์ หรือตัวแทนอื่น ๆ ของคุณ เว้นแต่จะระบุไว้เป็นอย่างอื่นในข้อตกลงนี้",
        content128: "17. การงดออกเสียง",
        content129: "การสละสิทธิ์โดยเราหรือคุณต่อความรับผิดของฝ่ายใดฝ่ายหนึ่งสำหรับการฝ่าฝืนสัญญาหรือความรับผิดอื่น ๆ ที่กำหนดไว้ในข้อตกลงนี้จะไม่ถือเป็นหรือตีความว่าเป็นการสละสิทธิ์ความรับผิดอื่น ๆ สำหรับการฝ่าฝืนสัญญา ความล้มเหลวในการใช้สิทธิหรือการเยียวยาใด ๆ จะไม่อยู่ใน ตีความได้ว่าเป็นการสละสิทธิ์หรือการเยียวยาดังกล่าว ของการยอมแพ้",
        content130: "18. ชื่อเรื่อง",
        content131: "หัวข้อทั้งหมดมีไว้เพื่อความสะดวกในการแสดงข้อตกลงเท่านั้น และไม่ได้ใช้เพื่อขยายหรือจำกัดเนื้อหาหรือขอบเขตของข้อกำหนดของข้อตกลง",
        content132: "19. กฎหมายที่ใช้บังคับ",
        content133: "19.1 ก่อนที่จะยื่นข้อพิพาทหรือการเรียกร้อง คุณรับทราบและตกลงที่จะติดต่อเว็บไซต์นี้ทางอีเมลก่อนเพื่อแก้ไขข้อพิพาทอย่างไม่เป็นทางการ เราจะพยายามแก้ไขข้อพิพาทของคุณเป็นการภายในโดยเร็วที่สุด ทั้งสองฝ่ายตกลงที่จะแก้ไขข้อพิพาทผ่านการเจรจาโดยสุจริต (การสนทนา จะเป็นความลับและได้รับการคุ้มครองตามหลักเกณฑ์ที่ใช้บังคับและไม่ใช้เป็นหลักฐานในการดำเนินคดีทางกฎหมายใดๆ)",
        content134: '19.2 คุณรับทราบและยอมรับว่าในกรณีที่มีข้อพิพาท ข้อขัดแย้ง ความขัดแย้ง หรือการเรียกร้อง รวมถึงการมีอยู่ ความถูกต้อง การตีความ การดำเนินการ การละเมิดหรือการสิ้นสุดข้อกำหนดเหล่านี้ หรือข้อพิพาทใด ๆ ที่เกิดขึ้นจากหรือเกี่ยวข้องกับข้อกำหนดเหล่านี้ ("ข้อพิพาท" ) ฝ่ายที่กล่าวมาข้างต้นจะต้องยื่นข้อพิพาทต่อศาลอนุญาโตตุลาการระหว่างประเทศของหอการค้าระหว่างประเทศ ("ศาลอนุญาโตตุลาการระหว่างประเทศของ ICC") ตาม "กฎอนุญาโตตุลาการของ ICC" ที่มีผลบังคับใช้ในขณะนั้น สถานที่ในการอนุญาโตตุลาการคือเบลีซและกฎหมายที่ใช้บังคับของการอนุญาโตตุลาการจะต้องถูกกำหนดตามกฎอนุญาโตตุลาการหอการค้านานาชาติ เว้นแต่คู่สัญญาจะตกลงเป็นอย่างอื่น จะมีแต่งตั้งอนุญาโตตุลาการเพียงคนเดียวเท่านั้นภายใต้กฎอนุญาโตตุลาการของ ICC อนุญาโตตุลาการจะมีอำนาจแต่เพียงผู้เดียวในการปกครองเขตอำนาจศาลของตนเอง ซึ่งรวมถึงแต่ไม่จำกัดเพียง การคัดค้านการมีอยู่ ขอบเขต หรือความถูกต้องของข้อตกลงอนุญาโตตุลาการ หรือการอนุญาโตตุลาการของการเรียกร้องหรือการเรียกร้องแย้งใด ๆ การอนุญาโตตุลาการใดๆ จะดำเนินการเป็นภาษาอังกฤษ ไม่ว่าอนุญาโตตุลาการจะดำเนินการอย่างไร อนุญาโตตุลาการจะต้องออกคำชี้ขาดเป็นลายลักษณ์อักษรที่สมเหตุสมผลและเพียงพอที่จะอธิบายคำชี้ขาดและข้อสรุปที่สำคัญ (ถ้ามี) ซึ่งเป็นพื้นฐานของคำชี้ขาด คำชี้ขาดของอนุญาโตตุลาการถือเป็นที่สิ้นสุดและมีผลผูกพันคู่กรณี และอาจบังคับใช้ในศาลที่มีเขตอำนาจศาล',
        content135: "20. ความมีประสิทธิผลและการตีความข้อตกลง",
        content136: "20.1 ข้อตกลงนี้จะมีผลเมื่อคุณคลิกบนหน้าลงทะเบียนของเว็บไซต์นี้เพื่อตกลงที่จะลงทะเบียน ดำเนินการลงทะเบียนให้เสร็จสิ้น และรับบัญชีและรหัสผ่านสำหรับเว็บไซต์นี้ โดยมีผลผูกพันทั้งเว็บไซต์นี้และคุณ",
        content137: "20.2 สิทธิ์ในการตีความขั้นสุดท้ายของข้อตกลงนี้เป็นของเว็บไซต์นี้。",
        content138: "รู้จักลูกค้าของคุณและนโยบายต่อต้านการฟอกเงิน",
        content139: "1. บทนำ",
        content140: '1.1 เราสัญญาว่าจะปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้องกับ "การรู้จักลูกค้าของคุณ" และการป้องกันการฟอกเงินอย่างรอบคอบ และจะไม่ละเมิด "การรู้จักลูกค้าของคุณและการต่อต้านการฟอกเงิน" โดยเจตนา ภายในขอบเขตการควบคุมที่เหมาะสมของเรา เราจะใช้มาตรการและเทคโนโลยีที่จำเป็นเพื่อให้บริการที่ปลอดภัยแก่คุณ และปกป้องคุณจากการสูญเสียที่เกิดจากพฤติกรรมการฟอกเงินของผู้ต้องสงสัยทางอาญาให้มากที่สุด',
        content141: "1.2 นโยบายการรู้จักลูกค้าของคุณและการต่อต้านการฟอกเงินของเราเป็นระบบนโยบายสากลที่ครอบคลุมซึ่งรวมถึงนโยบายการรู้จักลูกค้าของคุณและการต่อต้านการฟอกเงินสำหรับเขตอำนาจศาลทางกฎหมายต่างๆ ที่คุณอยู่ในเครือ",
        content142: "2. รู้จักลูกค้าและนโยบายต่อต้านการฟอกเงินมีดังนี้",
        content143: "2.1 เผยแพร่นโยบายการรู้จักลูกค้าของคุณและการป้องกันการฟอกเงิน และอัปเดตนโยบายเป็นครั้งคราวเพื่อให้เป็นไปตามมาตรฐานที่กำหนดโดยกฎหมายและข้อบังคับที่เกี่ยวข้อง",
        content144: "2.2 เผยแพร่และปรับปรุงหลักการและกฎเกณฑ์บางประการสำหรับการดำเนินงานเว็บไซต์นี้ และพนักงานของเราจะให้บริการตามคำแนะนำของหลักการและกฎเกณฑ์เหล่านี้",
        content145: "2.3 ออกแบบและดำเนินการขั้นตอนการติดตามและควบคุมธุรกรรมภายในให้ครบถ้วน เช่น การตรวจสอบตัวตนด้วยวิธีการที่เข้มงวด และจัดให้มีทีมงานมืออาชีพรับผิดชอบงานป้องกันการฟอกเงิน",
        content146: "2.4 ใช้วิธีการป้องกันความเสี่ยงเพื่อดำเนินการตรวจสอบสถานะและกำกับดูแลลูกค้าอย่างต่อเนื่อง",
        content147: "2.5 ทบทวนและตรวจสอบธุรกรรมที่เกิดขึ้นอย่างสม่ำเสมอ",
        content148: "2.6 รายงานธุรกรรมที่น่าสงสัยต่อเจ้าหน้าที่ผู้มีอำนาจ",
        content149: "2.7 หลักฐานการระบุตัวตน ที่อยู่ และบันทึกการทำธุรกรรมจะถูกเก็บรักษาไว้เป็นเวลาอย่างน้อยหกปี และอาจถูกส่งไปยังหน่วยงานกำกับดูแลโดยไม่ต้องแจ้งให้คุณทราบเพิ่มเติม",
        content150: "3. ข้อมูลประจำตัวและการตรวจสอบ",
        content151: "3.1 ข้อมูลประจำตัว",
        content152: "3.1.1 ตามกฎระเบียบที่แตกต่างกันในเขตอำนาจศาลที่แตกต่างกันและประเภทนิติบุคคลที่แตกต่างกัน เนื้อหาของข้อมูลของคุณที่เรารวบรวมอาจไม่สอดคล้องกัน โดยหลักการแล้ว ข้อมูลต่อไปนี้จะถูกรวบรวมจากบุคคลที่ลงทะเบียน:",
        content153: "ข้อมูลส่วนบุคคลพื้นฐาน: ชื่อ ที่อยู่ (และที่อยู่ถาวร หากแตกต่าง) วันเกิด สัญชาติ และข้อมูลอื่น ๆ ที่มีอยู่ การยืนยันตัวตนควรอิงตามเอกสารที่ออกโดยเจ้าหน้าที่หรือหน่วยงานอื่นที่คล้ายคลึงกัน เช่น หนังสือเดินทาง บัตรประจำตัวประชาชน หรือเอกสารระบุตัวตนอื่น ๆ ที่กำหนดและเรียกใช้โดยเขตอำนาจศาลที่แตกต่างกัน ที่อยู่ที่คุณให้ไว้จะได้รับการตรวจสอบโดยใช้วิธีการที่เหมาะสม เช่น การตรวจสอบตั๋วขนส่งผู้โดยสารหรือบันทึกอัตราดอกเบี้ย หรือการตรวจสอบทะเบียนการเลือกตั้ง",
        content154: "ภาพถ่ายที่ถูกต้อง: ก่อนที่คุณจะลงทะเบียน คุณต้องแสดงรูปถ่ายของตัวเองโดยถือบัตรประจำตัวไว้ที่หน้าอก",
        content155: "รายละเอียดการติดต่อ: หมายเลขโทรศัพท์/โทรศัพท์มือถือ และ/หรือที่อยู่อีเมลที่ถูกต้อง",
        content156: "3.1.2 หากคุณเป็นบริษัทหรือนิติบุคคลอื่น เราจะรวบรวมข้อมูลต่อไปนี้เพื่อระบุตัวคุณหรือผู้รับผลประโยชน์สูงสุดของบัญชีทรัสต์ของคุณ",
        content157: "ใบรับรองการจดทะเบียนและจดทะเบียนบริษัท สำเนาข้อบังคับของบริษัทและหนังสือบริคณห์สนธิ วัสดุการรับรองโดยละเอียดของโครงสร้างผู้ถือหุ้นของบริษัทและคำอธิบายความเป็นเจ้าของ พิสูจน์มติของคณะกรรมการของเงินต้นที่ได้รับอนุญาตซึ่งกำหนดการเปิดและการดำเนินการของบัญชีบนเว็บไซต์นี้ บริษัท กรรมการที่ต้องจัดเตรียมตามที่กำหนด เอกสารประจำตัวของผู้ถือหุ้นรายใหญ่และผู้มีอำนาจลงนามในบัญชีบนเว็บไซต์นี้ ที่อยู่ธุรกิจหลักของบริษัท หากแตกต่างจากที่อยู่ทางไปรษณีย์ของบริษัท ให้ระบุที่อยู่ทางไปรษณีย์ หากที่อยู่ในพื้นที่ของบริษัทไม่สอดคล้องกับที่อยู่ธุรกิจหลัก จะถือว่าเป็นลูกค้าที่มีความเสี่ยงสูงกว่าและจะต้องส่งเอกสารเพิ่มเติม",
        content158: "ขึ้นอยู่กับกฎระเบียบที่แตกต่างกันในเขตอำนาจศาลที่แตกต่างกันและหน่วยงานประเภทต่างๆ เราจำเป็นต้องมีใบรับรองและเอกสารอื่นๆ ที่ออกโดยหน่วยงานราชการ รวมถึงเอกสารที่เราเห็นว่าจำเป็น",
        content159: "3.1.3 เรายอมรับเฉพาะข้อมูลประจำตัวเวอร์ชันภาษาอังกฤษหรือภาษาจีนเท่านั้น หากไม่ โปรดแปลข้อมูลประจำตัวของคุณเป็นภาษาอังกฤษและรับรองข้อมูลดังกล่าว",
        content160: "3.2 ยืนยันการยืนยัน",
        content161: "3.2.1 เนื้อหาเต็มหน้าที่เราขอให้คุณจัดเตรียมเอกสารประจำตัว。",
        content162: "3.2.2 เราขอรูปถ่ายของคุณโดยถือเอกสารประจำตัวไว้ที่หน้าอก。",
        content163: "3.2.3 โดยทั่วไปควรตรวจสอบสำเนาเอกสารประกอบกับบัตรกำนัลต้นฉบับ อย่างไรก็ตาม สำเนาจะยอมรับได้หากผู้รับรองที่เหมาะสมและเชื่อถือได้สามารถรับรองได้ว่าสำเนาดังกล่าวเป็นสำเนาเอกสารต้นฉบับที่ถูกต้องและครบถ้วน ผู้รับรองดังกล่าว ได้แก่ เอกอัครราชทูต กรรมาธิการตุลาการ ผู้พิพากษาท้องถิ่น ฯลฯ",
        content164: "3.2.4 ข้อกำหนดในการระบุผู้รับประโยชน์สูงสุดและการควบคุมบัญชีคือการพิจารณาว่าท้ายที่สุดแล้วบุคคลใดเป็นเจ้าของหรือควบคุมลูกค้าโดยตรง และ/หรือเพื่อพิสูจน์ว่าธุรกรรมที่กำลังดำเนินอยู่กำลังดำเนินการในนามของผู้อื่น หากเป็นธุรกิจ ควรตรวจสอบตัวตนของผู้ถือหุ้นรายใหญ่ (เช่น ผู้ถือหุ้นที่มีสิทธิออกเสียงตั้งแต่ 10% ขึ้นไป) โดยทั่วไปการถือหุ้น 25% ถือว่าอยู่ในความเสี่ยงปกติและต้องตรวจสอบตัวตนของผู้ถือหุ้น การถือหุ้น 10% หรือมีสิทธิออกเสียงหรือหุ้นมากกว่านั้นถือเป็นสถานการณ์ที่มีความเสี่ยงสูงและการระบุตัวตน ของผู้ถือหุ้นจะต้องได้รับการตรวจสอบ",
        content165: "4. ติดตามธุรกรรม",
        content166: "4.1 เราตั้งค่าและปรับเปลี่ยนขีดจำกัดสูงสุดของการทำธุรกรรมรายวันและการถอนสกุลเงินเป็นครั้งคราว ขึ้นอยู่กับความปลอดภัยและเงื่อนไขการทำธุรกรรมจริง",
        content167: "4.2 หากธุรกรรมเกิดขึ้นบ่อยครั้งในผู้ใช้ที่ลงทะเบียนหรือมีสถานการณ์ที่ไม่สมเหตุสมผล ทีมงานมืออาชีพของเราจะประเมินและตัดสินใจว่าธุรกรรมนั้นน่าสงสัยหรือไม่",
        content168: "4.3 หากเราพิจารณาว่าธุรกรรมนั้นน่าสงสัยตามวิจารณญาณของเราเอง เราอาจใช้มาตรการที่เข้มงวด เช่น การระงับธุรกรรม การปฏิเสธธุรกรรม หรือแม้แต่ย้อนกลับธุรกรรมโดยเร็วที่สุดเท่าที่เป็นไปได้ และรายงานต่อหน่วยงานที่มีอำนาจ แต่ จะไม่แจ้งให้คุณทราบ",
        content169: "4.4 เราขอสงวนสิทธิ์ในการปฏิเสธการสมัครลงทะเบียนจากบุคคลที่มาจากเขตอำนาจศาลที่ไม่ปฏิบัติตามมาตรฐานการป้องกันการฟอกเงินระหว่างประเทศหรือบุคคลที่อาจได้รับการพิจารณาว่าเป็นบุคคลที่มีความเสี่ยงทางการเมืองเราขอสงวนสิทธิ์ในการระงับหรือยุติธุรกรรมที่น่าสงสัยในวิจารณญาณของเราแต่เพียงผู้เดียวที่ ได้ตลอดเวลาแต่เราไม่กระทำการใด ๆ ฝ่าฝืนหน้าที่หรือความรับผิดชอบใด ๆ ที่เป็นหนี้คุณ",
    },
    register: {
        formTitle1: "สร้าง",
        formTitle2: "ลงทะเบียนโดยใช้อีเมลหรือหมายเลขโทรศัพท์มือถือของคุณ",
        formTitle3: "บัญชี",
        field1: "รหัสยืนยัน",
        field2: "รับ",
        field3: "ยืนยันรหัสผ่าน",
        field4: "รหัสการเชิญ",
        field41: "(ไม่จำเป็น)",
        field5: "ฉันได้อ่านและเห็นด้วย",
        field6: "เงื่อนไขการให้บริการ",
        placeholder1: "กรุณากรอกรหัสยืนยัน",
        content7: "กรุณากรอกรหัสยืนยัน",
        content12: "กรุณากรอกหมายเลขโทรศัพท์",
        content13: "กรุณากรอกรหัสผ่าน",
        content14: "กรุณากรอกอีเมล์ของคุณ",
        content18: "กรุณากรอกรหัสผ่านอีกครั้ง",
        content19: "โปรดยอมรับข้อกำหนดในการให้บริการ",
        content20: "กรุณากรอกรหัสยืนยันที่ถูกต้อง",
        content23: "ยังไม่ได้รับรหัสยืนยัน？",
        content24: "กรุณากรอกรหัสยืนยันด้านล่าง",
        registerSuccess: "ความสำเร็จในการลงทะเบียน",
        content25: "รหัสผ่านไม่สอดคล้องกัน",
        content26: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
        content27: "รีเซ็ตรหัสผ่านสำเร็จ"
    },
    download: {
        content1: "ซื้อขายได้ทุกที่ทุกเวลา",
        content2: "เข้ากันได้อย่างสมบูรณ์แบบกับเทอร์มินัลหลายเครื่อง ตอบสนองความต้องการธุรกรรมในสถานการณ์ต่างๆ ได้ตลอดเวลา",
        content3: "ตรวจสอบสภาวะตลาดแบบเรียลไทม์ได้ตลอดเวลา",
        content4: "ซื้อและขาย BTC, ETH, XRP และสินทรัพย์ดิจิทัลอื่น ๆ ได้อย่างง่ายดาย",
        content5: "รับการแจ้งเตือนล่วงหน้าเกี่ยวกับการเปลี่ยนแปลงราคาสำหรับสกุลเงินดิจิทัลที่คุณสนใจ",
        content6: "ดูสินเชื่อสปอต Bitcoin สินเชื่อฟิวเจอร์ส และราคาออปชัน",
        content7: "เปรียบเทียบราคาสกุลเงินดิจิตอลจากการแลกเปลี่ยนต่างๆ",
        title: "ดาวน์โหลด",
        install: "ดาวน์โหลด",
        one: "1、อนุญาตให้ดาวน์โหลดไฟล์คำอธิบาย",
        two: "2、ดาวน์โหลดไฟล์คำอธิบายแล้ว",
        three: "3、ไปที่ [การตั้งค่า] บนโทรศัพท์ของคุณแล้วค้นหา [ทั่วไป]",
        four: "4、โปรไฟล์และตัวจัดการอุปกรณ์",
        five: "5、คลิกที่โปรไฟล์",
    },
    identity: {
        noAuthentication: {
            title: "การรับรองจูเนียร์",
            pleaseSelectYourCountry: "กรุณาเลือกประเทศของคุณ",
            name: "ชื่อ",
            enterName: "กรุณากรอกชื่อของคุณ",
            city: "เมือง",
            enterCity: "กรุณากรอกเมืองของคุณ",
            IDNumber: "หมายเลขประจำตัวประชาชน",
            enterIDNumber: "กรุณากรอกหมายเลขประจำตัวของคุณ",
        },
        noAdvancedAuthentication: {
            title: "การรับรองขั้นสูง",
            infoCountry: "ประเทศ/ภูมิภาค",
            infoName: "ชื่อ",
            infoNumber: "หมายเลขประจำตัวประชาชน",
            infoAddress: "ที่อยู่",
        },
        text: "ไม่ได้รับการรับรอง",
        recertification: "การรับรองซ้ำ",
        certification: "การรับรอง",
        authenticationInProgress: "ตรวจสอบแล้ว",
        inAuthentication: "ตรวจสอบแล้ว",
        uploadTheFrontOfTheDocument: "อัปโหลดด้านหน้าของบัตรประจำตัว",
        uploadTheReverseSideOfTheDocument: "อัปโหลดด้านหลังของใบรับรอง",
        uploadAPhotoOfAHandHeldID: "อัปโหลดรูปถ่ายบัตรประจำตัวของคุณในมือ",
        pleaseUpload: "โปรด ",
        pleaseCompleteOrdinaryCertificationFirst: "ต้องรอการตรวจสอบใบรับรองหลักให้สำเร็จ",
        refused: "ถูกปฏิเสธ",
        reason: "เหตุผล",
        succeeded: "ที่ประสบความสำเร็จ",
        uploading: "กำลังอัพโหลด",
        newTitle: "เลือกประเทศที่ออกบัตรประจำตัวของคุณ",
        pleaseOrdinaryCertificationFirst: "โปรดดำเนินการรับรองหลักก่อน",
        text1: "ปรับเปลี่ยนอวตาร",
        text2: "ชื่อนิค",
        text3: "บัญชี",
        text4: "การปรับเปลี่ยนชื่อเล่น",
        text5: "ชื่อเล่นใหม่",
        text6: "ป้อนชื่อเล่นใหม่ของคุณ",
        text7: "รหัสผ่านเก่า",
        text8: "ป้อนรหัสผ่านเก่าของคุณ",
        text9: "รหัสผ่านใหม่",
        text10: "ป้อนรหัสผ่านใหม่ของคุณ",
        text11: "ยืนยันรหัสผ่าน",

        text12: "ป้อนรหัสผ่านใหม่ของคุณอีกครั้ง",
        text13: "กล่องจดหมายใหม่",
        text14: "รหัสยืนยัน",
        text15: "กรุณากรอกรหัสยืนยัน",
        text16: "หมายเลขโทรศัพท์มือถือของคุณ",
        text17: "หมายเลขโทรศัพท์มือถือใหม่",
        text18: "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
        text19: "รหัสยืนยันโทรศัพท์มือถือ",
        text20: "การรับรองจูเนียร์",
        text21: "กรุณาตรวจสอบข้อมูลประจำตัวของคุณ",
        text22: "ประเทศ",
        text23: "เมือง",
        text24: "ป้อนเมืองของคุณ",
        text25: "ใส่ชื่อของคุณ",
        text26: "หมายเลขประจำตัวของคุณ",
        text27: "กรอกหมายเลขประจำตัวของคุณ",
        text28: "ภาพถ่ายด้านหน้าบัตรประจำตัวประชาชน",
        text29: "คลิกเพื่ออัพโหลดเอกสารของคุณ",
        text30: "อัปโหลดอีกครั้ง",
        text31: "ที่อัพโหลด",
        text32: "ถือรูปถ่ายประจำตัว",
        text33: "คลิกเพื่ออัปโหลดรูปถ่ายบัตรประจำตัวของคุณ",
        text34: "คุณได้ผูกมัด Google Authenticator",
        text35: "สำคัญ",
        text36: "กรุณากรอกรหัสยืนยันของ Google",
        text37: "ส่ง",
        text38: "ไม่สามารถเว้นว่างได้",
        text39: "รูปแบบอีเมลไม่ถูกต้อง",
        text40: "รหัสผ่านสองตัวไม่สอดคล้องกัน",
        text41: "คัดลอกเรียบร้อยแล้ว",
        text42: "การคัดลอกล้มเหลว",
        text43: "การปรับเปลี่ยนอวาตาร์",
        text44: "เปลี่ยนรหัสผ่าน",
        text45: "การผูกอีเมล",
        text46: "แก้ไขอีเมล",
        text47: "การผูกโทรศัพท์มือถือ",
        text48: "ปรับเปลี่ยนโทรศัพท์มือถือ",
        text49: "การยืนยันของ Google",
        text50: "ผูก Google Authenticator",
        text51: "ป้อนรหัสยืนยันของ Google",
        text52: "บันทึก",
        text53: "ยืนยันการส่ง",
        text54: "ปรับปรุงใหม่",
        text55: "ผูกพัน",
        text56: "ปิดการยืนยันของ Google",
        text57: "ขั้นตอนต่อไป",
        text58: "เสร็จ",
        text59: "การยืนยันของ Google ถูกผูกไว้",
        text60: "การยืนยันของ Google ได้รับการยกเลิกการรวมกลุ่มแล้ว",
        text61: "ได้ส่งใบรับรองหลักแล้ว",
        text62: "ส่งใบรับรองขั้นสูงแล้ว",
        text63: "ไม่มีการอัปโหลดรูปภาพ",
        text64: "ส่งซ้ำ",
        text65: "กรุณากรอกชื่อเล่น",
        text66: "บันทึกชื่อเล่นเรียบร้อยแล้ว",
        text67: "ยังไม่มีภาพที่อัพโหลด",
        text68: "รีเซ็ตรหัสผ่านเสร็จสมบูรณ์",
        text69: "แก้ไขอีเมลเรียบร้อยแล้ว",
        text70: "บันทึกอวตารสำเร็จแล้ว",
        text71: "อัพโหลดรูปภาพ",
        text72: "กล่องจดหมายของคุณ",
        text73: "ป้อนอีเมลใหม่ของคุณ",
        text74: "ชื่อของคุณ",
        text75: "ไปที่การรับรองความถูกต้อง",
        text76: "โปรดยืนยันรูปถ่ายประจำตัวของคุณ"
    },
    retrievePassword: {
        formTitle1: "รีเซ็ตรหัสผ่าน",
        formTitle2: "เพื่อความปลอดภัยของทรัพย์สินของคุณ ห้ามทำธุรกรรมภายใน 24 ชั่วโมงหลังจากเปลี่ยนรหัสผ่าน",
        formTitle3: "ดึงรหัสผ่าน",
        formTitle4: "ยืนยันการเปลี่ยนแปลง",
        formTitle5: "กรุณากรอกรหัสผ่านเก่า",
        formTitle6: "กรุณากรอกรหัสผ่านใหม่"
    },
    home: {
        title1: "แพลตฟอร์มการซื้อขาย Cryptocurrency ยอดนิยม",
        title3: "ทำไม ",
        title4: " เป็นแพลตฟอร์มบล็อกเชนโอเพ่นซอร์สประสิทธิภาพสูงที่ออกแบบมาเพื่อรองรับและดำเนินการโครงสร้างพื้นฐานดิจิทัลที่ปลอดภัย เป็นไปตามข้อกำหนด และคาดการณ์ได้",
        field1: "ก่อตั้งการแลกเปลี่ยน",
        field2: "บริการทางการเงินสินทรัพย์ดิจิทัล",
        field3: "ผู้ใช้หลายสิบล้านคน",
        field4: "จัดตั้งกองทุนคุ้มครองผู้ลงทุนหลายกองทุน",
        field5: "การซื้อขายที่รวดเร็ว",
        field6: "CME Gruop สามารถจับคู่คำสั่งซื้อขายที่มีความหน่วงต่ำเป็นพิเศษเพื่อประสบการณ์การซื้อขายขั้นสูงสุด",
        title5: "แนวโน้มของตลาด",
        title6: "ดูเพิ่มเติม",
        table1: "สกุลเงิน",
        table2: "ราคาล่าสุด",
        table3: "ขึ้นและลงตลอด 24 ชั่วโมง",
        table4: "ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
        table5: "ปริมาณธุรกรรมตลอด 24 ชั่วโมง",
        table6: "คำคม",
        title7: "เกี่ยวกับ ",
        title8: " เรามุ่งมั่นที่จะมอบเครื่องมือการซื้อขายที่ทันสมัยที่สุด เทคโนโลยีที่เป็นนวัตกรรม และการบริการลูกค้าที่มีคุณภาพที่เหนือชั้นให้กับผู้ใช้",
        title9: "ขอบเขตของสินทรัพย์ดิจิทัลเปลี่ยนแปลงไปในแต่ละวัน เพียงแค่มองการณ์ไกลและก้าวหน้าอย่างรวดเร็วเท่านั้นที่เราจะสามารถตามทันนวัตกรรมทางเทคโนโลยีได้",
        title901: "ให้บริการซื้อขายสินทรัพย์ดิจิทัลที่ทันสมัยที่สุดแก่ผู้ใช้และผู้ให้บริการสภาพคล่องทั่วโลก",
        title10: "เราเชื่อมั่นอย่างยิ่งว่าผู้ใช้ทุกคนสมควรได้รับประสบการณ์การซื้อขายที่ดีที่สุด",
        title11: "ความปลอดภัยที่คุณวางใจได้",
        title12: "มาตรการรักษาความปลอดภัยที่ซับซ้อนและกองทุน SAFU ช่วยปกป้องทรัพย์สินดิจิทัลของคุณจากความเสี่ยงทั้งหมด ",
        title13: "อัตราการทำธุรกรรมที่ดีที่สุด",
        title14: "อัตราการทำธุรกรรมพิเศษ สิทธิ์วีไอพีที่แข่งขันได้ และเพลิดเพลินกับบริการที่มีคุณภาพดีที่สุด",
        title15: "สนับสนุนการบริการลูกค้าตลอด 24 * 7 ชั่วโมง",
        title16: "โหมดการทำงานเต็มเวลาตลอด 24 ชั่วโมงทุกวัน เราจะตอบคำถามที่เกี่ยวข้องของคุณโดยเร็วที่สุด",
        title17: "การซื้อขายค่าธรรมเนียม 0",
        title18: "ใช้วิธีการชำระเงินหลายวิธีเพื่อแลกเปลี่ยนสกุลเงินดิจิทัลโดยไม่มีค่าธรรมเนียมการจัดการ ปลอดภัยและรวดเร็ว",
        title19: "ซื้อขายได้ทุกที่ทุกเวลา",
        title20: "เข้ากันได้อย่างสมบูรณ์แบบกับเทอร์มินัลหลายเครื่อง ตอบสนองความต้องการธุรกรรมในสถานการณ์ต่างๆ ได้ตลอดเวลา",
        title21: "ตรวจสอบสภาวะตลาดแบบเรียลไทม์ได้ตลอดเวลา",
        title22: "ซื้อและขาย BTC, ETH, XRP และสินทรัพย์ดิจิทัลอื่น ๆ ได้อย่างง่ายดาย",
        title23: "รับการแจ้งเตือนล่วงหน้าเกี่ยวกับการเปลี่ยนแปลงราคาสำหรับสกุลเงินดิจิทัลที่คุณสนใจ",
        title24: "ดูสินเชื่อสปอต Bitcoin สินเชื่อฟิวเจอร์ส และราคาออปชั่น",
        title25: "เปรียบเทียบราคาสกุลเงินดิจิตอลจากการแลกเปลี่ยนต่างๆ",
        title26: "สมัครตอนนี้เลย",
        title27: "ดอลลาร์",
        title28: "ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
        title29: "ผู้ให้บริการสภาพคล่องแบบบูรณาการ",
        title30: "ผู้ใช้",
        title31: "มากกว่า",
        title32: "Binance Loan เพิ่ม CTSI & KSM เป็นหลักทรัพย์ค้ำประกัน และเปิดตัวส่วนลดการลดอัตราดอกเบี้ย BUSD และ USDT!",
        title33: "ข้อได้เปรียบของเรา",
        title34: "ปลอดภัยและมั่นคง",
        title35: "ทีมงานด้านเทคนิคชั้นนำ การป้องกันความปลอดภัยที่ครอบคลุม การวิจัยอิสระและการพัฒนากลไกการสังเคราะห์ธุรกรรมความเร็วสูง ยังคงสามารถทำงานได้อย่างเสถียรและเชื่อถือได้ภายใต้การทำธุรกรรมจำนวนมากพร้อมกัน",
        title36: "การปฏิบัติตามข้อกำหนดอย่างมืออาชีพ",
        title37: "ทีมงานมืออาชีพที่มีประสบการณ์หลายปีในด้านบล็อกเชนและการเงิน มีใบอนุญาตการซื้อขายสินทรัพย์ดิจิทัลที่เป็นไปตามข้อกำหนด และมีการรับประกันการสำรอง 100%",
        title38: "ผู้ใช้ก่อน",
        title39: "เผชิญกับตลาดโลก รองรับหลายภาษา ทำงานตลอด 24 ชั่วโมงทุกวัน การสนับสนุนชุมชนที่แข็งแกร่ง และการบริการลูกค้าอย่างมืออาชีพ",
        title40: "ประสิทธิภาพสูง",
        title41: "ธุรกรรม 300,000 รายการต่อวินาที และเวลาตอบสนองคำสั่งซื้อน้อยกว่า 1 มิลลิวินาที",
        title42: "เกี่ยวกับเรา",
        title43: "ซื้อขายได้ทุกที่ทุกเวลา",
        title44: "เข้ากันได้อย่างสมบูรณ์แบบกับเทอร์มินัลหลายเครื่อง ตอบสนองความต้องการธุรกรรมในสถานการณ์ต่างๆ ได้ตลอดเวลา",
        title45: "（สแกนโค้ดเพื่อดาวน์โหลด）",
        title46: "ข่าวสกุลเงินดิจิทัล",
        title47: "พันธมิตรทางธุรกิจของเรา",
        title48: "รายชื่อผู้แพ้",
        title49: "มูลค่าการซื้อขาย 24 ชม",
        title50: "เพิ่มขึ้นและลดลง 24 ชั่วโมง"
    },
    quotation: {
        marketTrading: "คำคม",
        turnover: "ปริมาณ",
        optional: "ไม่จำเป็น",
        contractMarket: "ตลาดสัญญา",
        currencyPair: "คู่สกุลเงิน",
        latestPrice: "ราคาปิด",
        upsAndDowns: "การเปลี่ยนแปลงใบเสนอราคา",
        highest: "สูงสุด",
        lowest: "ต่ำสุด",
        transactionAmount: "ปริมาณธุรกรรม",
        operate: "ดำเนินงาน",
        buy: "ซื้อขาย",
        topTurnovers: "รายการธุรกรรม",
        topGainers: "รายการกำไร",
        tradingPair: "คู่การซื้อขาย",
        buyOrder: "ซื้อ",
        sellOrder: "ขายคำสั่ง"
    },
    accountChange: {
        demo: "การจำลอง",
        realAccount: "บัญชีจริง",
        demoAccount: "บัญชีทดลอง",
        accountRole: "บทบาทบัญชี",
        pleaseSelect: "กรุณาเลือก",
        AccountChangeType: "ประเภทการเปลี่ยนแปลงบัญชี",
        AccountType: "ประเภทบัญชี",
        currencyType: "ประเภทสกุลเงิน",
        allType: "ทุกประเภท",
        allAccount: "บัญชีทั้งหมด",
        allCoin: "ทุกสกุลเงิน",
        coin: "สกุลเงิน",
        amount: "เปลี่ยนจำนวนเงิน",
        balance: "ยอดเงินในบัญชี",
        time: "เวลา",
        title: "บันทึกการเปลี่ยนแปลงบัญชี",
        filtrar: "กรอง",
        check: "เปลี่ยนไปที่",
        showOnly: "แสดงเฉพาะการถือครองสกุลเงิน",
        holdAssets: "ยอดเงินคงเหลือ",
        accountList: "รายการบัญชี"
    },
    contractTransaction: {
        chart: "แผนภูมิ",
        basicEdition: "รุ่นพื้นฐาน",
        depthMap: "แผนที่ความลึก",
        second: "ที่สอง",
        minute: "จุด",
        day: "ท้องฟ้า",
        week: "สัปดาห์",
        month: "ดวงจันทร์",
        open: "เปิด",
        trade: "ซื้อขาย",
        buyLong: "ซื้อนาน",
        buyShort: "ซื้อระยะสั้น",
        cannotBuy: "สกุลเงินนี้ไม่รองรับธุรกรรมตามสัญญาการส่งมอบ",
        cannotBuy1: "สกุลเงินนี้ไม่รองรับการซื้อขายแบบถาวร",
        tradingAssets: "การซื้อขายสินทรัพย์",
        amountAvailable: "ปริมาณที่มีอยู่",
        timeStr: "เวลา",
        transactionPeriod: "ระยะเวลาการซื้อขาย",
        quantity: "ปริมาณ",
        enterQuantity: "กรุณากรอกจำนวน",
        buyIn: "ยาวไป",
        latestTransaction: "การทำธุรกรรมล่าสุด",
        time: "เวลา",
        direction: "ทิศทาง",
        price: "ราคา",
        sell: "สั้น",
        positionOrder: "ออเดอร์จัดส่ง",
        historicalOrders: "คำสั่งในอดีต",
        product: "ผลิตภัณฑ์",
        realAccount: "(บัญชีจริง)",
        demoAccount: "(บัญชีทดลอง)",
        openingTime: "เวลาสั่งซื้อ",
        openingPrice: "ราคาเปิด",
        curretPrice: "ราคาปัจจุบัน",
        liquidationPrice: "ราคาปิด",
        profitOrLoss: "กำไรและขาดทุน",
        endTime: "เวลาปิด",
        areYouSureToBuy: "คุณแน่ใจที่จะซื้อ?",
        areYouSureToLongBuy: "คุณแน่ใจหรือว่าต้องการไปนาน?",
        areYouSureToShortBuy: "คุณแน่ใจหรือไม่ว่าต้องการซื้อชอร์ต?",
        successfullyBought: "ซื้อสำเร็จ",
        minBuy: "การซื้อเข้าขั้นต่ำ",
        assets: "สินทรัพย์",
        withdraw: "ถอน",
        entrustedOrder: "คำสั่ง",
        total: "ทั้งหมด",
        continueToPlaceOrder: "ดำเนินการสั่งซื้อต่อไป",
        orderConfirmation: "ยืนยันการสั่งซื้อ",
        buyRu: "ซื้อ",
        sellChu: "ขาย",
        areYouSureToSell: "คุณแน่ใจหรือว่าต้องการขาย?",
        operation: "ดำเนินงาน",
        buyCover: "ตำแหน่งฝาครอบ",
        commitSuccess: "ทำธุรกรรมสำเร็จ",
        onlyEnterIntegers: "สามารถป้อนได้เฉพาะจำนวนเต็มเท่านั้น",
        trend: "แนวโน้ม",
        lotteryTime: "กำหนดเวลาในการสั่งซื้อ",
        countdown: "นับถอยหลัง",
        period: "ปัญหา",
        cycle: "ช่วงเวลา",
        unlimited: "ไม่ จำกัด",
        put: "PUT",
        call: "CALL",
        pending: "ในค่าคอมมิชชั่น",
        unopened: "ยังไม่ได้วาดเลย",
        opened: "จับรางวัล",
        settlementPrice: "ราคาชำระบัญชี",
        rateOfReturn: "อัตราผลตอบแทน",
        currentPositions: "ตำแหน่งปัจจุบัน",
        positionQuantity: "ปริมาณตำแหน่ง",
        guarantee: "ระยะขอบ",
        text1: "CALL",
        text2: "PUT",
        text3: "รอซื้อครับ",
        text4: "ปริมาณการสั่งซื้อ",
        text5: "จำนวนธุรกรรม",
        text6: "ยกเลิก",
        text7: "เวลาการส่งมอบ",
        text8: "การแจ้งเตือนการยกเลิก",
        text9: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อ",
        text10: "ปริมาณที่ผิดกฎหมาย",
        text11: "การแจ้งเตือนการสั่งซื้อ",
        text12: "คุณแน่ใจหรือว่าคุณกำลังซื้อภาวะกระทิง?",
        text13: "คุณแน่ใจหรือว่าจะซื้อของใส่?",
        text14: "การยกเลิกสำเร็จ"
    },
    mining: {
        title1: "แพลตฟอร์มการขุดสินทรัพย์ดิจิทัลบล็อกเชนชั้นนำของโลก",
        title2: "เปิดกว้างและโปร่งใส · ปลอดภัยและมั่นคง",
        title3: "กรุณาเลือกสกุลเงิน",
        title4: "การทำเหมืองแร่ผลผลิตต่อปี",
        title5: "ท้องฟ้า",
        title6: "ช่วงการขุด",
        title7: "รายละเอียดสินค้า",
        btn: "ของฉันตอนนี้",
        btn2: "ปิด",
        tabs1: "กำลังดำเนินการ",
        tabs2: "แลกแล้ว",
        table1: "ชื่อผลิตภัณฑ์",
        table2: "ช่วงการขุด",
        table3: "เวลาขุด",
        table4: "ปริมาณการขุด",
        table5: "วันที่หมดอายุ",
        table6: "ดำเนินการจนครบกำหนด",
        table7: "สถานะการสั่งซื้อ",
        egularMining: "ทำเหมืองอย่างสม่ำเสมอ",
        inProgress: "กำลังดำเนินการ",
        redeemed: "แลกแล้ว",
        redemption: "การไถ่ถอน",
        regularMining: "ทำเหมืองอย่างสม่ำเสมอ",
        earlyRedemption: "การไถ่ถอนก่อนกำหนด",
        need: "ความต้องการ",
        handlingFee: "ค่าธรรมเนียมการจัดการ",
        redemptionConfirmationMessage: "กรุณายืนยันว่าจะแลกล่วงหน้าหรือไม่？",
        form1: "การทำเหมืองแร่ผลผลิตต่อปี",
        form2: "ช่วงการขุด",
        form3: "สกุลเงินการขุด",
        form4: "จำนวนการสมัครสมาชิก (ขั้นต่ำ/สูงสุด)",
        form5: "ค่าธรรมเนียมการไถ่ถอนก่อนกำหนด: ",
        form6: "ราคาซื้อ",
        form7: "เงินทุนที่มีอยู่",
        form8: "ราคาซื้อ",
        form9: "เงินทุนที่มีอยู่",
        form10: "กรุณากรอกจำนวนเงินที่ซื้อ",
        form11: "ทั้งหมด",
        form12: "รายได้โดยประมาณ",
        form13: "มีเงินทุนไม่เพียงพอ",
        form14: "กรุณากรอกจำนวนเงินที่ซื้อ",
        form15: "คำสั่งซื้อของฉัน",
        form16: "รายได้",
        form17: "รายละเอียดการสั่งซื้อ",
        form18: "คำแนะนำสำหรับการไถ่ถอนก่อนกำหนด:",
        form19: "จำนวนการสมัครสมาชิก (ขั้นต่ำ)",
        form20: "จำนวนการสมัครสมาชิก (สูงสุด)",
        form21: "ปริมาณที่ถืออยู่",
        form22: "เวลาซื้อ",
        form23: "เวลาไถ่ถอน",
        form24: "เกิน",
        form25: "สมัครสมาชิกสำเร็จ",
        form26: "ไถ่ถอนสำเร็จ",
        form27: "บริหารจัดการการเงินง่าย ๆ ด้วยผลตอบแทนมากกว่า 25% แซงหน้าตลาด และยังได้รับรางวัลหลังการซื้ออีกด้วย",
        form28: "เชิญเพื่อนเพื่อรับรางวัล 50 USDT และบัตรกำนัลสัญญายังสามารถคืนค่าคอมมิชชัน 20% ได้อีกด้วย"
    },
    assets: {
        content1: "ทรัพย์สินทางบัญชี",
        content2: "รายได้วันนี้",
        content3: "บัญชีกระแสรายวัน",
        content4: "บัญชีจริงคือทรัพย์สินในบัญชีจริงของคุณ ซึ่งสามารถใช้สำหรับการทำธุรกรรมและการถอนเงิน",
        content5: "ถอนเหรียญ",
        content6: "ฝากเหรียญ",
        content7: "แลกเปลี่ยน",
        content8: "โอนย้าย",
        content9: "กรุณาเลือก",
        content10: "บัญชีทดลอง",
        content11: "บัญชีจริง",
        content12: "ได้รับสินทรัพย์",
        content13: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนไปใช้บัญชีจริง",
        content14: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนไปใช้บัญชีทดลอง ",
        content15: "ได้รับความสำเร็จ",
        table1: "สกุลเงิน",
        table2: "ปริมาณ",
        table3: "แช่แข็ง",
        table4: "มีอยู่",
        dialog1: "รายละเอียดสินค้า",
        dialog2: "1、สินทรัพย์นี้ได้รับอนุญาตให้ใช้ในโหมดบัญชีทดลองเท่านั้น",
        dialog3: "2、เพื่อป้องกันการละเมิด อนุญาตให้แลกได้เพียงครั้งเดียวภายในหนึ่งเดือน",
        dialog4: "3、การรับสินทรัพย์จะเพิ่มจำนวนสินทรัพย์ที่ได้รับตามเดิมและจะไม่เปลี่ยนสถานะตำแหน่ง",
        dialog5: "4、หากคุณมีคำถามอื่น ๆ โปรดติดต่อฝ่ายบริการลูกค้า",
        dialog6: "ปิด",
        dialog7: "รับสินทรัพย์สาธิตทันที",
        dialog8: "โอนเข้า",
        dialog9: "โอนออก",
        dialog10: "สวิตช์",
        dialog11: "การประเมินมูลค่า",
        dialog12: "สินทรัพย์สาธิต",
        dialog13: "บัญชีของฉัน",
        dialog14: "สินทรัพย์บัญชีทั้งหมด",
        dialog15: "ภาพรวมสินทรัพย์",
        dialog16: "การประเมินมูลค่าทรัพย์สินทั้งหมด",
        dialog17: "การประเมินมูลค่าสินทรัพย์",
        dialog18: "รายได้วันนี้",
        dialog19: "แช่แข็งเงินทุน",
        dialog20: "คุณสามารถรับโควต้าสินทรัพย์จำลองได้ทุกเดือน",
        dialog21: "รับ",
        dialog22: "คุณได้รับเรียบร้อยแล้ว",
        dialog23: 'รายได้สะสม 30 วัน',
        dialog24: "ผลิตภัณฑ์ทางการเงิน",
        dialog25: "การจัดการทางการเงินของฉัน",
        dialog26: "การจัดการทางการเงินในอดีต",
        dialog27: "บันทึกประวัติศาสตร์",
        dialog28: "บันทึกการระดมทุน"
    },
    validator: {
        dialog14: "เครื่องมือตรวจสอบ",
        dialog15: "เครื่องมือตรวจสอบการเชื่อมโยง",
        dialog16: "สวิตช์ตรวจสอบ",
        dialog17: "รหัสยืนยัน",
        dialog18: "รหัส QR ของเครื่องมือตรวจสอบ",
        dialog19: "รหัสตรวจสอบ",
        dialog20: "บันทึก",
        dialog21: "โปรดเลือกเครื่องมือตรวจสอบ",
        dialog22: "คัดลอกคีย์",
        dialog23: "บันทึกเรียบร้อยแล้ว",
        dialog24: "กรุณากรอกรหัสยืนยัน",
        dialog25: "คำเตือนที่เป็นมิตร: ก่อนที่จะยืนยันการบันทึก โปรดเปิดแอปที่เกี่ยวข้องและสแกนโค้ด QR ด้านล่างหรือเพิ่มรหัสด้วยตนเอง!",
        dialog26: "เปิดใช้งานตัวตรวจสอบความถูกต้องของคุณเพื่อเพิ่มความปลอดภัยสูงสุดให้กับบัญชีของคุณ。",
        dialog27: "คุณจะต้องป้อนรหัสยืนยันเฉพาะที่เข้าถึงได้ผ่านโทรศัพท์มือถือของคุณทุกครั้งที่คุณเข้าสู่ระบบหรือถอนเงิน",
        dialog28: "ตั้งค่าเครื่องมือตรวจสอบ",
        dialog29: "ช่วย",
        dialog30: "คุณไม่ได้ผูกมัดรหัสยืนยันตัวตน รับการป้องกันที่แข็งแกร่งยิ่งขึ้นด้วยตัวตรวจสอบความถูกต้อง",
        dialog31: "เครื่องมือตรวจสอบยังไม่ได้ตั้งค่า โปรดตั้งค่าก่อน",
        dialog32: "ไปที่การตั้งค่า"
    },
    recharge: {
        title1: "ไม่รู้ว่าจะใช้สกุลเงินดิจิทัลในการซื้ออย่างไร？",
        title2: "เพียงสามขั้นตอนง่ายๆ!",
        title3: "เลือกสกุลเงินดิจิทัลที่คุณต้องการซื้อจากเมนูแบบเลื่อนลงและป้อนจำนวนหรือจำนวนเงินในการซื้อ",
        title4: "เลือกวิธีการชำระเงินที่คุณต้องการ",
        title5: "หลังจากยืนยันการชำระเงินแล้ว สกุลเงินดิจิทัลที่คุณซื้อจะถูกโอนไปยังบัญชีของคุณโดยอัตโนมัติ",
        title6: "โปรดเลือกสกุลเงินที่คุณต้องการเติมเงิน",
        title7: "บันทึกการฝากเงิน",
        table1: "สกุลเงิน",
        table2: "ปริมาณ",
        table3: "ชื่อลูกโซ่",
        table4: "สถานะ",
        table5: "เหตุผล",
        table6: "เวลา",
        table7: "ดูบัตรกำนัล",
        dialog1: "กรุณากรอกรหัสยืนยันด้านล่าง",
        dialog2: "รหัสการชำระเงิน",
        dialog3: "สำเนา",
        dialog4: "ที่อยู่",
        dialog5: "จำนวนเงินฝาก",
        dialog6: "ภาพหน้าจอของธุรกรรม",
        dialog7: "ประกาศสำคัญ",
        dialog8: "กรุณากรอกจำนวนเงินฝาก",
        dialog9: "อัพโหลดภาพ",
        dialog10: "กรุณากรอกเนื้อหา",
        dialog11: "กรุณาอัพโหลดภาพหน้าจอของการเติมเงิน",
        dialog12: "ไม่ได้รับการตรวจทาน",
        dialog13: "ถูกปฏิเสธ",
        dialog14: "ฝากแล้ว",
        tip1: "ส่งเรียบร้อยแล้ว",
        tip2: "คัดลอกเรียบร้อยแล้ว",
        tip3: "การคัดลอกล้มเหลว",
        tip4: "โปรดเลือกสกุลเงินที่คุณต้องการเติมเงิน",
        tip5: "1.ที่อยู่การฝากเงินข้างต้นคือที่อยู่การชำระเงินอย่างเป็นทางการของแพลตฟอร์ม โปรดมองหาที่อยู่การฝากเงินอย่างเป็นทางการของแพลตฟอร์ม คุณจะต้องรับผิดชอบต่อการสูญเสียเงินที่เกิดจากการฝากผิด",
        tip6: "2.โปรดตรวจสอบให้แน่ใจว่าได้ยืนยันความปลอดภัยของคอมพิวเตอร์และเบราว์เซอร์ของคุณแล้ว เพื่อป้องกันไม่ให้ข้อมูลถูกดัดแปลงหรือรั่วไหล",
        tip7: "3.หลังจากที่คุณเติมเงินตามที่อยู่ข้างต้นแล้ว โหนดเครือข่ายทั้งหมดจะต้องยืนยันก่อนจึงจะสามารถเครดิตบัญชีได้",
        tip8: "4.โปรดเลือกระบบโทเค็นและสกุลเงินด้านบนแล้วโอนจำนวนเงินฝากที่สอดคล้องกัน โปรดอย่าโอนทรัพย์สินอื่น ๆ ที่ไม่เกี่ยวข้อง มิฉะนั้น จะไม่ถูกเรียกคืน",
        tip9: "บันทึกรหัส QR",
        tip10: "เติม",
        tip11: "ประกาศสำคัญ",
        tip12: "ลิงค์นอกสถานที่",
        tip13: "เติมเงินรหัส QR",
        tip14: "ขั้นตอนต่อไป",
        tip15: "บันทึกการเติมเงิน",
        tip16: "รายละเอียดการเติมเงิน",
        tip17: "ที่อยู่การฝากเงิน",
        tip18: "ชำระเงินด่วน",
        tip20: "ยอดคงเหลือไม่เพียงพอ",
        tip22: "ส่งแล้วรอการยืนยัน",
        tip23: "รอการชำระเงิน",
        tip24: "จำนวน",
        tip25: "ส่งการชำระเงินแล้ว กำลังรอการยืนยันการบล็อก",
        tip26: "การชำระเงินถูกปฏิเสธ",
        tip27: "การชำระเงินล้มเหลว",
        tip28: "ชำระเงินสำเร็จ",
        bankChannel: "ช่องทางบัตรธนาคาร",
        tip29: "การค้นหาทางประวัติศาสตร์",
        tip30: "รายการสกุลเงิน",
        tip31: "เลือกเครือข่าย",
        tip32: "เมื่อคุณเติมเงินสกุลเงินนี้ โปรดเติมเงินผ่านเครือข่ายที่รองรับด้านล่างเท่านั้น หากคุณเติมเงินผ่านเครือข่ายอื่น เงินจะสูญหาย",
        tip33: "เมื่อคุณถอนสกุลเงินนี้ โปรดถอนผ่านเครือข่ายที่รองรับด้านล่างเท่านั้น หากคุณถอนผ่านเครือข่ายอื่น เงินจะสูญหาย",
        tip34: "เติมเงินด่วน",
        tip35: "สแกนรหัสเพื่อเติมเงิน",
        tip36: "เติมเงินด้วยตนเอง",
        tip37: "Network",

        tip38: "ที่อยู่เติมเงิน",
        tip39: "จำนวนการเติมเงิน",
        tip40: "อัพโหลดใบเสร็จรับเงินธุรกรรม",
        tip41: "อัพโหลดภาพ",
        tip42: "ยืนยันการส่ง",
        tip43: "ยืนยันการชำระเงิน",
        tip44: "หมายเหตุ: โปรดยืนยันที่อยู่ที่คุณต้องการเติมเงิน เราจะไม่รับผิดชอบต่อการสูญเสียเงินหากคุณกรอกไม่ถูกต้อง",
        tip45: "เตือน",
        tip46: "คัดลอกที่อยู่เรียบร้อยแล้ว!",
        tip47: "คัดลอกที่อยู่ล้มเหลว!",
        tip48: "ยอดคงเหลือที่มีอยู่ไม่เพียงพอ",
        tip49: "ส่งการเติมเงินเรียบร้อยแล้ว และกำลังรอการยืนยันในห่วงโซ่",
        tip50: "การเติมเงินล้มเหลว",
        tip51: "จำนวนเงินที่เติมไม่ถูกต้อง",
        tip52: "การเชื่อมต่อล้มเหลว",
        tip53: "กระเป๋าเงินไม่ได้เข้าสู่ระบบ",
        tip54: "การเชื่อมต่อถูกปฏิเสธ",
        tip55: "ส่งสำเร็จแล้ว กำลังรอการตรวจสอบและอนุมัติการบริการลูกค้า",
        tip56: "โปรดอัปโหลดภาพหน้าจอใบเสร็จการทำธุรกรรม",
        tip57: "การส่งล้มเหลว",
        tip58: "บันทึกการเติมเงิน",
        tip59: "บันทึกการถอนเงิน",
        tip60: "เติมเงินสกุลเงิน",
        tip61: "สกุลเงินที่ถอนออก",
        tip62: "ที่อยู่เติมเงิน",
        tip63: "ภาพหน้าจอแสดง",
        tip64: "คลิกเพื่อขยายภาพ",
        tip65: "เวลาชาร์จ",
        tip66: "เหตุผลในการปฏิเสธ",
        tip67: "จำนวนเงินที่ถอน",
        tip68: "จำนวนเงินที่ได้รับ",
        tip69: "เครือข่ายการถอนเงินสด",
        tip70: "ที่อยู่การถอนเงิน",
        tip71: "เวลาถอนเงิน",
        tip72: "ปิด",
        tip73: "ภาพหน้าจอของธุรกรรม",
        tip74: "รอการตรวจสอบ",
        tip75: "ถูกปฏิเสธ",
        tip76: "สมบูรณ์",
        tip77: "ถูกปฏิเสธ",
        tip78: "ตรวจสอบแล้ว",
        tip79: "เบิกจ่ายแล้ว",
        tip80: "สารสกัด",
        tip81: "เครือข่ายการถ่ายโอน",
        tip82: "ที่อยู่/ใบแจ้งหนี้",
        tip83: "ถอนทั้งหมด",
        tip84: "โปรดอย่าถอนเงินโดยตรงไปยังการระดมทุนหรือที่อยู่ ICO มิฉะนั้นคุณจะไม่สามารถรับโทเค็นที่ออกโดยการระดมทุนหรือ ICO ได้",
        tip85: "ปริมาณมาถึง",
        tip86: "ยืนยันการถอนเงิน",
        tip87: "ที่อยู่การถอนเงินไม่ถูกต้อง",
        tip88: "จำนวนเงินที่ถอนไม่ถูกต้อง",
        tip89: "จำนวนเงินที่จะถอนเป็นอย่างน้อย",
        tip90: "จำนวนเงินถอนสูงสุดคือ",
        tip91: "ส่งคำขอถอนเงินแล้ว",
        tip92: "รายการที่อยู่",
        tip93: "คุณยังไม่ได้เพิ่มที่อยู่",
        tip94: "เพิ่มเลย",
        tip95: "เพิ่มที่อยู่",
        tip96: "เพิ่มที่อยู่ใหม่",
        tip97: "กรุณาเลือก",
        tip98: "ที่อยู่",
        tip99: "กรุณาเลือกเครือข่ายการโอน",
        tip100: "กรุณากรอกที่อยู่",
        tip101: "เพิ่มที่อยู่เรียบร้อยแล้ว",
        tip102: "ในการทำธุรกรรม",
    },
    fundExchange: {
        title1: "วิธีการแลกเปลี่ยนเงินทุน？",
        title2: "เลือกสกุลเงินที่เหมาะสมที่จะแปลง。",
        title3: "เลือกสกุลเงินที่เหมาะสมในการแปลง。",
        title4: "กรอกจำนวนเงินที่จะแลกเปลี่ยนแล้วคลิกส่งเพื่อเสร็จสิ้นการแลกเปลี่ยนกองทุน。",
        title5: "จาก",
        title6: "มาถึง",
        title7: "ปริมาณการแลกเปลี่ยน",
        title8: "อัตราแลกเปลี่ยน",
        title9: "มีอยู่",
        title10: "กรุณากรอกจำนวนการไถ่ถอน",
        title11: "ไม่มีคู่การซื้อขายที่เกี่ยวข้องสำหรับการแลกเปลี่ยน",
        title12: "กรุณากรอกจำนวนที่ต้องการแลก",
        title13: "ไถ่ถอนสำเร็จ",
        title14: "บันทึกการแลกเปลี่ยน",
        table1: "ใช้สกุลเงิน",
        table2: "ปริมาณ",
        table3: "อัตราแลกเปลี่ยน",
        table4: "แลกเปลี่ยนสกุลเงิน",
        table5: "ใบเสร็จ",
        table6: "เวลา",
        title15: "จาก",
        title16: "ขณะนี้ไม่มีเนื้อหาให้เลือก โปรดเลือกรายการอื่น"
    },
    fundTransfer: {
        title1: "โอนเงินยังไง?",
        title2: "เลือกบัญชีกระแสรายวันที่ต้องการโอน",
        title3: "เลือกบัญชีที่คุณต้องการโอน",
        title4: "กรอกจำนวนเงินโอนแล้วคลิกส่งเพื่อดำเนินการโอนให้เสร็จสิ้น",
        title5: "สกุลเงิน",
        title6: "ปริมาณการโอน",
        title7: "กรุณากรอกจำนวนเงินที่ต้องการโอน",
        title8: "บันทึกการโอน",
        title9: "กรุณาเลือกประเภทกระเป๋าสตางค์",
        title10: "กรุณาเลือกสกุลเงิน",
        title11: "กรุณาเลือกประเภทกระเป๋าสตางค์",
        title12: "กรุณาเลือกสกุลเงิน",
        title13: "กรุณากรอกจำนวนเงินที่ต้องการโอน",
        title14: "ส่งเรียบร้อยแล้ว",
        table1: "โอนออกบัญชี",
        table2: "โอนเงิน",
        table3: "ปริมาณการโอน",
        table4: "โอนบัญชี",
        table5: "เวลา",
        table6: "โอนย้าย",
        table7: "การโอนเงิน",
        table8: "โอนไปที่",
        table9: "บันทึกการโอน",
        table10: "รายละเอียดการโอน",
        table11: "โอนสำเร็จ",
        table12: "การโอนล้มเหลว",
        table13: "บัญชีกระแสรายวันไม่สามารถโอนได้"
    },
    withdrawal: {
        title1: "ประกาศสำคัญ",
        title2: "1.เพื่อป้องกันการเก็งกำไร คุณสามารถสมัครถอนสกุลเงินได้เมื่อปริมาณธุรกรรมถึงโควต้า",
        title3: "2.ใบสมัครถอนเงินจะได้รับเครดิตภายใน 24 ชั่วโมงหลังจากส่ง หากไม่ได้รับเงินถอนหลังจากเวลาถอนโดยประมาณ โปรดปรึกษาฝ่ายบริการลูกค้าออนไลน์",
        title4: "3.หลังจากส่งใบสมัครถอนเงินอยู่ในสถานะหยุดนิ่งเนื่องจากอยู่ระหว่างการถอนเงินและระบบระงับเงินไว้ชั่วคราวไม่ได้หมายความว่าคุณสูญเสียทรัพย์สินหรือมีความผิดปกติกับทรัพย์สิน",
        title5: "สกุลเงิน",
        title6: "ที่อยู่กระเป๋าเงิน",
        title7: "จำนวนเหรียญที่ถอนออก",
        title8: "บันทึกการถอนเหรียญ",
        title9: "กรุณาเลือกสกุลเงิน",
        title10: "กรุณาเลือกประเภทโซ่",
        title101: "",
        title11: "กรุณาเข้า",
        title12: "ที่อยู่กระเป๋าเงิน",
        title13: "ส่งเรียบร้อยแล้ว",
        title14: "ภายใต้การทบทวน",
        title15: "ตรวจสอบสำเร็จ",
        title16: "การตรวจสอบล้มเหลว",
        title17: "เบิกจ่ายแล้ว",
        title18: "กรุณากรอกหรือวางที่อยู่กระเป๋าเงินของคุณ",
        title19: "กรุณากรอกจำนวนเงินที่ถอน",
        title20: "ค่าธรรมเนียมการจัดการ",
        title21: "มาถึงจริง",
        table1: "สกุลเงิน",
        table2: "จำนวนเหรียญที่ถอนออก",
        table3: "ชื่อลูกโซ่",
        table4: "ที่อยู่กระเป๋าเงิน",
        table5: "สถานะ",
        table6: "เหตุผล",
        table7: "เวลาสมัคร",
        table8: "ถอนเหรียญ",
        table81: "ถอนเหรียญ",
        table9: "ที่อยู่การถอนเงิน",
        table10: "โปรดเลือกสกุลเงินที่คุณต้องการถอน",
        table11: "กรุณาตรวจสอบให้แน่ใจว่าคุณเข้า",
        table12: 'ที่อยู่ (มักจะขึ้นต้นด้วย "0x")',
        table13: "เหรียญที่สามารถถอนได้ (หักค่าธรรมเนียมการจัดการ)：",
        table14: "เลือกสกุลเงิน",
        table15: "ประสบปัญหา? ข้อเสนอแนะทันที",
        table16: "สมดุล",
        table17: "รายละเอียดการถอนเงิน",
        password: "รหัสผ่าน",
        passwordTips: "กรุณากรอกรหัสผ่าน",
        passwordAg: "ยืนยันรหัสผ่าน",
        passwordAgTips: "กรุณากรอกรหัสผ่านอีกครั้ง",
        oldPassword: "รหัสผ่านเก่า",
        oldPasswordTips: "กรุณากรอกรหัสผ่านเก่า",
        newPassword: "รหัสผ่านใหม่",
        newPasswordTips: "กรุณากรอกรหัสผ่านใหม่",
        passwordNotSame: "รหัสผ่านไม่สอดคล้องกัน",
        withdrawPasswordSet: "ตั้งรหัสผ่านการถอนเงิน",
        withdrawPasswordModify: "เปลี่ยนรหัสผ่านการถอน",
        withdrawPassword: "ถอนรหัสผ่าน",
        withdrawPasswordTips: "กรุณากรอกรหัสผ่านการถอนเงิน",
        setWithdrawPasswordFirst: "กรุณาตั้งรหัสผ่านการถอนเงินก่อน",
        withdrawPasswordSetSuccess: "การติดตั้งที่ประสบความสำเร็จ",
        withdrawPasswordModifySuccess: "แก้ไขเรียบร้อยแล้ว",
        submit: "ส่ง",
    },
    customer: {
        content1: "บริการออนไลน์",
        content2: "บริการลูกค้า",
        content3: "กรุณากรอกข้อมูลการติดต่อของคุณ",
        content4: "กรุณากรอกเนื้อหา",
        content5: "ส่ง",
        content6: "การส่งล้มเหลว การเชื่อมต่อเครือข่ายล้มเหลว",
        content7: "รูปภาพ",
        content8: "ข้อความว่างเปล่า",
        content9: "ส่วนแบ่งของฉัน",
        content10: "แบ่งปันลิงค์",
        content11: "บันทึกรูปภาพ",
        content12: "รายได้ของฉัน",
        content13: "คำอธิบายระดับ",
        content14: "ขนาดทีม",
        content15: "รายได้จากคำเชิญ",
        content16: "คำอธิบายกฎ",
        content17: "ระดับสมาชิก",
        content18: "ยอดเติมเงินมากกว่า",
        content19: "ระดับทีม",
        content20: "ระดับทีมและรายได้",
        content21: "เพื่อให้เป็นไปตามเงื่อนไข",
        content22: "รายได้จากการจัดจำหน่าย",
        content23: "ทีมระดับ",
        content24: "ระดับคำเชิญ",
        content25: "สมาชิกที่ถูกต้อง",
        content26: "รายได้หลัก",
        content27: "รายได้รอง",
        content28: "รายได้ระดับ 3",
    },
    standardContract: {
        increaseMargin: "เพิ่มอัตรากำไรขั้นต้น",
        increaseAmount: "เพิ่มจำนวน",
        Pleaseenterthemargin: "กรุณากรอกจำนวนมาร์จิ้นที่ต้องการเพิ่ม",
        Pleaseenterthecorrect: "กรุณากรอกจำนวนเงินฝากที่ถูกต้อง",
        Increasemarginsuccessfully: "เพิ่มมาร์จิ้นสำเร็จ",
        takeProfitPriceWrong: "ขายทำกำไรผิดราคา",
        stoppriceerror: "หยุดข้อผิดพลาดราคา",
        thetakeprofit1: "ราคาขายทำกำไรจะต้องสูงกว่าราคาตลาด",
        thetakeprofit2: "ราคาหยุดขาดทุนจะต้องต่ำกว่าราคาตลาด",
        thetakeprofit3: "ราคาทำกำไรจะต้องต่ำกว่าราคาตลาด",
        thetakeprofit4: "ราคาหยุดขาดทุนจะต้องสูงกว่าราคาตลาด",
        thetakeprofit5: "ปริมาณไม่ถูกต้อง",
        estimatedprofitloss: "ประมาณการกำไรและขาดทุน",
        positionAmount: "จำนวนตำแหน่ง",
        closeAmount: "ปริมาณปิด",
        whenthelatest: "เมื่อถึงราคาล่าสุดแล้ว",
        whenthelatest2: "คำสั่ง Take Profit ในราคาตลาดจะถูกกระตุ้นให้ปิดสถานะปัจจุบัน กำไรและขาดทุนที่คาดหวัง",
        whenthelatest3: "คำสั่งหยุดการขาดทุนของตลาดจะถูกกระตุ้นให้ปิดสถานะปัจจุบัน กำไรและขาดทุนที่คาดหวัง",
        contract: "สัญญา",
        ordercanceledsuccessfully: "ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว",
        successfullyordered: "สั่งซื้อสำเร็จแล้ว",
        positionopeningreminder: "การแจ้งเตือนการเปิดตำแหน่ง",
        wrongquantity: "ปริมาณไม่ถูกต้อง",
        quantitycannot: "ปริมาณต้องไม่มากกว่า",
        modificationstoploss: "การปรับเปลี่ยน Stop Profit และ Stop Loss ประสบความสำเร็จ",
        positionclosedsuccessfully: "ปิดตำแหน่งเรียบร้อยแล้ว",
        orderCancellation: "การยกเลิกคำสั่งซื้อ",
        orderCancellation2: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อ",
        tobeexecuted: "ที่จะถูกดำเนินการ",
        expired: "หมดอายุแล้ว",
        failed: "ล้มเหลว",
        contractTransaction: "สัญญาถาวร",
        increase: "เพิ่มขึ้น",
        openPosition: "โกดังเต็ม",
        isolatedPosition: "ตำแหน่งที่โดดเดี่ยว",
        limitOrder: "ขีด จำกัด ราคา",
        marketOrder: "ราคาตลาด",
        pleaseSelectLeverage: "โปรดเลือกเลเวอเรจ",
        pleaseEnterQuantity: "กรุณากรอกจำนวน",
        canOpenMore: "ตำแหน่งสูงสุดที่สามารถเปิดได้",
        contractAmount: "จำนวนเงินตามสัญญา",
        openingFee: "ค่าธรรมเนียมการจัดการ",
        currentPosition: "ตำแหน่ง",
        historicalPositions: "ธุรกรรมในอดีต",
        currentCommission: "คำสั่งซื้อปัจจุบัน",
        historicalCommission: "คณะกรรมการประวัติศาสตร์",
        buyPrice: "ราคาซื้อ",
        income: "กำไร",
        quantity: "ปริมาณ",
        marginRate: "อัตรากำไรขั้นต้น",
        initialMargin: "อัตรากำไรขั้นต้น",
        estimatedPriceParity: "ราคาบังคับชำระบัญชี",
        operate: "ดำเนินงาน",
        finishQuantity: "ปริมาณธุรกรรม",
        averagePrice: "ราคาซื้อขายเฉลี่ย",
        pleaseEnterLeverage: "กรุณาใส่เลเวอเรจ",
        takeProfitAndStopLoss: "TP/SL",
        takeProfit: "TP",
        stopLoss: "SL",
        openLong: "Long",
        openShort: "Short",
        liquidation: "ปิดตำแหน่ง",
        marketLquidation: "ราคาตลาดคงที่",
        cancel: "ยกเลิกคำสั่งซื้อ",
        enterBuyPrice: "กรุณากรอกราคาซื้อ",
        areYouSureLquidation: "คุณแน่ใจหรือว่าจะปิดตำแหน่ง??",
        confirm: "แน่นอน",
        enterStopWinPrice: "กรุณากรอกราคาขายทำกำไร",
        enterStopLossPrice: "กรุณากรอกราคาหยุดขาดทุน",
        commissionTime: "เวลาคอมมิชชั่น",
        commissionPrice: "ราคาคอมมิชชั่น",
        commissionQuantity: "จำนวนคอมมิชชั่นทั้งหมด",
        volumeAlreadyTraded: "จำนวนเงินที่เสร็จสมบูรณ์",
        areYouSureToWinOrLoss: "คุณแน่ใจหรือไม่ว่าต้องการหยุดกำไรและหยุดการขาดทุน?",
        maxQuantity: "ตำแหน่งสูงสุด",
        saleQuantity: "ปิดตำแหน่งแล้ว",
        salePrice: "ราคาปิดเฉลี่ย",
        saleTime: "เวลา",
        succeeded: "ที่ประสบความสำเร็จ",
        cancelled: "ยกเลิก",
        piece: "เปิด",
        triggerPrice: "ราคาทริกเกอร์",
        setWin: "ตั้งค่าทำกำไร",
        setLoss: "ตั้งค่าหยุดการสูญเสีย",
        enterWinQuantity: "กรุณากรอกจำนวนการทำกำไร",
        enterLossQuantity: "กรุณากรอกจำนวนหยุดการสูญเสีย",
        planCommission: "คอมมิชชั่นแผน",
        enterWinTriggerPrice: "โปรดป้อนราคาทริกเกอร์จุดทำกำไร",
        enterLossTriggerPrice: "โปรดป้อนราคาทริกเกอร์จุดหยุดขาดทุน",
        insufficientQuantity: "ปริมาณไม่เพียงพอ",
        enterTriggerPrice: "กรุณากรอกราคาทริกเกอร์",
        tips1: "ราคาคำสั่งซื้อของคุณสูงกว่าราคาปัจจุบัน และธุรกรรมจะดำเนินการโดยตรงที่ราคาตลาดปัจจุบัน คุณแน่ใจหรือไม่ว่าต้องการซื้อ？",
        tips2: "ราคาคำสั่งซื้อของคุณต่ำกว่าราคาปัจจุบัน และธุรกรรมจะดำเนินการโดยตรงที่ราคาตลาดปัจจุบัน คุณแน่ใจหรือไม่ว่าต้องการซื้อ？",
        type: "พิมพ์",
        increaseQuantity: "เพิ่มตำแหน่ง",
        reduceQuantity: "ลดตำแหน่ง",
        limitCommission: "คำสั่งจำกัด",
        tips3: "ราคาหยุดขาดทุนจะต้องต่ำกว่าราคาตลาด",
        tips4: "ราคาขายทำกำไรจะต้องสูงกว่าราคาตลาด",
        tips5: "ราคาหยุดขาดทุนจะต้องสูงกว่าราคาตลาด",
        tips6: "ราคาทำกำไรจะต้องต่ำกว่าราคาตลาด",
        tips7: "ราคาหยุดขาดทุนควรต่ำกว่าราคาตลาดและต่ำกว่าราคาคำสั่งซื้อ",
        tips8: "ราคาขายทำกำไรควรมากกว่าราคาคำสั่งซื้อ (อาจน้อยกว่าราคาตลาด)",
        tips9: "ราคาหยุดขาดทุนควรมากกว่าราคาตลาดและมากกว่าราคาคำสั่งซื้อ",
        tips10: "ราคาขายทำกำไรควรน้อยกว่าราคาคำสั่งซื้อ (สามารถมากกว่าราคาตลาดได้)",
        accountEquity: "ยอดเงินในบัญชี",
        unrealizedPL: "กำไรหรือขาดทุนที่ยังไม่เกิดขึ้นจริง",
        tips11: "คุณแน่ใจหรือว่าคุณพูดถูก",
        tips12: "ราคาตลาด",
        tips13: "ปิดทุกตำแหน่ง",
        tips14: "อย่าเตือนอีกเลย",
        profitRate: "อัตราการปิดของผลตอบแทน",
        openTime: "เวลาเปิดทำการ",
        unwindTime: "เวลาปิด",
        dealTime: "เวลาทำธุรกรรม",
        amountClose: "จำนวนตำแหน่งที่ปิด",
        long: "Long",
        short: 'Short',
        orderQuantity: "ปริมาณการสั่งซื้อ",
        entrustedMargin: "อัตรากำไรขั้นต้นที่ได้รับมอบหมาย",
    },
    spotGoods: {
        spotGoods: "แลกเปลี่ยน",
        sellPrice: "ราคาขาย",
        orderRecord: "บันทึกการไถ่ถอนแฟลช",
        transactionTime: "เวลาทำธุรกรรม",
        maxBuy: "สามารถซื้อได้",
        maxSell: "พร้อมจำหน่าย",
        purchaseQuantity: "ปริมาณการซื้อ",
        slippage: "เลื่อนหลุด",
        convertTips: "เราจะปิดธุรกรรมในราคาที่ดีที่สุด โดยมี Slippage 0-5%。",
        changePrice: "ราคาแลกเปลี่ยนปัจจุบัน",
        consume: "บริโภค",
        get: "รับ",
        changeTips: "คุณแน่ใจหรือไม่ว่าต้องการแลก?？",
        confirm: "ยืนยันการแลกรางวัล"
    },
    news: {
        title: "ศูนย์ข่าว",
        redMore: "อ่านเพิ่มเติม",
    },
    credit: {
        credit: "เครดิต",
        creditScore: "คะแนนเครดิตทั้งหมด",
        latestEntry: "บันทึกล่าสุด",
        liveUpdate: "อัปเดตสด",
        systemEvaluation: "การประเมินระบบ",
        time: "วันที่",
        name: "ชื่อ",
        reason: "เหตุผล",
        scoreStory: "บันทึกคะแนนเครดิต"
    },
    borrowing: {
        borrowing: "เงินกู้",
        diversifiedMarket: "ตลาดที่หลากหลาย",
        totalSupply: "อุปทานทั้งหมด",
        totalBorrowings: "การกู้ยืมทั้งหมด",
        tips1: "นี่คือจำนวนเงินทั้งหมดที่คุณสามารถยืมจากหลักประกันของคุณได้ โดยขึ้นอยู่กับวงเงินการกู้ยืม",
        tips2: "อัตราดอกเบี้ยที่มั่นคงของคุณจะยังคงเท่าเดิมตลอดอายุเงินกู้ของคุณ แนะนำสำหรับอุปทานระยะยาวและผู้ใช้ที่ชอบการคาดการณ์ได้",
        totalSupplys: "อุปทานทั้งหมด",
        supplyAPR: "อัตราอุปทาน",
        totalBorrowings: "รวมการกู้ยืม",
        borrowAPR: "อัตราการกู้ยืม",
        check: "ตรวจสอบ",
        market: "ตลาด",
        availableLiquidity: "สภาพคล่องที่มีอยู่",
        currencyPrice: "ราคาสกุลเงินปัจจุบัน",
        supplyAssets: "จัดหาสินทรัพย์",
        tips3: "หมายเหตุ: อัตราดอกเบี้ยด้านล่างเป็นอัตราดอกเบี้ยคงที่ หลังจากพ้นระยะเวลาการจัดหา เงินต้นบวกรายได้จะถูกส่งกลับไปยังบัญชีของคุณ",
        supplyCycle: "วงจรอุปทาน",
        minimumSupply: "อุปทานขั้นต่ำ",
        supply: "จัดหา",
        borrowedAssets: "สินทรัพย์ที่ยืมมา",
        tips4: "สิ่งสำคัญที่ควรทราบ: หากต้องการยืมเงิน คุณจะต้องแสดงสินทรัพย์หรือหลักฐานหลักประกันใดๆ",
        tips5: "โปรดดูคำอธิบายทรัพย์สินจำนอง。",
        repaymentCycle: "รอบการชำระคืน",
        BorrowableAmount: "จำนวนเงินกู้ที่มีอยู่",
        borrow: "เงินกู้",
        accountInformation: "ข้อมูลเกี่ยวกับบัญชี",
        walletBalance: "ยอดคงเหลือในกระเป๋าสตางค์",
        canSupply: "มีอยู่",
        AmountCanBeBorrowed: "จำนวนเงินกู้ทั้งหมดที่มีอยู่",
        borrowedAmount: "จำนวนเงินที่ยืม",
        remainingAmount: "ยอดคงเหลือ",
        getBorrowednAmount: "รับวงเงินสินเชื่อ",
        supplyOrder: "ใบสั่งจัดหา",
        borrowedOrder: "คำสั่งสินเชื่อ",
        supplyAmount: "ปริมาณการจัดหา",
        expectedProfits: "ผลตอบแทนที่คาด",
        supplyTime: "เวลาในการจัดหา",
        expirationTime: "วันที่หมดอายุ",
        borrowingAmount: "จำนวนเงินกู้",
        dueRepayment: "จำนวนเงินชำระคืน",
        borrowingTime: "เวลาวางจำหน่าย",
        repaymentTime: "ระยะเวลาการชำระคืน",
        repay: "การชำระคืน",
        supplyCurrency: "สกุลเงินอุปทาน",
        buyNow: "ซื้อตอนนี้",
        supplyRecords: "บันทึกการจัดหา",
        borrowRecords: "บันทึกสินเชื่อ",
        completed: "สมบูรณ์",
        borrowNow: "ยืมเลย",
        borrowCurrency: "สกุลเงินที่ยืม",
        borrowMin: "เล็กที่สุด",
        borrowMax: "ขีดสุด",
        borrowRange: "จำนวนเงินกู้ (ขั้นต่ำ/สูงสุด)",
        tips6: "กรุณาชำระให้ตรงเวลา หากเกินกำหนด จะมีการเรียกเก็บเงินรายวันเพิ่มเติม (เงินต้น + ดอกเบี้ย)",
        tips7: "สำหรับค่าธรรมเนียมล่าช้า。",
        pleaseEnterBorrowAmount: "กรุณากรอกจำนวนเงินกู้",
        interest: "ความสนใจ",
        tips8: "คุณแน่ใจหรือไม่ว่าต้องการชำระคืนล่วงหน้า?",
        borrowChannel: "ช่องทางการยืม",
        tips9: "มาเริ่มทำความรู้จักกันก่อนเลย",
        name: "ชื่อ",
        lastName: "นามสกุล",
        birthDate: "วันเกิด",
        tips10: "ข้อมูลเพิ่มเติมอีกเล็กน้อย ที่อยู่ของคุณคืออะไร?",
        familyAddress: "ที่อยู่บ้าน (รวมถึงหมายเลขยูนิต)",
        city: "เมือง",
        country: "ชาติ",
        postalCode: "รหัสไปรษณีย์",
        pleaseEnterYourHomeAddress: "กรุณากรอกที่อยู่บ้านของคุณ",
        tips11: "บอกเราเกี่ยวกับสถานการณ์ทางการเงินของคุณ",
        tips12: "เราอาจจำเป็นต้องยืนยันข้อมูลนี้ในภายหลัง ดังนั้นโปรดพยายามทำให้ถูกต้องที่สุด",
        yourMonthlyIncome: "รายได้ต่อเดือนของคุณ",
        enterYourMonthlyIncome: "กรุณากรอกรายได้ต่อเดือนของคุณ",
        extraIncomeOptional: "รายได้เพิ่มเติม (ไม่จำเป็น)",
        enterExtraIncome: "กรุณากรอกรายได้เพิ่มเติมของคุณ",
        monthlyRentOrMortgagePayment: "ค่าเช่ารายเดือนหรือการชำระเงินจำนอง",
        enterMonthlyRent: "กรุณากรอกค่าเช่ารายเดือนหรือการชำระเงินจำนองของคุณ",
        tip13: "แจ้งให้เราทราบหากคุณมีจำนอง",
        tip14: "หากไม่มีการเลือกการค้ำประกันการจำนอง ความน่าจะเป็นที่จะผ่านการตรวจสอบจะต่ำ",
        isThereMortgage: "มีการจำนองหรือไม่?",
        selectIsThereMortgage: "กรุณาเลือกว่าจะมีการจำนองหรือไม่",
        selectMortgageType: "กรุณาเลือกประเภทการจำนอง",
        yes: "ใช่",
        no: "เลขที่",
        uploadScreenshotOfTransaction: "กรุณาอัพโหลดภาพหน้าจอการทำธุรกรรม",
        tip15: "มาติดต่อกันกันเถอะ",
        tip16: "เราอาจติดต่อคุณที่หมายเลขนี้หากเราต้องการข้อมูลเพิ่มเติมเกี่ยวกับการสมัครสินเชื่อของคุณ",
        tip17: "ฉันได้อ่านและลงนามความยินยอมแบบอิเล็กทรอนิกส์แล้ว",
        tip18: "ข้อกำหนดการใช้งานและความยินยอมทางอิเล็กทรอนิกส์",
        tip19: "，รวมถึงความยินยอมของคุณให้เราส่งข้อมูลเกี่ยวกับเราให้กับคุณ",
        tip20: "ข้อกำหนดการใช้งานผลิตภัณฑ์และบริการ",
        tip21: "หลังจากกรอกข้อมูลแล้วกรุณารอการประเมินและทบทวนระบบ",
        phoneNumber: "หมายเลขโทรศัพท์",
        enterPhoneNumber: "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
        tip22: "โปรดทำเครื่องหมายในช่องเพื่อยอมรับข้อกำหนดการใช้งานและแบบฟอร์มยินยอมทางอิเล็กทรอนิกส์",
        inReview: "ภายใต้การทบทวน",
        applicationAmount: "นำมาใช้",
        reasonForRejection: "เหตุผลในการปฏิเสธ",
        reapply: "สมัครใหม่",
        applyStatus: "สถานะการสมัคร",
        currentOrder: "คำสั่งซื้อปัจจุบัน",
        interestRate: "อัตราดอกเบี้ย"
    },
    yuebao: {
        filed1: "ลงทุน",
        filed2: "เอาออก",
        filed3: "รายได้รายวัน",
        filed4: "การเร่งความเร็วของทีม",
        filed5: "ฝากแล้ว",
        filed6: "ผลประกอบการเมื่อวาน",
        filed7: "รายได้รวม",
        filed8: "เงินทุนที่มีอยู่",
        filed9: "กรุณากรอกจำนวนเงิน",
        filed10: "การทำฟาร์ม",
        filed11: "การแนะนำ",
        field12: "ราคาซื้อขั้นต่ำ",
        field13: "มากที่สุดที่คุณสามารถซื้อได้",
        filed14: "สมัครสมาชิก",
        filed15: 'ปกติ',
        filed16: 'อัตราดอกเบี้ยรายปี',
    },
    tipsPopover: {
        title: "ติดตั้งแอปพลิเคชั่นนี้",
        press: "ตาม",
        and: "และ",
        scrren: "เพิ่มไปที่หน้าจอหลัก",
        hasInstall: "(หากติดตั้งแล้วกรุณาปิดหน้าต่าง)",
    },
    follow: {
        title1: "แผนการติดตามผล",
        follow_text1: "เริ่มดำเนินการตามคำสั่ง",
        follow_text2: "ประวัติการเปิดตัว",
        follow_text3: "ชื่อ",
        follow_text4: 'คู่การซื้อขาย',
        follow_text5: 'ระยะเวลาการซื้อ',
        follow_text6: 'เวลาสั่งซื้อ',
        follow_text7: 'เวลาปล่อย',
        follow_text8: 'จำนวนผู้ติดตาม',
        follow_text9: 'จำนวนสั่งซื้อ',
        follow_text10: 'ดำเนินงาน',
        follow_text11: 'เชิญ',
        follow_text12: 'ปฏิบัติตามทิศทางการสั่งซื้อ',
        follow_text13: 'กำหนดเงื่อนไขการสั่งซื้อ',
        follow_text14: 'เงื่อนไขการสั่งซื้อดังต่อไปนี้',
        follow_text15: 'จำนวนเงินคงที่',
        follow_text16: 'เปอร์เซ็นต์',
        follow_text17: 'คนที่ได้รับเชิญ',
        follow_text18: 'ID ของอีกฝ่าย',
        follow_text19: "ยืนยันปฏิบัติตามคำสั่ง",
        follow_text20: "จำนวนการสั่งซื้อของคุณ (ไม่บังคับ)",
        follow_text21: "กรุณากรอกชื่อ",
        follow_text22: "กรุณาเลือกคู่การซื้อขาย",
        follow_text23: "กรุณาเลือกทิศทางการสั่งซื้อ",
        follow_text24: "กรุณาเลือกระยะเวลาการซื้อ",
        follow_text25: "กรุณาเลือกเวลาสั่งซื้อ",
        follow_text26: "กรุณาเลือกจำนวนการซื้อ",
        follow_text27: "ปริมาณการซื้อสูงสุดต้องไม่ต่ำกว่าปริมาณการซื้อขั้นต่ำ",
        follow_text28: "การซื้อเข้าขั้นต่ำ",
        follow_text29: "ส่วนใหญ่ซื้อ",
        follow_text30: "สร้างคำสั่งคัดลอกสำเร็จ",
        follow_text31: "รายการคู่การซื้อขาย",
        follow_text32: "ทำตามคำสั่งไปแล้ว",
        follow_text33: "กรุณากรอกข้อมูลผู้เชิญ",
        follow_text34: "เชิญ",
        follow_text35: "ชวนฉัน",
        follow_text36: "การคัดลอกประวัติ",
        follow_text37: "ช่วงจำนวนการสั่งซื้อ",
        follow_text38: "กรุณากรอกรหัสการสั่งซื้อ",
    },
    followHistory: {
        title1: 'ประวัติการเปิดตัว',
        title2: "การคัดลอกประวัติ",
        follow_h_text1: "ยอดรวมของการสั่งซื้อ",
        follow_h_text2: "จำนวนคนที่ติดตามออร์เดอร์ทั้งหมด",
        follow_h_text3: "จำนวนการเผยแพร่",
        follow_h_text4: "อัตราการชนะ",
        follow_h_text5: "จำนวนครั้งในการปฏิบัติตามคำสั่ง",
        follow_h_text6: "กำไรจากการสั่งซื้อต่อไปนี้",
        follow_h_text7: "ทิศทาง",
        follow_h_text8: "ชนะ",
        follow_h_text9: "การขาดดุล",
    },
    "asset.index.1579E8B41F8D5134": "ทรัพย์สินของฉัน",
    "asset.index.B3F6F05Dfbe431Cd": "การจำลอง",
    "asset.index.B9Aeab4Ee8F33746": "การประเมินมูลค่าสินทรัพย์",
    "asset.index.583Df8Bd541Eb7E8": "แนวโน้มรายได้",
    "asset.index.B1254815D133Cc26": "7 วัน",
    "asset.index.2F615F6C029F01B7": "30 วัน",
    "asset.index.29439Fb58E4Bbe22": "ถอน",
    "asset.index.831Ab31568A78285": "เติม",
    "asset.index.39F7A0D48D12E8C9": "โอนย้าย",
    "asset.index.B99063C5689Beaec": "แลกเปลี่ยน",
    "asset.index.E1Dc620F2F038B2A": "รับเงินทุน",
    "asset.index.972A0B4C2B4393D0": "บัญชีของฉัน",
    "asset.index.9Dfb0Fb334620733": "ยอดเงินคงเหลือ",
    "asset.index.Cdc5Fbd26790Cb47": "ปริมาณแช่แข็ง",
    "asset.index.3D8132D72Ae965Cd": "การประเมินมูลค่า",
    "asset.receive.825503Cc430559Cb": "ได้รับสินทรัพย์",
    "asset.receive.54154A0553A535B7": "สินทรัพย์สาธิต",
    "asset.receive.F2E57B00A9C5D129": "1.สินทรัพย์นี้ได้รับอนุญาตให้ใช้ในโหมดบัญชีทดลองเท่านั้น",
    "asset.receive.Ea0D1D52989299Bd": "2.เพื่อป้องกันการละเมิด อนุญาตให้แลกได้เพียงครั้งเดียวภายในหนึ่งเดือน",
    "asset.receive.090E0037Aa235D3D": "3.การรับสินทรัพย์จะเพิ่มจำนวนสินทรัพย์ที่ได้รับตามเดิมและจะไม่เปลี่ยนสถานะตำแหน่ง",
    "asset.receive.7Fd4E1Abc805C0A6": "4.หากคุณมีคำถามอื่น ๆ โปรดติดต่อฝ่ายบริการลูกค้า",
    "asset.receive.Df5B3A511D986575": "รับสินทรัพย์สาธิตทันที",
    "asset.records.1Fa02E8187A39592": "สามเดือนที่ผ่านมา",
    "asset.records.7B291C37333Fe34D": "จากใกล้ไปไกล",
    "asset.records.A476Cd1Ec868Fc5F": "สามเดือนที่ผ่านมา,",
    "asset.records.9D5755A842E55Bb7": "จากใกล้ไปไกล,",
    "asset.records.E3Fa05E607203Cdc": "เติม",
    "asset.records.B4F206C6Bec08Dea": "ถอน",
    "asset.index.Df5B3A511D986576": "คุณได้รับเนื้อหาสาธิตเรียบร้อยแล้ว",
    "deposit.depositSpeedy.Efe81D0E0174239B": "วิธีการชำระเงิน",
    "deposit.depositSpeedy.B9293Ee96E435F85": "สกุลเงินเฟียต",
    "deposit.depositSpeedy.16658A855F07D171": "จำนวน",
    "deposit.depositSpeedy.204Ffab8A6E01870": "แน่นอน",
    "deposit.depositSpeedy.22E5Dfb74Ead8Aa9": "ไม่สามารถเว้นว่างได้",
    "deposit.depositSpeedy.B8E774D0E4E5E4C1": "การเติมเงินขั้นต่ำ",
    "deposit.depositSpeedy.F169D816F6Dd83C5": "การเติมเงินสูงสุด",
    "deposit.depositWallet.F64Ec60B1Db4A6D6": "ฝากเงิน USDT",
    "deposit.depositWallet.551640C76F4Ca4A1": "เติมเงินสกุลเงิน",
    "deposit.depositWallet.B404C543712B71D5": "เครือข่ายเติมเงิน",
    "deposit.depositWallet.A484B0F5E94B3F4F": "ที่อยู่การฝากเงิน",
    "deposit.depositWallet.D3980D54Acf242Db": "บันทึกรหัส QR",
    "deposit.depositWallet.A06E84801D6582Be": "จำนวนการเติมเงิน",
    "deposit.depositWallet.Daaaeb1B7B22B126": "คำใบ้",
    "deposit.depositWallet.D599E40E1Eeec1B3": "เติมเงินสำเร็จ",
    "deposit.depositWallet.4F48Abbafce532Bb": "ส่งสำเร็จแล้ว กำลังรอการตรวจสอบการบริการลูกค้า",
    "deposit.depositWallet.A88C481228811696": "คุณปฏิเสธที่จะเปลี่ยนเครือข่าย",
    "deposit.depositWallet.C6Ebf27895C21932": "โปรดเปิดปลั๊กอินกระเป๋าสตางค์ TRON ด้วยตนเองและเข้าสู่ระบบ",
    "deposit.index.B5491C8Dd09D8183": "เลือกสกุลเงินที่คุณต้องการเติม",
    "deposit.index.2F784B2298D39987": "เติมเงินด่วน",
    "deposit.index.0Daa03Dcdcabd837": "ลิงค์นอกสถานที่",
    "withdraw.bottomSheet.628A63056Ef2D2Fe": "การยืนยันการถอนเงิน",
    "withdraw.bottomSheet.A086Fa20082C849D": "โปรดตรวจสอบให้แน่ใจว่าข้อมูลด้านล่างนี้ถูกต้อง",
    "withdraw.bottomSheet.Bf8B184D32971501": "เครือข่ายการถอนเงิน",
    "withdraw.bottomSheet.8758Fd50C87D6C9C": "ที่อยู่",
    "withdraw.bottomSheet.F9Db93B87E08763B": "ปริมาณ",
    "withdraw.bottomSheet.4Ad26475002878C0": "ค่าธรรมเนียมการจัดการ",
    "withdraw.index.A96454041169Af6D": "เลือกสกุลเงิน",
    "withdraw.index.2A563B7081Dd5B83": "ที่อยู่การถอนเงิน",
    "withdraw.index.B189C2Ef713Cfff4": "จำนวนเหรียญที่ถอนออก",
    "withdraw.index.558F35140E84B562": "มีอยู่：",
    "withdraw.index.F4E759087E12Cb77": "ถอนทั้งหมด",
    "withdraw.index.5Cbd9A6B284D25Ae": "รหัสผ่านกองทุน",
    "withdraw.index.B89Cbe4Bfc33Bb41": "ค่าธรรมเนียมการจัดการ:",
    "withdraw.index.C886De8D8A27026E": "ประกาศสำคัญ",
    "withdraw.index.Eac7C5A4095F5606": "1.เพื่อป้องกันการเก็งกำไร คุณสามารถสมัครถอนสกุลเงินได้เมื่อปริมาณธุรกรรมถึงโควต้า",
    "withdraw.index.C3Cc7Fff24504Be9": "2.ใบสมัครถอนเงินจะได้รับเครดิตภายใน 24 ชั่วโมงหลังจากส่ง หากไม่ได้รับเงินถอนหลังจากเวลาถอนที่คาดไว้ โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์",
    "withdraw.index.0B4Ad7Ccdc833B0D": "3.หลังจากส่งใบสมัครถอนเงินจะอยู่ในสถานะหยุดนิ่งเนื่องจากอยู่ระหว่างการถอนเงินและระบบระงับเงินไว้ชั่วคราวไม่ได้หมายความว่าคุณสูญเสียทรัพย์สินหรือมีความผิดปกติกับทรัพย์สิน",
    "withdraw.index.4639F3A6E07C00B3": "ขั้นตอนต่อไป",
    "withdraw.index.81Fba0D65Cc5C3Aa": "กรุณากรอกหรือวางที่อยู่กระเป๋าเงินของคุณ",
    "withdraw.index.25768141C8Bdea91": "กรุณากรอกจำนวนเงินที่ถอน",
    "withdraw.index.97A85734Cd1B7Bf0": "กรุณากรอกรหัสผ่านกองทุน",
    "withdraw.index.39C7D74B33241C78": "จำนวนเงินที่ถอนไม่ถูกต้อง",
    "withdraw.index.86A5D17908197525": "ยืนยันการถอน รอการตรวจสอบเพื่อปล่อยเหรียญ",
    "withdraw.index.48Fb603C6638C7F6": "กรุณาตั้งรหัสผ่านกองทุน",
    "withdraw.index.873Ade9A3Bacc2F7": "คำใบ้",
    "bill.index.5Bbb2A6Ac68D6B2E": "บัญชีจริง",
    "bill.index.75751E0Eb8261C40": "บัญชีทดลอง",
    "bill.index.Cbc853B37Ecc2E97": "ประเภทการเปลี่ยนแปลงบัญชี",
    "bill.index.4A0Cacddeb2E38B1": "ประเภทบัญชี",
    "bill.index.F16217028E098B2F": "สกุลเงิน",
    "bill.index.A620Dbe6F06B78Ba": "ทุกประเภท",
    "bill.index.2C3C148Bb94D9B3F": "บัญชีทั้งหมด",
    "c2C.index.Ab45695E4Bf1E382": "ธุรกรรม C2C",
    "c2C.index.2702Dc911Dfea762": "ฉันต้องการที่จะซื้อ",
    "c2C.index.D737D5B8367A53C4": "ฉันต้องการขาย",
    "c2C.index.C0C540A3Ba9Abe01": "ปริมาณ",
    "c2C.index.D8644E8D60C8Bd8A": "ราคาต่อหน่วย",
    "c2C.index.Ebb8670B203D3604": "ขีด จำกัด",
    "c2C.index.F8C6245A2Ebf1D27": "บัตรธนาคารทั้งหมด",
    "c2C.index.F8C6245A2Ebf1D28": "การรวบรวมสกุลเงิน",
    "c2C.index.F8C6245A2Ebf1D29": "บัตรเครดิตธนาคาร",
    "c2C.index.Cc3Aa8141Da9Ec9E": "ซื้อ",
    "c2C.index.Cc3Aa8141Da9Ec9F": "ขาย",
    "c2C.index.67A39834582Ad99A": "ไม่มีข้อมูล",
    "c2C.order.04C23810B47F77F7": "ตามจำนวน",
    "c2C.order.6905365902E0A73D": "ตามปริมาณ",
    "c2C.order.3F0Ecebbd9D2F23B": "มีอยู่",
    "c2C.order.16853Bda54120Bf1": "ทั้งหมด",
    "c2C.order.Ad3335796F2C95F7": "เงินก้อน",
    "c2C.order.61092E27A6879318": "เพื่อปกป้องความปลอดภัยของทรัพย์สิน โปรดเพิ่มความตระหนักในการป้องกัน!",
    "c2C.order.0F51881F0Fb920B2": "ข้อมูลการซื้อขาย",
    "c2C.order.Dd74Ceca85E5Bc65": "กำหนดเวลาการชำระเงิน",
    "c2C.order.De3341388A59073F": "30 นาที",
    "c2C.order.D334B597A352167F": "ชื่อเล่นผู้ขาย",
    "c2C.order.D334B597A352167G": "ชื่อเล่นผู้ซื้อ",
    "c2C.order.9D5F89F99Ced890D": "วิธีการทำธุรกรรม",
    "c2C.order.8Adf755B14Bc6B7C": "โปรดอ่านข้อความต่อไปนี้ก่อน",
    "c2C.order.686B16F454A7338B": "อย่าสังเกตใด ๆ เมื่อทำการโอนเงินผ่านบัตรธนาคาร มิฉะนั้นเงินจะไม่ถูกปล่อยและบัญชีจะถูกบล็อกโดยตรง หลังจากการชำระเงิน คุณจะต้องจัดเตรียมไดอะแกรมรายละเอียดธุรกรรมใหม่หลังการชำระเงิน (หากมีการรายงานไดอะแกรม P หรือรายละเอียดธุรกรรมที่ซ่อนอยู่ไปยังแพลตฟอร์มเพื่อระงับบัญชี)",
    "c2C.order.9Bec8Fba867B739B": "เลือกวิธีการชำระเงิน",
    "c2C.order.Cf2D892C419Fea36": "ซื้อขั้นต่ำ",
    "c2C.order.7290A6B7456A03E0": "การซื้อที่ใหญ่ที่สุด",
    "c2C.orderConfirm.F7E99B8C203E2B07": "รายละเอียดการสั่งซื้อ",
    "c2C.orderConfirm.036D94Dc2D1Cf7D3": "มีการสร้างคำสั่งซื้อแล้ว",
    "c2C.orderConfirm.0F5433503F3845Ce": "กรุณาชำระเงินให้ผู้ขายภายในเวลานับถอยหลัง。",
    "c2C.orderConfirm.24C3Bcacdb85A451": " รอการชำระเงินของผู้ซื้อ ",
    "c2C.orderConfirm.8E8140D7Ab607B24": "ติดต่อผู้ขาย",
    "c2C.orderConfirm.8E8140D7Ab607B25": "ติดต่อผู้ซื้อ",
    "c2C.orderConfirm.Ec4D8722Ec15C813": "ขณะนี้สกุลเงินดิจิทัลของผู้ขายได้ฝากไว้ในบัญชีเอสโครว์แล้ว โปรดอย่าลังเลที่จะชำระเงิน  ",
    "c2C.orderConfirm.69D1Fbbc7700C1Ab": "ชื่อจริงของผู้ซื้อ：",
    "c2C.orderConfirm.E5Ed8Ec53Edcd5D3": "การสนับสนุนการบริการลูกค้า 7x24 ชั่วโมง ",
    "c2C.orderConfirm.Abf9F4B8C93D641E": "หมายเลขคำสั่งซื้อ",
    "c2C.orderConfirm.726C51702F70C486": "เวลาสร้าง",
    "c2C.orderConfirm.E097Bb9B1216Bfd8": "ติดต่อฝ่ายบริการลูกค้า",
    "c2C.orderConfirm.103408Fbbe30287F": "ยกเลิกคำสั่งซื้อ",
    "c2C.orderConfirm.4E93Df1Fb521F4Ba": "ฉันได้ยืนยันการชำระเงินแล้ว",
    "c2C.orderConfirm.3B5418Dbea7Ebfe4": "จ่ายแล้ว",
    "c2C.orderConfirm.387Ca3625B260E4E": "คำสั่งซื้อที่ชำระเงินของคุณ",
    "c2C.orderConfirm.7C83D5F1Db1A08B7": "ยกเลิกธุรกรรม",
    "c2C.orderConfirm.76C86566Cc3751C0": "ยกเลิกคำสั่งซื้อแล้ว",
    "c2C.orderConfirm.205B349751D176B4": "การชำระเงินสำเร็จ",
    "c2C.paymentAdd.6F2A7Dcc66E6Acba": "วิธีการชำระเงิน",
    "c2C.paymentAdd.C87E865Df6800304": "การกำหนดค่าวิธีการชำระเงิน",
    "c2C.paymentAdd.B59Ae0F1B1C235Df": "ประเภทวิธีการชำระเงิน",
    "c2C.paymentAdd.06910Bddf002695F": "ชื่อจริง",
    "c2C.paymentAdd.3E33Ae3Efa7507Dd": "บัญชีเพย์พาล",
    "c2C.paymentAdd.3E33Ae3Efa7507De": "หมายเลขบัญชีธนาคาร/หมายเลขบัตร",
    "c2C.paymentAdd.3E33Ae3Efa7507Df": "ชื่อสกุลเงิน",
    "c2C.paymentAdd.595Ede91Abf6F6E0": "จ่ายรหัส QR",
    "c2C.paymentAdd.1Ecc8Be9Ba1C940A": "คลิกเพื่ออัพโหลด",
    "c2C.paymentAdd.6Daae340F2E9718A": "ชื่อธนาคาร",
    "c2C.paymentAdd.347751415C3Da489": "ชื่อลูกโซ่",
    "c2C.paymentAdd.15B3627Faddccb1D": "ข้อสังเกต",
    "c2C.paymentAdd.86Da96Cbd274058F": "คำเตือนที่อบอุ่น: เมื่อคุณขายสกุลเงินดิจิทัล ผู้ซื้อจะแสดงวิธีการชำระเงินที่คุณเลือก โปรดยืนยันว่ากรอกข้อมูลถูกต้อง",
    "c2C.paymentAdd.4Ce9979Bfb6576D9": "บันทึก",
    "c2C.paymentAdd.90D2A3A5C07179C0": "กรุณากรอกชื่อจริงของคุณ",
    "c2C.paymentAdd.A3B0Cd3Ad9Ca3475": "กรุณากรอกของคุณ",
    "c2C.paymentAdd.Ec389E6190Eedb62": "กรุณากรอกชื่อธนาคารของคุณ",
    "c2C.paymentAdd.9Be51Fb1E9025Fb2": "กรุณากรอกชื่อลูกโซ่ของคุณ",
    "c2C.paymentAdd.94F034F0E01439E0": "กรุณากรอกที่อยู่ของคุณ",
    "c2C.paymentAdd.B12E035663A42B32": "บัตรธนาคารทั้งหมด",
    "c2C.paymentAdd.C7B677F393A8F8Ac": "การรวบรวมสกุลเงิน",
    "c2C.paymentAdd.Abafe11737Bab7Cd": "กรุณาอัพโหลดรหัสการชำระเงิน",
    "c2C.paymentAdd.07C443212Ff04Bfb": "เพิ่มเรียบร้อยแล้ว",
    "c2C.paymentDetail.86Da96Cbd274058F": "คำเตือนที่อบอุ่น: เมื่อคุณขายสกุลเงินดิจิทัล ผู้ซื้อจะแสดงวิธีการชำระเงินที่คุณเลือก โปรดยืนยันว่ากรอกข้อมูลถูกต้อง",
    "c2C.paymentDetail.C4C613Da60226De4": "แก้ไขเรียบร้อยแล้ว",
    "c2C.paymentMethod.7609F7C8337C7A17": "วิธีการชำระเงิน C2C",
    "c2C.records.9E36893D5736Abb4": "รายการสั่งซื้อ",
    "c2C.records.4B53F9A5B13B3235": "ที่รอดำเนินการชำระเงิน",
    "c2C.records.4B53F9A5B13B3236": "ยกเลิกธุรกรรม",
    "c2C.records.4B53F9A5B13B3237": "จ่ายแล้ว",
    "contract.index.9706Df877458F0Be": "โกดังเต็ม",
    "contract.index.623Fc7D3D40Aa479": "อัตรากำไรขั้นต้น",
    "contract.index.F92Dce1169330387": "ราคาตลาดคงที่",
    "contract.index.3598B97Dd28Dbf20": "กรุณากรอกจำนวน (ชิ้น)",
    "contract.index.6E1Fae821Dc0B797": "ที่ยั่งยืน",
    "contract.index.Eb07Eb0C37C14575": "จัดส่ง",
    "contract.index.Eb6492F19B1C1Fb6": "รายละเอียดการทำธุรกรรมในอดีต",
    "contract.index.873Ade9A3Bacc2F7": "คำใบ้",
    "contract.index.Ff63B0F93D39F50B": "คุณแน่ใจหรือว่าคุณพูดถูก",
    "contract.index.Ff63B0F93D39F50D": "ยาวไป",
    "contract.index.Ff63B0F93D39F50E": "สั้น",
    "contract.index.Ff63B0F93D39F50F": "จัดการ",
    "contract.index.Ff63B0F93D39F50G": "ปิดทุกตำแหน่ง？",
    "customer.dialog.3D410C88E8A24Fe8": "ยืนยันชื่อเล่น",
    "customer.dialog.4B3340F7872B411F": "ยกเลิก",
    "customer.dialog.549B1456Bb5F98B3": "กรุณากรอกชื่อเล่นของคุณ",
    "customer.dialog.B773B3E45Ccfad00": "ชื่อเล่นว่างเปล่า",
    "customer.index.7308C6B849D159E9": "รายละเอียดรูปภาพ",
    "delivery.callDialog.C74F562C3Fe91Fe3": "สั่งซื้อสำเร็จแล้ว",
    "delivery.callDialog.B8C98F42Caa15Ca5": "ทิศทาง",
    "delivery.callDialog.B79A581Dae543974": "ซื้อนาน",
    "delivery.callDialog.B79A581Dae543975": "ซื้อระยะสั้น",
    "delivery.callDialog.3B26F0F7E90773F3": "ราคาเปิด",
    "delivery.callDialog.65Fb252Bd94E1039": "รายได้โดยประมาณ",
    "delivery.index.B483Ba4Fce633539": "จัดส่ง",
    "delivery.index.224Dd6Cb58D58249": "ระยะเวลาการซื้อขาย",
    "delivery.index.28158F517E902788": "การซื้อเข้าขั้นต่ำ",
    "delivery.index.A1232162B14Bec76": "ออเดอร์จัดส่ง",
    "delivery.index.445B1D3176D9C69D": "คำสั่งในอดีต",
    "delivery.index.Ab6Cb86E28653C5C": "จัดส่ง",
    "delivery.index.20A7A6F14D3698C0": "เวลาเปิดทำการ",
    "delivery.index.Ec6821A49395Ddc2": "เวลาปิด",
    "delivery.index.254Fdc665C391743": "ราคาปิด",
    "delivery.index.2A0C5E68B44A472A": "กำไรและขาดทุน",
    "delivery.index.E05B33309F6D236A": "กรุณากรอกจำนวน",
    "delivery.index.B2899E073Cb355D9": "ซื้อขั้นต่ำ",
    "download.description.869467A93C7Dd4A1": "หมายเหตุการติดตั้ง",
    "download.description.C80C1Edd6Bee12Bc": "1.อนุญาตให้ดาวน์โหลดไฟล์คำอธิบาย",
    "download.description.2F5Bc180F92642B4": "2.ดาวน์โหลดไฟล์คำอธิบายแล้ว",
    "download.description.3C3B849F6Ccf712F": "3.ป้อน [การตั้งค่า] บนโทรศัพท์ของคุณ จากนั้นไฟล์คำอธิบายที่ดาวน์โหลดมาจะแสดงอยู่ใต้ข้อมูลบัญชี",
    "download.description.86Affd862985E045": "4.คลิกเพื่อดาวน์โหลดไฟล์คำอธิบาย",
    "download.description.32832492Bfc1D95E": "5.คลิกเพื่อติดตั้ง",
    "download.index.245883C80F181C4A": "ดาวน์โหลด",
    "download.index.Ef3De8Cb2722937A": "เริ่มซื้อขายได้ทุกที่ทุกเวลา",
    "download.index.F4A87Eaeed691638": "ติดตามข่าวสารล่าสุดผ่านแอพของเรา",
    "download.index.Ad3Aba52D0D39D01": "ดาวน์โหลดแพ็คเกจการติดตั้ง",
    "download.safariGuide.61Bd9A8Fcc2Ea788": "เคล็ดลับดีๆ",
    "download.safariGuide.2Cc68Aaadf623477": "กรุณาเยี่ยมชมในซาฟารี",
    "download.safariGuide.C80Fff2A6Ff4E768": "คุณกำลังเยี่ยมชมเว็บไซต์ที่มีการกระจายอำนาจ โปรดเรียกใช้ในแอปพลิเคชันซาฟารี",
    "download.safariGuide.06Da016F3E2F79Bd": "คัดลอกลิงค์",
    "finance.index.B034B367545D5236": "โครงการคุณภาพสูงระดับโลก",
    "finance.index.6Ebfac2C0A9228B0": "ผู้ใช้งานมากกว่า 1.6 ล้านคน มูลค่า 122.4 พันล้านดอลลาร์",
    "finance.index.52Bdcaf19659363D": "การทำฟาร์ม",
    "finance.index.D66924272B031Bf5": "รายได้ต่อปีสูงมาก",
    "finance.index.34789D88Afcefa64": "ดูรายการ",
    "finance.index.E12676B95654D21E": "สินเชื่อเครดิต",
    "finance.index.4C924Cfd89A11Ac7": "ค้นพบโอกาสในการซื้อขายเพิ่มเติม",
    "finance.index.C251D4B594Da2848": "ปริมาณ AI",
    "finance.index.4E53Cf2E5F173Dd3": "การเช่าซื้อเพียงคลิกเดียว ธุรกรรมอัจฉริยะของ AI",
    "finance.records.Cce168301447D1Ba": "กำลังดำเนินการ",
    "finance.records.4587B6Bd7Cfa4454": "แลกแล้ว",
    "finance.records.18685418E3A50147": "การทำเหมืองแร่",
    "finance.records.Df9Fd438F97Cc908": "ท้องฟ้า",
    "finance.records.E23Cb03C5Ad359E5": "ระยะ",
    "finance.records.Bd87Dac6Cba7Eba8": "ปริมาณการซื้อ",
    "finance.records.2D0Fff99265E8B1A": "มีกำไร",
    "finance.records.2D0Fff99265E8B1B": "กำไรเมื่อครบกำหนด",
    "finance.records.024F5F0B851782De": "เวลาขุด：",
    "finance.records.3143A26D3F983896": "เวลาไถ่ถอน：",
    "finance.records.96574Aaf8Db85Ead": "การไถ่ถอนก่อนกำหนด",
    "finance.records.531E1829203181Ac": "คุณแน่ใจหรือไม่ว่าต้องการแลกก่อนเวลา;",
    "finance.records.9205843B8923Dac3": ";",
    "loan.applyCallback.B9258Ec8746A74D8": "ช่องทางการยืม",
    "loan.applyForm.7B8Ed340400A6E2B": "ชื่อ",
    "loan.applyForm.549A44Bae725F4A2": "นามสกุล",
    "loan.applyForm.2A27E61375E7Fea8": "วันเกิด",
    "loan.applyForm.89925B019D537738": "ที่อยู่อีเมล",
    "loan.applyForm.Afaeb32Cb4D62E28": "ที่อยู่บ้าน (รวมถึงหมายเลขยูนิต)",
    "loan.applyForm.E05B5D049B64B040": "เมือง",
    "loan.applyForm.B166E4E8Fe9513Fa": "ชาติ",
    "loan.applyForm.83Aaede109E395F8": "รหัสไปรษณีย์",
    "loan.applyForm.647Ed21332A4968B": "รายได้ต่อเดือนของคุณ",
    "loan.applyForm.Cf0A9B845D34D4B4": "รายได้เพิ่มเติม (ไม่จำเป็น)",
    "loan.applyForm.7048F618Acc6A54C": "ค่าเช่ารายเดือนหรือการชำระเงินจำนอง",
    "loan.applyForm.15C1Bba18Ae18545": "แจ้งให้เราทราบหากคุณมีจำนอง",
    "loan.applyForm.3921E90625A84E36": "หากไม่มีการเลือกการค้ำประกันการจำนอง ความน่าจะเป็นที่จะผ่านการตรวจสอบจะต่ำ",
    "loan.applyForm.262Eec4F8906B0F6": "มีการจำนองหรือไม่?",
    "loan.applyForm.8634Eb21B6910F21": "กรุณาเลือกประเภทการจำนอง",
    "loan.applyForm.A4897B3A331B5E61": "บัตรกำนัลการทำธุรกรรม",
    "loan.applyForm.6623384C683De457": "มาติดต่อกันกันเถอะ",
    "loan.applyForm.A8360Bdba86834Cb": "เราอาจติดต่อคุณที่หมายเลขนี้หากเราต้องการข้อมูลเพิ่มเติมเกี่ยวกับการสมัครสินเชื่อของคุณ",
    "loan.applyForm.C1C373F385A4C7B3": "หมายเลขโทรศัพท์",
    "loan.applyForm.1B9785Badb91191F": "หลังจากกรอกข้อมูลแล้วกรุณารอการประเมินและทบทวนระบบ",
    "loan.applyForm.8755B9C761D4080C": "ฉันได้อ่านและลงนามความยินยอมแบบอิเล็กทรอนิกส์แล้ว",
    "loan.applyForm.3E987B787468148C": "ข้อกำหนดการใช้งานและความยินยอมทางอิเล็กทรอนิกส์",
    "loan.applyForm.Bc54E76B61C50Fb9": "โปรดอ่านและยอมรับข้อตกลง",
    "loan.applyForm.89E158384F634Eb8": "Prev",
    "loan.applyForm.Efa5A4548E2F3510": "ที่อยู่",
    "loan.applyForm.4Cadf1787541B35D": "ใช่",
    "loan.applyForm.Fab408D2F4100447": "เลขที่",
    "loan.applyForm.3Bad7A307480Cc56": "รูปแบบอีเมลไม่ถูกต้อง;",
    "loan.applyForm.306322F49B36855D": "ส่งใบสมัครแล้ว โปรดรอการตรวจสอบการบริการลูกค้า",
    "loan.applyForm.3C6E0E858C995Ff9": "กรุณาอัพโหลดใบสำคัญการทำธุรกรรม",
    "loan.applyForm.2Bf443476B271376": "สามารถอัพโหลดได้สูงสุด 4 ภาพ",
    "loan.applyQuota.Ef1D8E23003B9A6F": "ช่องทางการยืม",
    "loan.applyQuota.Ef1D8E23003B9A6G": "รับวงเงินสินเชื่อ",
    "loan.applyQuota.9E0780F9352C7273": "ยอดคงเหลือในกระเป๋าสตางค์",
    "loan.applyQuota.Cbc1Eb9D639A6105": "จำนวนเงินกู้ทั้งหมดที่มีอยู่",
    "loan.applyQuota.033A05462195B080": "จำนวนเงินที่ยืม",
    "loan.applyQuota.9Aa89B036Ef4821D": "ยอดคงเหลือ",
    "loan.applyQuota.5656Fb52Ef17A557": "รับวงเงินสินเชื่อ",
    "loan.applyQuota.6Ff6702B4C917D40": "ภายใต้การทบทวน",
    "loan.applyQuota.6Ff6702B4C917D41": "ถูกปฏิเสธ",
    "loan.applyQuota.6Ff6702B4C917D42": "ที่ประสบความสำเร็จ",
    "loan.applyQuota.0Bad0E857Ea4A952": "เวลาสมัคร",
    "loan.applyQuota.3E7E56E2De2Cc546": "นำมาใช้",
    "loan.applyQuota.8F1D170D9E54Af5B": "ความคืบหน้าการสมัคร",
    "loan.applyQuota.6167Ca035B93Caf3": "เหตุผล",
    "loan.applyQuota.410C7954F9A3981D": "สมัครใหม่",
    "loan.bottomSheet.61Cd62F861D8F5B2": "กรุณาเลือกสกุลเงิน",
    "loan.index.4C10307B22E885C3": "ค้นพบโอกาสในการซื้อขายเพิ่มเติมและสร้างความมั่งคั่ง",
    "loan.index.Ae8D37Dea2B3717B": "อัตราดอกเบี้ย",
    "loan.index.1Bb54625682E85Db": "การแนะนำกฎ",
    "loan.index.5Bd31Fab681C6E9D": "ดูเพิ่มเติม",
    "loan.index.111F95F404814327": "สกุลเงินกู้ยืม",
    "loan.index.6Bc2723B3Bec106D": "เงินกู้",
    "loan.index.3200106280E6E370": "อัตราดอกเบี้ย",
    "loan.index.049A6Ccb6C81A635": "จำนวนเงินกู้ (ต่ำสุด/สูงสุด)",
    "loan.productDetails.5037Ad86Ab4B7E02": "เงินกู้",
    "loan.productDetails.37181C74559Db182": "คำสั่ง ",
    "loan.productDetails.5802Aaf06A1E4755": "สภาพคล่อง",
    "loan.productDetails.89Aea9Cf9337C40F": "ปริมาณที่สามารถยืมได้",
    "loan.productDetails.9E419Ae2D06F3Ad9": "ปริมาณที่จะชำระคืน",
    "loan.productDetails.C65F329Ef14C4A3D": "จำนวนเหรียญที่ยืม",
    "loan.productDetails.3A74667815Adc8Bf": "ขีดสุด",
    "loan.productDetails.Ab851D8351573227": "ท้องฟ้า",
    "loan.productDetails.Ddf82D8A2C8F46A0": "รอบการชำระคืน",
    "loan.productDetails.C105E5562005Aeb1": "ท้องฟ้า",
    "loan.productDetails.3F346Be2137F0756": "จำนวนเงินกู้ (ต่ำสุด/สูงสุด)",
    "loan.productDetails.2707F78Df864E194": "ความสนใจ",
    "loan.productDetails.B9Dc9B81E726Bdf1": "กรุณาชำระให้ตรงเวลา หากเกินกำหนด จะมีการเรียกเก็บเงินรายวันเพิ่มเติม (เงินต้น + ดอกเบี้ย)",
    "loan.productDetails.B9Dc9B81E726Bdf2": "%สำหรับค่าธรรมเนียมล่าช้า",
    "loan.productDetails.4D94Faa033Be7356": "ฉันได้ตกลง",
    "loan.productDetails.62429A957A22780A": "ข้อตกลงการบริการให้ยืมเหรียญ",
    "loan.productDetails.Bc54E76B61C50Fb9": "โปรดอ่านและยอมรับข้อตกลง",
    "loan.productDetails.Ec8Ba071C53A67Cb": "ยืมเลย",
    "loan.productDetails.59246A0Bf081D398": "น้อยที่สุด",
    "loan.productDetails.Ec3F1172B71Cd36C": "จำนวนเงินขั้นต่ำ",
    "loan.productDetails.7Ccc4Cf1D81930B3": "จำนวนมากที่สุด",
    "loan.productDetails.071488598990Aa68": "โปรดอ่านและยอมรับข้อตกลง;",
    "loan.productDetails.579Dd216D3339119": "สินเชื่อสำเร็จ;",
    "loan.records.4951B36Fd0D2A831": "ประวัติสินเชื่อและเครดิต",
    "loan.records.Bb0Aaa30514B7Cba": "บันทึกปัจจุบัน",
    "loan.records.0F8B0A7D80769051": "ประวัติการชำระหนี้",
    "loan.records.D4B42E43D88De6F1": "บันทึกประวัติศาสตร์",
    "loan.records.Cb1847D6281897E6": "จำนวนเงินกู้",
    "loan.records.C7Bfcacfc2Adea58": "จำนวนเงินชำระคืน",
    "loan.records.8B369164D5Fea340": "เวลายืม：",
    "loan.records.Ab2402Ad3Ffd35E7": "จ่ายเงินกู้เร็ว",
    "loan.records.B7A0Ca0C195D0Cd1": "เวลาวางจำหน่าย：",
    "loan.records.42014Bdcfd9C411B": "ระยะเวลาการชำระคืน：",
    "loan.records.A0Acfaee54F06458": "สมบูรณ์",
    "loan.records.67A39834582Ad99A": "ไม่มีข้อมูล",
    "loan.records.6A687Ff5B8F1598F": "คุณแน่ใจหรือไม่ว่าต้องการชำระคืนล่วงหน้า?",
    "loan.records.7C20D7008D0Eae86": "ชำระคืนสำเร็จ",
    "mining.bottomSheet.Ba91637D32Ccba04": "การทำฟาร์ม",
    "mining.bottomSheet.7De3D636A165E008": "อัตราผลตอบแทน",
    "mining.bottomSheet.F3003345B189D683": "ช่วงการขุด",
    "mining.bottomSheet.3E4C0A8C533F5848": "ประเภทเหรียญ",
    "mining.bottomSheet.Adcba368993Ae65E": "จำนวนการสมัครสมาชิก (ขั้นต่ำ/สูงสุด)",
    "mining.bottomSheet.94743B24E4Ed4166": "ไม่ จำกัด",
    "mining.bottomSheet.286944Fedd211257": "เงินทุนที่มีอยู่",
    "mining.bottomSheet.7B5766Dc65Abc0C3": "รายได้โดยประมาณ:",
    "mining.bottomSheet.9Bbaf80Fdb6Fd148": "ของฉันตอนนี้",
    "mining.bottomSheet.Bb1493C567C114Dd": "เคล็ดลับดีๆ：",
    "mining.bottomSheet.D2315E87E34A3Bd3": "ค่าธรรมเนียมการไถ่ถอนก่อนกำหนด",
    "mining.index.8B2Bba1422Eed6F0": "สร้างความมั่งคั่งนับหมื่นล้าน รายได้สุทธิ 100%",
    "mining.index.42997E300086Ee89": "ผลตอบแทนสูงสุด",
    "mining.index.510F74F42052Ecce": "ผลิตภัณฑ์จากการขุด",
    "mining.index.B853F96626106912": "ไปขุด",
    "mining.productList.37181C74559Db182": "คำสั่ง",
    "mining.productList.Aac5B810004C46C8": "ปกติ",
    "mining.productList.D2Fb4F78C387D888": "คุณขุดสำเร็จแล้ว",
    "quantify.bottomSheet.9Ea4A318F690Bc95": "ยืนยันรายการ",
    "quantify.bottomSheet.6915303B698303B1": "หุ่นยนต์",
    "quantify.bottomSheet.68045296Dd0F8Ad6": "จำนวนค่าเช่า",
    "quantify.bottomSheet.Fbd931286Be387Aa": "วงจร",
    "quantify.bottomSheet.9Ad84Db481807844": "อย่างไม่มีกำหนด",
    "quantify.bottomSheet.994D7226Ca083Ea5": "อัตราผลตอบแทนรายวัน",
    "quantify.bottomSheet.0Bf82Ee4Bfe063B7": "วันที่มีค่า",
    "quantify.bottomSheet.88008603Ba7Bde64": "การซื้อสำเร็จ",
    "quantify.bottomSheet.Ff50B3091Bbd09Ab": "รับส่วนแบ่งรายได้ตั้งแต่บัดนี้เป็นต้นไป！",
    "quantify.bottomSheet.C778A674C4A054F9": "ตรวจสอบคำสั่งซื้อ",
    "quantify.bottomSheet.685Dad322B7029B0": "การทำธุรกรรมคืน",
    "quantify.buyForm.Acf8560A04334E95": "ราคาซื้อ",
    "quantify.buyForm.Cf9Cfbc2C554944F": "ภาพรวม",
    "quantify.buyForm.8788Df2B625E97B5": "หุ่นยนต์",
    "quantify.buyForm.50Ca63B45E881D50": "ระยะเวลาการจ่ายเงินปันผล",
    "quantify.buyForm.Fcda03Adbc5Fca97": "ทุกวัน",
    "quantify.buyForm.Afb89504Fc399189": "กรุณากรอกจำนวนการซื้อ",
    "quantify.buyForm.1435Afdfb4Ec0596": "ปริมาณการซื้อขั้นต่ำ",
    "quantify.buyForm.1B97F1730Bacd839": "ปริมาณการซื้อสูงสุด",
    "quantify.index.32F56C9B7D0E250A": "ระยะเวลา: ไม่มีกำหนด",
    "quantify.index.E34F028D00904630": "ราคา",
    "quantify.index.E34F028D00904631": ",อัตราผลตอบแทนรายวัน",
    "quantify.productDetail.6Bbe178Df539A5Ca": "จำนวนเงินที่เอสโครว์",
    "quantify.productDetail.53635B53Bca31Dfa": "รายได้โดยประมาณต่อวัน",
    "quantify.productDetail.F9E46449A6269E09": "รายได้สะสม",
    "quantify.productDetail.98Fc46B1B8C993B2": "สั่งซื้อโฮสติ้ง",
    "quantify.productDetail.93624Bb045830966": "เช่าเลย",
    "quantify.records.0C16A18C32B9Cf4A": "บันทึกการสั่งซื้อ",
    "quantify.records.B191F5614B0E2312": "ประวัติการซื้อ",
    "quantify.records.6A06033B86A73F7C": "บันทึกการไถ่ถอน",
    "quantify.records.45E0F7E71611618E": "รายได้สะสม",
    "quantify.records.45E0F7E71611618F": "กำไรเมื่อครบกำหนด",
    "quantify.records.Aae1201E38C4Baaa": "วิ่ง",
    "flash.index.C41Fd4F2Fdfa594B": "บริโภค",
    "flash.index.1Ac59Fa2218E3B00": "มีอยู่:",
    "flash.index.Bf7233A660821549": "รับ",
    "flash.index.548E775Dd67C7472": "ยืนยันการแลกเปลี่ยน",
    "flash.index.066A2449Bd616F03": "กรุณากรอกจำนวนการไถ่ถอน",
    "flash.index.Fca26Fcf9C06563F": "แลกแฟลชสำเร็จ",
    "message.index.40031524233F4564": "ศูนย์ข้อความ",
    "message.index.8E5586210Fd44D69": "การแจ้งเตือนตำแหน่งถาวร",
    "message.index.Bcd3F470E88C197D": "ยังไม่มีการแจ้งเตือน",
    "message.index.23A557Fbce545879": "ประกาศการชำระบัญชีถาวร",
    "message.index.B5E19B36B5125550": "การแจ้งเตือนการถอน",
    "message.index.716A981465138334": "เตือนการเติมเงิน",
    "message.index.884474Ebff2977Ba": "ข้อมูลระบบ",
    "message.index.08Cc7D24752Ec42C": "บริการออนไลน์",
    "message.index.1D820A6A19Ab025D": "บริการด้วยตนเองออนไลน์ 7 X 24 ชั่วโมง",
    "more.index.29881E0B5Df58Bf7": "คุณสมบัติเพิ่มเติม",
    "more.index.3558F69B0260Be61": "ฟังก์ชั่นการซื้อขาย",
    "more.index.7243Fe610Ed98Cec": "บัญชีจริง",
    "more.index.7243Fe610Ed98Ced": "บัญชีทดลอง",
    "more.index.693C7B35Bdf3E3A3": "การเงิน",
    "more.index.F855997Fac114554": "ศูนย์ช่วยเหลือ",
    "more.index.Ae9A1252278Da742": "ช่วย",
    "more.index.Ace012504Bc529E0": "ข้อมูล",
    "more.index.05682Dbef5Eeb0A8": "บริการลูกค้า",
    "more.index.C7Af227A5D5C7Bb9": "คุณได้เปลี่ยนไปใช้บัญชีจริงแล้ว",
    "more.index.D818A65592694786": "คุณได้เปลี่ยนไปใช้บัญชีทดลองแล้ว",
    "notice.details.B360807Dbe727E6E": "เกี่ยวกับเรา",
    "notice.details.92F2552F695E70E3": "เกี่ยวกับเรา",
    "notice.details.7Aaceaf69B67F3D1": "การแนะนำกฎ",
    "notice.index.6128438Be34Bcb9F": "การแจ้งให้ทราบตลอดไป",
    "notice.index.71627F5Eb7128261": "การแจ้งการถอนเงิน",
    "notice.index.2Dce570Fda841705": "การแจ้งเตือนการเติมเงิน",
    "notice.index.228A7C9C6448A9B1": "การแจ้งเตือนของระบบ",
    "setting.dialog.8B4F5B74660Deabe": "การกำหนดค่าสี",
    "setting.dialog.Bfc7D25486Ebc1A9": "สีเขียวขึ้นและสีแดงตก",
    "setting.dialog.796Ea0E1A82C320B": "ขึ้นสีแดงและตกสีเขียว",
    "setting.index.8Ddc5864E1739466": "การตั้งค่า",
    "setting.index.F5205801D57D6727": "ภาษา",
    "setting.index.2E2C12Dd0Cc1B63B": "สกุลเงินใบเสนอราคา",
    "setting.index.322D8496Aec3D918": "หมายเลขเวอร์ชัน",
    "setting.index.Aa7E6C204C751Cfa": "ออกจากระบบ",
    "share.index.75Bc38Bbf7D2E766": "เชิญเพื่อน ๆ",
    "share.index.45575Eb5D42213E6": "รหัสเชิญของฉัน",
    "share.index.29F67F0644A78Bf3": "สำเนา",
    "share.index.19Cc65Bb6Bb98Fe7": "ลิงค์คำเชิญของฉัน",
    "share.index.5372712F162Fb78B": "จำนวนผู้ใต้บังคับบัญชาโดยตรง",
    "share.index.C88D6B95E3Ab7D6F": "จำนวนผู้ใต้บังคับบัญชาทั้งหมด",
    "share.index.Bb5Fa5471Aeecc62": "ส่วนลดค่าคอมมิชชั่นสำหรับผู้ใต้บังคับบัญชาโดยตรง",
    "share.index.426B6Bac9A5F3D4F": "ส่วนลดทั้งหมด",
    "share.index.197E4A428F0401C9": "ดูบันทึกส่วนลด",
    "share.records.88A6B2E2B74B13C4": "บันทึกค่าคอมมิชชั่น",
    "share.records.B671A35Ffdc93B89": "ส่วนลด",
    "transfer.index.B17617A869C03Ca5": "กระเป๋าสตางค์",
    "transfer.index.E4116Dcc6F6C7270": "โอนสำเร็จ",
    "transfer.index.48Fb603C6638C7F6": "กรุณาตั้งรหัสผ่านกองทุน",
    "transfer.records.Eb0E39Eb5911D418": "รับ",
    "transfer.records.977554Be0Aa65052": "เวลาแลกเปลี่ยนแฟลช：",
    "transfer.records.9Aa33884Aa400B7C": "เวลาโอน：",
    "form1.forget.76636Db8Fae5B124": "กล่องจดหมายของคุณ",
    "form1.forget.35354B9Cca1Bb0E6": "รหัสยืนยันอีเมล",
    "form1.forget.604A0B11E916F387": "รหัสผ่าน",
    "form1.forget.9Cb1C9C51E7503D6": "ยืนยันรหัสผ่าน",
    "form1.forget.3A4F7E04B008453C": "หมายเลขโทรศัพท์ของคุณ",
    "form1.forget.Cf11Dce5B4713B5A": "รหัสยืนยันโทรศัพท์มือถือ",
    "form1.forget.3012Edba57D4F297": "กรุณากรอกอีเมล์ของคุณ",
    "form1.forget.F1Ee1D97E869E447": "กรุณากรอกรหัสยืนยัน",
    "form1.forget.3A5C4C9Ae68Fa0F6": "กรุณาใส่รหัสผ่านของคุณ",
    "form1.forget.C6Cb174Da411D5F7": "กรุณากรอกโทรศัพท์มือถือของคุณ",
    "form1.forget.947B3B21Ee45E582": "ส่ง",
    "form1.forget.3E0580F1E8630Df6": "รหัสผ่านสองตัวไม่สอดคล้องกัน",
    "form1.forget.C5A61836B8Cc74C6": "เปลี่ยนเส้นทางรหัสผ่านสำเร็จแล้ว...",
    "form1.forget.B96D072Bc8962565": "ส่งซ้ำ",
    "form1.login.2B72C27Ff828Cfc4": "รหัสผ่านของคุณ",
    "form1.login.D7C6B872Af9Cb17F": "จำรหัสผ่านของฉัน",
    "form1.login.0Fff44C827A4F3B6": "เข้าสู่ระบบ",
    "form1.login.1B7F2C1Ede3990Cc": "อย่ามีบัญชีหรือยัง? สมัครตอนนี้เลย",
    "form1.login.F657F7Be1Cc33Bd2": "ลืมรหัสผ่าน",
    "form1.login.2074A1Eec4B088B0": "เข้าสู่ระบบกระเป๋าเงิน",
    "form1.login.1B8938Fbcc3C9B56": "เข้าสู่ระบบสำเร็จและเปลี่ยนเส้นทาง...",
    "form1.login.07162A7Bb9310555": "กรุณาติดตั้งกระเป๋าสตางค์ ERC20",
    "form1.login.766969966Ae151Dc": "กรุณาติดตั้งกระเป๋าเงิน TRC20",
    "form1.login.B88171E1Ad4C50Bf": "คุณปฏิเสธที่จะเปลี่ยนเครือข่าย",
    "form1.register.Aaef0710Cb4Db554": "ป้อนรหัสผ่านอีกครั้ง",
    "form1.register.54Dfea0415C708Ff": "รหัสการเชิญ",
    "form1.register.6839940Dac08C794": "ลงทะเบียน",
    "form1.register.9901A3B5550Aa58E": "มีบัญชีอยู่แล้ว? เข้าสู่ระบบ",
    "form1.register.2548Ca53785252Ea": "กรุณากรอกรหัสเชิญของคุณ",
    "form1.register.Dd71Fd65900Dd03E": "โปรดอ่านข้อตกลงบริการการลงทะเบียนและยอมรับ,",
    "form1.register.7975613909490B77": "การลงทะเบียนสำเร็จและเปลี่ยนเส้นทาง...",
    "form1.walletDialog.105829Acfc0Bd6Aa": "เลือกกระเป๋าสตางค์",
    "userc.certification.2Af9511640153D2E": "การรับรองจูเนียร์",
    "userc.certification.177B191D8E0Fa84D": "",
    "userc.certification.601218D4D572E98A": "ตรวจสอบแล้ว",
    "userc.certification.6E37C51Ba9012Fc8": "ไม่ผ่าน",
    "userc.certification.1B9B563E05C96474": "การรับรองขั้นสูง",
    "userc.certification.1418B83803Ab56B4": "กรุณากรอกใบรับรองหลักก่อน",
    "userc.creditScore.0B149112601Acc4D": "เครดิต",
    "userc.creditScore.88Ac7F84E106C5F6": "คะแนนเครดิตทั้งหมด",
    "userc.creditScore.3E1D6E0E7F1E6155": "การประเมินระบบ",
    "userc.index.62Eac58D04Bbca0F": "ศูนย์ส่วนบุคคล",
    "userc.index.F4Cac53F93Cb2Aff": "การซื้อขายจำลอง",
    "userc.index.42F409Fdf3559773": "ศูนย์รักษาความปลอดภัย",
    "userc.index.1B8E211009807Db8": "การรับรองความถูกต้อง",
    "userc.index.Bdfcf21Eb8F2Eb70": "บันทึกการเปลี่ยนแปลงบัญชี",
    "userc.index.6C18D67F6D19586B": "บทนำแพลตฟอร์ม",
    "userc.index.807A814Ed58A93Bc": "ล้างแคช",
    "userc.index.E43Daad59759611C": "ไม่ได้รับการรับรอง",
    "userc.secureCenter.F5C70F0Db2F1Ba76": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
    "userc.secureCenter.1F37Ba427Debf24A": "การผูกบัญชี",
    "userc.secureCenter.F9A5Ffa750664004": "ผูก Google Authenticator",
    "userb.certificationForm.7685Af7D30043Cd6": "การรับรองจูเนียร์",
    "userb.certificationForm.7685Af7D30043Cd7": "การรับรองขั้นสูง",
    "userb.certificationForm.70E37C35Abc3F462": "ประเทศ",
    "userb.certificationForm.F92C25A68E4D08C5": "เมือง",
    "userb.certificationForm.0Ccc6387B38E0318": "ชื่อของคุณ",
    "userb.certificationForm.94C67Bba370Fdd46": "ใบอนุญาตเลขที่",
    "userb.certificationForm.B2D4C7Fffe79258E": "จดหมาย",
    "userb.certificationForm.57554268761Fb47A": "อัปโหลดด้านหน้าบัตรประจำตัวของคุณ",
    "userb.certificationForm.D79E90201F5319Bd": "อัปโหลดด้านหลังบัตรประจำตัวของคุณ",
    "userb.certificationForm.9C6Bad08Af29E20E": "อัพโหลดรูปภาพบัตรประจำตัวประชาชนของคุณ",
    "userb.certificationForm.F96B62Dfa31Cde45": "ยืนยันการส่ง",
    "userb.certificationForm.2125D78Ea8C6D287": "ข้อกำหนดในการอัปโหลด",
    "userb.certificationForm.0D64864D3076A824": "ดูตัวอย่าง",
    "userb.certificationForm.35287Deb72281E87": "1.ต้องสามารถอ่านข้อมูลบัตรประจำตัวได้ชัดเจน。",
    "userb.certificationForm.3007F2E01Efc7B57": "2.เนื้อหาของภาพถ่ายเป็นความจริงและถูกต้อง และไม่อนุญาตให้มีการแก้ไขใดๆ",
    "userb.certificationForm.25A90660554319F9": "3.ต้องมองเห็นหมายเลขประจำตัวและชื่อได้ชัดเจน รองรับ JPG / JPEG / PNG",
    "userb.certificationForm.5A9Aefbc03C778F7": "กรุณาเข้า",
    "userb.certificationForm.3B7A1D8Ce27C937E": "ส่งสำเร็จแล้ว โปรดรอการตรวจสอบ",
    "userb.certificationForm.744Bd07D8Abd2513": "กรุณาอัปโหลดด้านหน้าของบัตรประจำตัวของคุณ",
    "userb.certificationForm.6De1C319130F7Fef": "กรุณาอัพโหลดด้านหลังบัตรประจำตัวของคุณ",
    "userb.certificationForm.79F8E8B172E30C8A": "กรุณาอัพโหลดภาพถ่ายบัตรประจำตัวประชาชนของคุณ",
    "userb.certificationForm.46412E16D28A4753": "การอัปโหลดรูปภาพล้มเหลว",
    "userb.changeDialog.676B0Adca1F8Eea4": "เปลี่ยนรหัสผ่าน",
    "userb.modifyInfoDialog.F41De3A1Fa69135A": "หมายเลขโทรศัพท์",
    "userb.modifyInfoDialog.3C3Aac9664A35Ef8": "สวิตช์ตรวจสอบ",
    "userb.modifyInfoDialog.62149E566814154C": "เลือกเครื่องมือตรวจสอบ",
    "userb.modifyInfoDialog.8E69468E2435Fc89": "เปิดแอปการตรวจสอบสิทธิ์แล้วแตะ +",
    "userb.modifyInfoDialog.7625E5Bdcbfe9963": "เลือก 'สแกนรหัส QR' หรือ 'ป้อนรหัส'",
    "userb.modifyInfoDialog.93F094E2B4369472": "สแกนรหัส QR หรือป้อนรหัส",
    "userb.modifyInfoDialog.43E4F1532529Ee1E": "ปิด/เปิด",
    "userb.modifyInfoDialog.Bae6358Dfd95025A": "รหัสผ่านกองทุนเก่า",
    "userb.modifyInfoDialog.E1133Cd4B1C2Abb7": "รหัสผ่านกองทุนใหม่",
    "userb.modifyInfoDialog.C1Ce0403A2523Ee0": "ยืนยันรหัสผ่านกองทุนใหม่",
    "userb.modifyInfoDialog.8Dd453Adc2Cd78Fb": "ยืนยันรหัสผ่านกองทุน",
    "userb.modifyInfoDialog.Bb0D9854C79325Bb": "กรุณากรอกรหัสผ่านกองทุนเดิมของคุณ",
    "userb.modifyInfoDialog.E66Cb29B00Bc54D1": "กรุณากรอกรหัสผ่านกองทุนใหม่ของคุณ",
    "userb.modifyInfoDialog.E8Ae2Ec5Df401255": "กรุณากรอกรหัสผ่านกองทุนของคุณ",
    "userb.modifyInfoDialog.258A534498Fe984F": "กรุณายืนยันรหัสผ่านกองทุนของคุณ",
    "userb.modifyInfoDialog.768Ec43Faa193F08": "การผูกบัญชี",
    "userb.modifyInfoDialog.D34746090C25E5Db": "รหัสผ่านกองทุน",
    "userb.modifyInfoDialog.E4F27D8916E5E536": "ยืนยัน",
    "userb.modifyInfoDialog.Bef7160Ce53773E0": "เครื่องมือตรวจสอบถูกปิดแล้ว",
    "userb.modifyInfoDialog.Be8Bf47Ba6820De1": "เปิดการยืนยันของ Google สำเร็จแล้ว",
    "userb.modifyInfoDialog.24Dba26593F43C74": "แก้ไขรหัสผ่านกองทุนสำเร็จแล้ว",
    "userb.modifyInfoDialog.5C369D42Dc7Dbe76": "ตั้งรหัสผ่านกองทุนสำเร็จ",
    "userb.modifyInfoDialog.667Bf8D0B6C36D4C": "การผูกสำเร็จ",
    "userb.modifyInfoDialog.1C5E05Efee2B0B9F": "รหัสยืนยันผิดพลาด",
    "userb.veBottomSheet.Eecc4683C725F6F2": "ตัวอย่างการอัพโหลดใบรับรอง",
    "userb.veBottomSheet.6F38A0D5858633Ee": "พื้นหลังสีเข้มสะอาดตา",
    "userb.veBottomSheet.Af162Dbdfc4Fcae9": "แสงสว่างเพียงพอ",
    "userb.veBottomSheet.0F7Baf0Cee3C8141": "การจัดตำแหน่งเฟรมเสริม",
    "userb.veBottomSheet.Ac9E471Eead0Cf11": "ภาพถ่ายมีความชัดเจน",
    "userb.veBottomSheet.50B741382E71F103": "สาเหตุที่เป็นไปได้สำหรับความล้มเหลว",
    "userb.veBottomSheet.Aa56C68E8Fd4Cfb4": "ฝาครอบป้องกันบัตรประจำตัวยังไม่ได้ถูกถอดออก",
    "userb.veBottomSheet.5D2F429C75D4C7F2": "พื้นหลังได้รับผลกระทบจากความยุ่งเหยิง",
    "userb.veBottomSheet.90F42D3Cb7769Dbc": "บัตรประจำตัวประชาชนเป็นแบบสะท้อนแสง",
    "userb.veBottomSheet.1Ee78Cee782D81B4": "แสงมืดเกินไป/ถูกบดบังด้วยเงาโทรศัพท์มือถือ",
    "userb.veBottomSheet.1A75D2Fc2614592B": "ถือบัตรประจำตัวประชาชน",
    "home.home.C3525Eb110Db58Aa": "มากกว่า",
    "home.home.29761532Fc8Ebecc": "ซื้อขาย",
    "home.home.F15Ea99Bfa6E1848": "รับรองความปลอดภัย ซื้อด้วยความมั่นใจ",
    "home.home.46E1Ab39Bae7182A": "เร็ว",
    "home.home.Fde2Eb7F6F3Dd800": "การทำธุรกรรมที่รวดเร็วและการดำเนินการที่ง่ายดาย",
    "home.home.Ea4756Bc1642E0F1": "ชื่อ",
    "home.home.B6B1127Ede1C97B4": "ราคาล่าสุด",
    "home.home.3587Ad870Eb0Ab86": "24H เพิ่มขึ้นและลดลง",
    "home.home.Cb1A4E14Ec2Cd2B5": "ค้นพบ",
    "home.home.0F1B1Ac0E96A40D1": "บล็อกเชน",
    "home.home.8Eaefb1107A0E210": "ฟอเร็กซ์",
    "home.home.Ad65263D034Ea051": "โลหะมีค่า",
    "home.home.5Fc1474Dbf74Ac1A": "ผลผลิต",
    "home.home.135318F4664F7773": "พลังงาน",
    "kline.kLine.C96Ff250Cf6B8B84": "ราคาสูงสุด 24 ชม",
    "kline.kLine.6E8Be64F19D74565": "ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
    "kline.kLine.08A4Bfbe26A0F262": "ราคาต่ำสุด 24 ชม",
    "kline.kLine.8701Deb075066331": "ปริมาณการซื้อขายใน 24 ชม. (USDT)",
    "kline.kLine.Ea3C3052136C84Cd": "1 คะแนน",
    "kline.kLine.B49Cca240E013124": "5 คะแนน",
    "kline.kLine.F27A90Be97Ba3D6C": "15 คะแนน",
    "kline.kLine.Ff3E62395B694384": "30 คะแนน",
    "kline.kLine.C1993F9C6Db1A674": "1 ชั่วโมง",
    "kline.kLine.Fd2Cbbae405E284C": "1 วัน",
    "kline.kLine.C9Cd71904395042C": "มกราคม",
    "kline.kLine.7D8127Ec18C7B8C7": "ซื้อ",
    "kline.kLine.E3D3Ffdb9B3E5636": "จำนวน (ชิ้น)",
    "kline.kLine.6834Fec1838D8029": "ราคา (USDT)",
    "kline.kLine.16C52Aae474Bc9Cd": "ขายคำสั่ง",
    "kline.kLine.B9Bea1A9A88D1419": "เปิดยาวๆ",
    "kline.kLine.D36Cfa96Ee2B343B": "เปิดสั้น",
    "other.languageRateSelect.6897784800834C1B": "การตั้งค่าภาษา",
    "other.languageRateSelect.6897784800834C1C": "โปรดเลือกสกุลเงินของราคา",
    "other.navigationBar.F6E62F9642018Cbb": "หน้าแรก",
    "other.navigationBar.0Ec227161A47B49D": "คำคม",
    "other.navigationBar.29761532Fc8Ebecc": "ซื้อขาย",
    "other.navigationBar.693C7B35Bdf3E3A3": "การเงิน",
    "other.navigationBar.9734C54620Eb09Af": "สินทรัพย์",

    "home.index.25Aa4Fc745150030": "ราชาแห่ง cryptocurrencies",
    "home.index.2D6Ecf8Faaa8B124": "เร็วขึ้น ดีขึ้น แข็งแกร่งขึ้น",
    "home.index.1Db26267D1041223": "ซื้อขาย cryptocurrencies มากกว่า 1,700 รายการได้อย่างง่ายดาย",
    "home.index.F8E18C90C3E35618": "สมัครตอนนี้เลย",
    "home.index.29761532Fc8Ebecc": "ซื้อขาย",
    "home.index.D8A95E4506487452": "สัญญายอดนิยม",
    "home.index.5Bd31Fab681C6E9D": "ดูเพิ่มเติม",
    "home.index.010Ae07A09Caf221": "คู่การซื้อขาย",
    "home.index.F4D875118E6D6Dbb": "ราคาซื้อขายล่าสุด",
    "home.index.3Dfdfb3D6599100E": "ราคาเพิ่มขึ้นและลดลงตลอด 24 ชั่วโมง",
    "home.index.28Fb39Bd41E54242": "แนวโน้ม",
    "home.index.B47A3911Bacd94C6": "รายการกำไร",
    "home.index.712910D574F43D95": "รายได้ที่มั่นคง",
    "home.index.5507Fd830D7Bf51F": "กลยุทธ์ชั้นยอด คัดลอกง่าย",
    "home.index.7De3D636A165E008": "อัตราผลตอบแทน",
    "home.index.B853F96626106912": "ไปขุด",
    "home.index.213B5C96Be7Cd1F8": "วัน อัตราดอกเบี้ยรายปี",
    "home.index.213B5C96Be7Cd1F9": "ซื้อได้สูงสุด",
    "home.index.Dc710Cffe6313Bb5": "ตรวจสอบรายละเอียด",
    "home.index.B92Ffc837Ecaa1Dd": "ข่าว",
    "home.index.6C18D67F6D19586B": "บทนำแพลตฟอร์ม",
    "home.index.6342E3C33Cb48Cd5": "สกุลเงินดิจิทัลเป็นสื่อกลางในการแลกเปลี่ยนที่ใช้หลักการเข้ารหัสเพื่อความปลอดภัยของธุรกรรม สกุลเงินดิจิทัลไม่มีรูปแบบทางกายภาพ ซึ่งต่างจากสกุลเงินทั่วไป เช่น ดอลลาร์สหรัฐ สกุลเงินดิจิทัลยอดนิยม เช่น Bitcoin (BTC), Ethereum (ETH) และ Polkadot (DOT) ใช้บล็อกเชนเป็นเทคโนโลยีพื้นฐานเพื่อทำหน้าที่เป็นบัญชีแยกประเภทดิจิทัลแบบกระจายอำนาจ ธุรกรรมสกุลเงินดิจิทัลทั้งหมดจะถูกบันทึกไว้ในบล็อคเชน และไม่สามารถเปลี่ยนแปลงได้เมื่อได้รับการยืนยันและตรวจสอบแล้ว ต่างจากสกุลเงินแบบดั้งเดิมที่ธนาคารดูแลบัญชีแยกประเภทแบบรวมศูนย์ ธุรกรรมสกุลเงินดิจิทัลเกิดขึ้นบนบล็อกเชนสาธารณะที่ใครๆ ก็สามารถเข้าถึงได้",
    "home.index.198Efc4254683Eef": "นอกจากนี้ ตามกลไกฉันทามติ ทุกคนสามารถตรวจสอบธุรกรรมสกุลเงินดิจิทัลและเพิ่มลงในบล็อกเชนได้ ซึ่งทำให้เกิดการกระจายอำนาจ เนื่องจากบริษัทชั้นนำระดับโลกเช่น Samsung, BlackRock, Morgan Stanley และ Alphabet ได้ลงทุน ผู้คนเชื่อว่าเทคโนโลยีบล็อกเชนจะเปลี่ยนระบบการเงินทั่วโลกไปโดยสิ้นเชิง สกุลเงินดิจิทัลเปิดประตูสู่โลกแห่งการเงินแบบกระจายอำนาจสำหรับคุณ ช่วยให้คุณสำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุดที่มาจากเทคโนโลยีล้ำสมัย",
    "home.index.E710339D9576292E": "ข้อได้เปรียบของเรา",
    "home.index.F9Ce8B2C63885B26": "ปลอดภัยและมั่นคง",
    "home.index.C4D0A2C9Ff0305Ce": "ทีมงานด้านเทคนิคชั้นนำ การป้องกันความปลอดภัยที่ครอบคลุม การวิจัยอิสระและการพัฒนากลไกการสังเคราะห์ธุรกรรมความเร็วสูง ยังคงสามารถทำงานได้อย่างเสถียรและเชื่อถือได้ภายใต้การทำธุรกรรมจำนวนมากพร้อมกัน",
    "home.index.2E8708Ee3F11Cc1A": "เป็นมืออาชีพและเชื่อถือได้",
    "home.index.Bb12Cbcf89C56C5C": "ทีมงานมืออาชีพที่มีประสบการณ์หลายปีในด้านบล็อกเชนและการเงิน มีใบอนุญาตการซื้อขายสินทรัพย์ดิจิทัลที่เป็นไปตามข้อกำหนด และมีการรับประกันการสำรอง 100%",
    "home.index.Aa4723Bfbf6808F4": "เสิร์ฟด้วยใจ",
    "home.index.1Bf0204B7D3Ee230": "เผชิญกับตลาดโลก รองรับหลายภาษา ทำงานตลอด 24 ชั่วโมงทุกวัน การสนับสนุนชุมชนที่แข็งแกร่ง และการบริการลูกค้าอย่างมืออาชีพ",
    "home.index.2E7Dfd53D26F7224": "ประสิทธิภาพสูง",
    "home.index.1C65453103B5Fcc3": "ธุรกรรม 300,000 รายการต่อวินาที และเวลาตอบสนองคำสั่งซื้อน้อยกว่า 1 มิลลิวินาที",
    "home.index.85Ac49Ece9Dcc80B": "ซื้อขายได้ทุกที่ทุกเวลา!",
    "home.index.2799E18842E4Ebe9": "เปิดตำแหน่งทันที รองรับทั้งแอป OKEX และหน้าเว็บ!",
    "home.index.2Bf52Ce75E29Fc88": "สแกนโค้ดเพื่อดาวน์โหลดทันที",
    "home.index.88D1422B33571066": "หุ่นยนต์",
    "home.index.04Ee893775563F21": "เวอร์ชั่นแอปเปิ้ล",
    "home.index.04Ee893775563F22": "บริการผลิตภัณฑ์",
    "home.index.04Ee893775563F23": "การจัดการทางการเงิน",
    "home.index.04Ee893775563F24": "กลับ",
    "home.index.04Ee893775563F26": "IOS & ANDROID",
}
